
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("b5pIV", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");


var $aPdNQ = parcelRequire("aPdNQ");

function $25b0e61f73c02011$export$280798ff6ccf43f0(adf, schema) {
    let isTransformed = false;
    const { panel: panel, panel_c1: panel_c1 } = schema.nodes;
    if (!panel || !panel_c1) return {
        transformedAdf: adf,
        isTransformed: false
    };
    const transformedAdf = (0, $jTt8P.traverse)(adf, {
        panel: (node)=>{
            if (!node.content) return;
            const fragment = (0, $aPdNQ.Fragment).fromJSON(schema, node.content);
            if (!panel.validContent(fragment) && panel_c1.validContent(fragment)) {
                isTransformed = true;
                return {
                    ...node,
                    type: 'panel_c1'
                };
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
}



var $4yKbg = parcelRequire("4yKbg");

var $5Qi6J = parcelRequire("5Qi6J");





var $bjg0G = parcelRequire("bjg0G");


var $6mKj3 = parcelRequire("6mKj3");


var $hPTbh = parcelRequire("hPTbh");


var $aUBmi = parcelRequire("aUBmi");

const $ce56c1219cf89111$var$getInsertPositionAfterSelection = (selection)=>{
    if (!selection) return undefined;
    const blockRange = selection.$from.blockRange(selection.$to);
    return blockRange?.end ?? selection.to;
};
const $ce56c1219cf89111$var$getPreservedSelection = (editorAPI, shouldUsePreservedSelection)=>{
    if (!shouldUsePreservedSelection) return undefined;
    return editorAPI.blockControls?.sharedState?.currentState?.()?.preservedSelection;
};
const $ce56c1219cf89111$export$7b169887c898052a = (editorAPI)=>{
    return (snippet, insertBelowPreservedSelection = false)=>{
        if (!editorAPI?.core?.actions?.execute) // Editor not ready (timing) — benign, not a real failure.
        return {
            status: 'not-ready'
        };
        const body = snippet.body;
        if (!body) // Snippet has no body to insert — benign data issue, not a real failure.
        // Terminal: unlike not-ready, this will not change on retry, so callers
        // should give up and clean up rather than retry indefinitely.
        return {
            status: 'empty-body'
        };
        const editorAPIWithPreservedSelection = editorAPI;
        const preservedSelection = $ce56c1219cf89111$var$getPreservedSelection(editorAPIWithPreservedSelection, insertBelowPreservedSelection);
        try {
            editorAPI.core.actions.execute(({ tr: tr })=>{
                const schema = tr.doc.type.schema;
                let content;
                if ((0, $6mKj3.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) {
                    // upgrade any container nodes whose content requires _c1 (e.g. panel
                    // containing a table) before converting to PM nodes.
                    const transformedBody = Array.isArray(body) ? body.map((node)=>(0, $25b0e61f73c02011$export$280798ff6ccf43f0)(node, schema).transformedAdf || node) : (0, $25b0e61f73c02011$export$280798ff6ccf43f0)(body, schema).transformedAdf || body;
                    // convert to ProseMirror nodes via processRawValue so that all other
                    // incoming transforms are applied
                    content = Array.isArray(transformedBody) ? (0, $4yKbg.processRawFragmentValue)(schema, transformedBody) : (0, $5Qi6J.processRawValue)(schema, transformedBody);
                } else // Convert snippet body to ProseMirror content
                // Body can be either a single ADFEntity or an array of ADFEntity
                content = Array.isArray(body) ? (0, $aPdNQ.Fragment).fromJSON(schema, body) : schema.nodeFromJSON(body);
                const insertPosition = $ce56c1219cf89111$var$getInsertPositionAfterSelection(preservedSelection);
                const nextTr = (0, $bjg0G.safeInsert)(content, insertPosition, insertPosition === undefined)(tr) ?? tr;
                if (preservedSelection) editorAPIWithPreservedSelection.blockControls?.commands?.stopPreservingSelection?.()({
                    tr: nextTr
                });
                return nextTr;
            });
            return {
                status: 'success'
            };
        } catch (error) {
            (0, $aUBmi.reportError)(error);
            return {
                status: 'error',
                reason: (0, $hPTbh.INSERT_SNIPPET_FAILURE_REASON).INSERT_EXCEPTION
            };
        }
    };
};
module.exports["useInsertSnippet"] = $ce56c1219cf89111$export$7b169887c898052a;

});

parcelRegister("iWI3x", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hYoU4 = parcelRequire("hYoU4");


var $4arST = parcelRequire("4arST");

const $6e8e2f3a6d87036a$export$9540a34fb4a0cc39 = {
    COLLAB_PROVIDER: 'RETRIEVE_EDITOR_TITLE_AND_CONTENT_ERROR_COLLAB_PROVIDER',
    ACK_STATE: 'RETRIEVE_EDITOR_TITLE_AND_CONTENT_ERROR_ACK_STATE'
};
const $6e8e2f3a6d87036a$export$502db6186656215e = ({ onCollabError: onCollabError, editorActions: editorActions })=>{
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    const getCollabProviderState = (0, $4arST.useGetCollabProviderState)({
        editorActions: editorActions,
        collabEditProvider: collabEditProvider,
        reason: 'get-content'
    });
    const retrieveEditorTitleAndContent = (0, $cozmU.useCallback)(()=>{
        return new Promise((resolve, reject)=>{
            if (!collabEditProvider) return reject($6e8e2f3a6d87036a$export$9540a34fb4a0cc39.COLLAB_PROVIDER);
            return Promise.resolve(getCollabProviderState(true)).then((ackState)=>{
                if (!ackState) return reject($6e8e2f3a6d87036a$export$9540a34fb4a0cc39.ACK_STATE);
                const { title: title, content: content, stepVersion: stepVersion } = ackState;
                return resolve({
                    title: title,
                    adf: content,
                    ncsStepVersion: stepVersion.toString()
                });
            }).catch((error)=>{
                onCollabError();
                reject(error);
            });
        });
    }, [
        onCollabError,
        getCollabProviderState,
        collabEditProvider
    ]);
    return {
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent
    };
};
module.exports["useRetrieveEditorTitleAndContent"] = $6e8e2f3a6d87036a$export$502db6186656215e;

});

parcelRegister("iSo43", function(module, exports) {
const $6ac09341ad5c7ec7$export$91d00b201265e40b = 'editor_main_chunk';
const $6ac09341ad5c7ec7$export$c6893228a1079127 = 'rendered_ssr_chunks';
const $6ac09341ad5c7ec7$export$cffaeea6ab4f52ea = '__CONFLUENCE_SSR_CHUNKS__';
const $6ac09341ad5c7ec7$export$ee9d2dfeb48f89d3 = ()=>{
    if (typeof window === 'undefined') return [];
    const chunks = window[$6ac09341ad5c7ec7$export$cffaeea6ab4f52ea];
    if (!Array.isArray(chunks)) return [];
    return [
        ...new Set(chunks.filter((chunk)=>typeof chunk === 'string'))
    ];
};
module.exports["EDITOR_MAIN_SSR_CHUNK_NAME"] = $6ac09341ad5c7ec7$export$91d00b201265e40b;
module.exports["RENDERED_SSR_CHUNKS_CUSTOM_DATA_KEY"] = $6ac09341ad5c7ec7$export$c6893228a1079127;
module.exports["CONFLUENCE_SSR_CHUNKS_WINDOW_KEY"] = $6ac09341ad5c7ec7$export$cffaeea6ab4f52ea;
module.exports["getRenderedSsrChunks"] = $6ac09341ad5c7ec7$export$ee9d2dfeb48f89d3;

});

parcelRegister("beK3g", function(module, exports) {
/* useSpinner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lOkIA = parcelRequire("lOkIA");

const $510b459ad72a4bad$var$ReadOnlyOverlay = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31f7Cj1 _0jFU0VN91d _1mT5xdy1CL _3OE6xYdnbC _2IhTondnbC _39xV02N91d _42Yu6BcY7l",
            __cmplp.className
        ])
    });
});
const $510b459ad72a4bad$var$TransparentReadOnlyOverlay = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0KLXrujOvk _0wOv4QRaMg _0jFU0VN91d _1mT5xdWVPG _3OE6xYdnbC _2IhTondnbC _39xV02N91d _42Yu6BcY7l",
            __cmplp.className
        ])
    });
});
const $510b459ad72a4bad$export$7f7cbe89f1eacd2 = ({ shouldShowSpinner: shouldShowSpinner, isOverlayTransparent: isOverlayTransparent = false })=>{
    if (!shouldShowSpinner) return null;
    if (isOverlayTransparent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($510b459ad72a4bad$var$TransparentReadOnlyOverlay, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOkIA.CenteredSpinner), {
        size: "large"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($510b459ad72a4bad$var$ReadOnlyOverlay, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOkIA.CenteredSpinner), {
        size: "medium"
    }));
};
const $510b459ad72a4bad$export$21495182eeff761c = ()=>{
    const [shouldShowSpinner, setShouldShowSpinner] = (0, $cozmU.useState)(false);
    const showSpinner = (0, $cozmU.useCallback)(()=>setShouldShowSpinner(true), []);
    const hideSpinner = (0, $cozmU.useCallback)(()=>setShouldShowSpinner(false), []);
    return {
        showSpinner: showSpinner,
        hideSpinner: hideSpinner,
        shouldShowSpinner: shouldShowSpinner
    };
};
module.exports["Spinner"] = $510b459ad72a4bad$export$7f7cbe89f1eacd2;
module.exports["useSpinner"] = $510b459ad72a4bad$export$21495182eeff761c;

});

parcelRegister("btQhd", function(module, exports) {
/* EditorWrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kNIYN = parcelRequire("kNIYN");


var $3u5lg = parcelRequire("3u5lg");


var $dOBRD = parcelRequire("dOBRD");


var $jbOus = parcelRequire("jbOus");


var $9DHhW = parcelRequire("9DHhW");


var $ah4BL = parcelRequire("ah4BL");


var $5vi32 = parcelRequire("5vi32");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $jxpvN = parcelRequire("jxpvN");


var $hrAmX = parcelRequire("hrAmX");


var $7aRa9 = parcelRequire("7aRa9");


var $6MSEP = parcelRequire("6MSEP");


var $dPJCf = parcelRequire("dPJCf");


var $6jB9o = parcelRequire("6jB9o");


var $1mHQU = parcelRequire("1mHQU");


var $5pjrL = parcelRequire("5pjrL");


var $601vk = parcelRequire("601vk");


var $wtSEP = parcelRequire("wtSEP");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $4PPzL = parcelRequire("4PPzL");


var $4Wxqa = parcelRequire("4Wxqa");


var $9Z1sw = parcelRequire("9Z1sw");


var $eSLr0 = parcelRequire("eSLr0");


var $sLZsl = parcelRequire("sLZsl");


var $jmjWc = parcelRequire("jmjWc");


const $0c186b876cfe191c$export$5960959cfc832bcd = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EcrVg",
    loader: async ()=>(await (parcelRequire("cgPr2"))).EditorConversionModal,
    name: 'EditorConversionModal'
});



var $1iuay = parcelRequire("1iuay");


var $5MyXJ = parcelRequire("5MyXJ");


var $bQm3c = parcelRequire("bQm3c");


var $duklN = parcelRequire("duklN");


var $c0rhi = parcelRequire("c0rhi");


var $i9VoI = parcelRequire("i9VoI");


var $7Sm4c = parcelRequire("7Sm4c");


var $iVU5h = parcelRequire("iVU5h");


var $iSXh4 = parcelRequire("iSXh4");


var $hNtOj = parcelRequire("hNtOj");


var $bUSKZ = parcelRequire("bUSKZ");

/**
 * @generated SignedSource<<042bc70250ce0b222b6ec61bb8fed4e1>>
 * @relayHash a8c4454f25df6d929f9eb1e322e9cada
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1cd9eca42c709108c99f9ddf20faebeefea0dc583da0e021308d3fe45262dd8d
const $4478baa07702c6a7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceKeyWatcherContentSpaceKeyQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceKeyWatcherContentSpaceKeyQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "a8c4454f25df6d929f9eb1e322e9cada",
            "id": "1cd9eca42c709108c99f9ddf20faebeefea0dc583da0e021308d3fe45262dd8d",
            "metadata": {},
            "name": "useSpaceKeyWatcherContentSpaceKeyQuery",
            "operationKind": "query",
            "text": "query useSpaceKeyWatcherContentSpaceKeyQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,space{id,key,alias}}}}"
        }
    };
}();
$4478baa07702c6a7$var$node.hash = "6b36a8d07cc501cdb430d7f11ca8944a";
var $4478baa07702c6a7$export$2e2bcd8739ae039 = $4478baa07702c6a7$var$node;









var $7zgzO = parcelRequire("7zgzO");





var $e9owJ = parcelRequire("e9owJ");

const $99aa1354571330dd$export$486cb94e63be330f = ({ contentType: contentType })=>{
    const { match: match, replace: replace, toUrl: toUrl } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { contentId: contentId, spaceKey: spaceKeyFromUrl } = match?.params ?? {};
    const { triggerAnalyticsEvent: triggerAnalyticsEvent } = (0, $e9owJ.useEditorAnalyticsEvent)({
        contentId: contentId,
        contentType: contentType,
        source: 'editPageScreen',
        subject: 'editor',
        collabService: 'ncs'
    });
    // Replaces the URL to match the given space key
    const changeUrl = (0, $cozmU.useCallback)((spaceKey)=>{
        // Only changing the space key
        const params = {
            ...match?.params,
            query: match?.query,
            spaceKey: spaceKey
        };
        const url = toUrl(match?.name, params);
        if (url !== null) replace(url);
    }, [
        replace,
        toUrl,
        match
    ]);
    // Changes the URL if the new space key from the move event is different from the current
    const onMoveSubscriptionEvent = (0, $cozmU.useCallback)((_eventName, response)=>{
        const newSpaceAlias = response?.pageMoved?.newSpaceAlias ?? null;
        if (newSpaceAlias !== null && newSpaceAlias?.toLowerCase() !== spaceKeyFromUrl?.toLowerCase()) changeUrl(newSpaceAlias);
        // Fire analytics to track when the page or blog was moved
        const eventName = contentType === 'page' ? 'pageMoved' : 'blogMoved';
        triggerAnalyticsEvent(eventName, {
            editorType: 'next',
            ...response
        });
    }, [
        changeUrl,
        contentType,
        spaceKeyFromUrl,
        triggerAnalyticsEvent
    ]);
    // Handles the case where the page is moved while the user is editing it
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        subscriberId: 'UseSpaceKeyWatcherSubscription',
        delta: 'pageMoved',
        onDataReceived: onMoveSubscriptionEvent
    });
    // Handles the case where the user returns to a bookmarked page which has since been moved
    (0, $cozmU.useEffect)(()=>{
        const fetchSpaceKey = async ()=>{
            const { data: data } = await (0, $c0rhi.queryInterop)({
                query: (0, $4478baa07702c6a7$export$2e2bcd8739ae039),
                variables: {
                    contentId: contentId
                },
                fetchPolicy: 'network-only',
                __callerPackage__: "editor-features"
            });
            const contentSpaceKeyAsKey = data?.content?.nodes?.[0]?.space?.key ?? null;
            const contentSpaceAliasAsKey = data?.content?.nodes?.[0]?.space?.alias ?? null;
            const contentSpaceKey = contentSpaceAliasAsKey || contentSpaceKeyAsKey;
            if (contentSpaceKey !== null && contentSpaceKey !== spaceKeyFromUrl) changeUrl(contentSpaceKey);
        };
        if (contentId) fetchSpaceKey();
    }, [
        contentId,
        changeUrl,
        spaceKeyFromUrl
    ]);
};



var $2tHI8 = parcelRequire("2tHI8");





var $kSwu1 = parcelRequire("kSwu1");


var $6mKj3 = parcelRequire("6mKj3");





var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");








var $aJv6Q = parcelRequire("aJv6Q");


var $3IBnw = parcelRequire("3IBnw");











var $4U6ec = parcelRequire("4U6ec");

/**
 * @generated SignedSource<<9c0b77e2b5e78d185b7dc1b5457f1035>>
 * @relayHash 3bebc9b916816a4421a88a5541e30086
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c7a1aa7636dab60636aa748a13ec4c88b1f1170c4a67b1f74da99ad0e09e4ce8
const $d42c0607fc0e2a3a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "editor"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"editor\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DraftContentProperties",
                                    "kind": "LinkedField",
                                    "name": "draft",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "autoConvertedDate"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsAutoConvertedRecentlyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsAutoConvertedRecentlyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3bebc9b916816a4421a88a5541e30086",
            "id": "c7a1aa7636dab60636aa748a13ec4c88b1f1170c4a67b1f74da99ad0e09e4ce8",
            "metadata": {},
            "name": "useIsAutoConvertedRecentlyQuery",
            "operationKind": "query",
            "text": "query useIsAutoConvertedRecentlyQuery($contentId:ID!){content(id:$contentId){nodes{id,properties(key:\"editor\"){nodes{value}},metadata{frontend{fabricEditorSupported}},contentProperties{draft{autoConvertedDate}}}}}"
        }
    };
}();
$d42c0607fc0e2a3a$var$node.hash = "bd10bb6670b064c3529095e127e8cdf2";
var $d42c0607fc0e2a3a$export$2e2bcd8739ae039 = $d42c0607fc0e2a3a$var$node;



var $jMyy4 = parcelRequire("jMyy4");

const $9d4f4069312c3141$export$43dbb334710faaa0 = (0, $d42c0607fc0e2a3a$export$2e2bcd8739ae039);
const $9d4f4069312c3141$export$1136bf1e7d4859ac = ({ contentId: contentId })=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($9d4f4069312c3141$export$43dbb334710faaa0, {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "editor-features"
    });
    const node = data?.content?.nodes?.[0];
    // isFabricEditor: Is this page persisted as a v2 Fabric page, or a legacy page (v1/null)?
    const isFabricEditor = node?.properties?.nodes?.[0]?.value === '"v2"';
    // isFabricEditorSupported: Is this page eligible for conversion from legacy to Fabric?
    const isFabricEditorSupported = !!node?.metadata?.frontend?.fabricEditorSupported;
    // isAutoConverted: A page is auto-converted if it is not persisted as Fabric, and is conversion eligible.
    const isAutoConverted = !isFabricEditor && isFabricEditorSupported;
    // isMarkedAutoConverted: Does this page already have the autoConvertedDate content property? (i.e. has this auto-converted page been previously visited?)
    const isMarkedAutoConverted = !!node?.contentProperties?.draft?.autoConvertedDate;
    return {
        loading: loading,
        error: error,
        isAutoConverted: isAutoConverted,
        isMarkedAutoConverted: isMarkedAutoConverted
    };
};


/**
 * @generated SignedSource<<ade4a0bda57d1e9adec362ed6a063017>>
 * @relayHash a88f8ef230b3d1f68cdbdbbb6d77d943
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID db06bf7f6c39ffc11c383a55a4d313a8051acfca05b47e376d7108a2ac6d4258
const $0ec7676069805861$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useMarkAutoConvertedDateMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceCreateAutoConvertedDatePayload",
                    "kind": "LinkedField",
                    "name": "confluence_createAutoConvertedDate",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useMarkAutoConvertedDateMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceCreateAutoConvertedDatePayload",
                    "kind": "LinkedField",
                    "name": "confluence_createAutoConvertedDate",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "a88f8ef230b3d1f68cdbdbbb6d77d943",
            "id": "db06bf7f6c39ffc11c383a55a4d313a8051acfca05b47e376d7108a2ac6d4258",
            "metadata": {},
            "name": "useMarkAutoConvertedDateMutation",
            "operationKind": "mutation",
            "text": "mutation useMarkAutoConvertedDateMutation($input:ConfluenceCreateAutoConvertedDateInput!,$cloudId:ID!){confluence_createAutoConvertedDate(cloudId:$cloudId,input:$input){success,errors{extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}},message}}}"
        }
    };
}();
$0ec7676069805861$var$node.hash = "b462648a057e8cb8c786e1b5e6926d57";
var $0ec7676069805861$export$2e2bcd8739ae039 = $0ec7676069805861$var$node;









var $308Wd = parcelRequire("308Wd");





var $1NBp8 = parcelRequire("1NBp8");


const $d332ea2ab10997ab$export$7bc4789aad42c5 = ({ cloudId: cloudId, contentId: contentId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // Mutation which "marks" a page by adding the autoConvertedDate content property to the page
    const [markAutoConvertedDateMutation] = (0, $308Wd.useMutationInterop)((0, $0ec7676069805861$export$2e2bcd8739ae039), {
        onError: (err)=>{
            // If an error occurred, track it with an analytics event
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'error',
                    actionSubject: 'markAutoConvertedDate',
                    source: (0, $1NBp8.EDIT_PAGE_V2).name,
                    attributes: {
                        contentId: contentId,
                        isGQLError: true,
                        message: err.message
                    }
                }
            });
            (0, $7Sm4c.markErrorAsHandled)(err);
        },
        refetchQueries: ()=>[
                {
                    // Refetch query data for whether page is marked as auto-converted
                    query: (0, $9d4f4069312c3141$export$43dbb334710faaa0),
                    variables: {
                        contentId: contentId
                    }
                }
            ],
        __callerPackage__: "editor-features"
    });
    const markAutoConvertedDate = (0, $cozmU.useCallback)(async ()=>{
        // Mark the page as auto-converted by setting the autoConvertedDate content property
        const { data: data } = await markAutoConvertedDateMutation({
            variables: {
                cloudId: cloudId,
                input: {
                    contentId: contentId
                }
            }
        });
        const errors = data?.confluence_createAutoConvertedDate?.errors;
        // If an error occurred, track it with an analytics event
        if (errors?.length) errors.forEach((err)=>createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'error',
                    actionSubject: 'markAutoConvertedDate',
                    source: (0, $1NBp8.EDIT_PAGE_V2).name,
                    attributes: {
                        contentId: contentId,
                        isGQLError: false,
                        message: err.message
                    }
                }
            }).fire());
    }, [
        cloudId,
        contentId,
        createAnalyticsEvent,
        markAutoConvertedDateMutation
    ]);
    return {
        markAutoConvertedDate: markAutoConvertedDate
    };
};


const $87ee69f0834f1b27$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    pageHasBeenConvertedTitle: {
        id: "editor-features.page-has-been-converted-title",
        defaultMessage: "Page has been converted"
    },
    pageHasBeenConvertedDescription: {
        id: "editor-features.page-has-been-converted-description",
        defaultMessage: "This page has been converted to the new editing experience"
    },
    pageHasBeenConvertedLearnMore: {
        id: "editor-features.page-has-been-converted-learn-more-link",
        defaultMessage: "Learn more"
    }
});
const $87ee69f0834f1b27$export$91195e10eb787117 = ()=>{
    window.open((0, $4U6ec.learnMoreURL), '_blank');
};
const $87ee69f0834f1b27$var$FlagComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ flags: flags, onShowFlag: onShowFlag })=>{
    const showFlag = (0, $cozmU.useRef)(true);
    // Show the flag and trigger any side effects once
    if (showFlag) {
        flags.showInfoFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $87ee69f0834f1b27$export$a7357cdd1f0b0168.pageHasBeenConvertedTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $87ee69f0834f1b27$export$a7357cdd1f0b0168.pageHasBeenConvertedDescription),
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $87ee69f0834f1b27$export$a7357cdd1f0b0168.pageHasBeenConvertedLearnMore),
                    onClick: $87ee69f0834f1b27$export$91195e10eb787117
                }
            ],
            // Auto-dismiss the flag after 8 seconds (AtlasKit AutoDismissFlag default dismiss delay)
            isAutoDismiss: true
        });
        onShowFlag();
        showFlag.current = false;
    }
    return null;
});
const $87ee69f0834f1b27$export$111652a70d302bfa = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
})(({ contentId: contentId, flags: flags })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    // Get relevant auto-conversion data
    const { loading: loading, error: error, isAutoConverted: isAutoConverted, isMarkedAutoConverted: isMarkedAutoConverted } = (0, $9d4f4069312c3141$export$1136bf1e7d4859ac)({
        contentId: contentId
    });
    // Determine if current user is the first one to interact with an auto-converted legacy page
    const didAutoConversionRecently = !loading && !error && isAutoConverted && !isMarkedAutoConverted;
    // This key is set previously when a user manually converts a page (i.e. clicks "Convert page")
    const didManualConversionRecently = (0, $cozmU.useMemo)(()=>(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).PAGE_JUST_CONVERTED) === contentId, [
        contentId
    ]);
    // Mutation to mark auto-converted page with autoConvertedDate content property
    const { markAutoConvertedDate: markAutoConvertedDate } = (0, $d332ea2ab10997ab$export$7bc4789aad42c5)({
        cloudId: cloudId,
        contentId: contentId
    });
    const handleShowFlagManualConversion = (0, $cozmU.useCallback)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).PAGE_JUST_CONVERTED);
    }, []);
    const handleShowFlagAutoConversion = (0, $cozmU.useCallback)(()=>{
        markAutoConvertedDate();
    }, [
        markAutoConvertedDate
    ]);
    if (didManualConversionRecently) // In the case of a recent manual conversion, we want to:
    // (1) Show the flag.
    // (2) Clear local storage since the manual conversion has completed and the user has received visual confirmation.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87ee69f0834f1b27$var$FlagComponent, {
        flags: flags,
        onShowFlag: handleShowFlagManualConversion
    });
    else if (didAutoConversionRecently) // In the case of being the first visitor of an auto-converted page, we want to:
    // (1) Show the flag.
    // (2) Mark the page with an auto-conversion timestamp indicating this page has been visited. Subsequent page visits will not trigger the flag.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87ee69f0834f1b27$var$FlagComponent, {
        flags: flags,
        onShowFlag: handleShowFlagAutoConversion
    });
    return null;
});


// Note: Old component which shows the success flag only after a successful manual conversion; being phased out in favor of MigrationSuccessFlagComponentV2
const $9bece82eecc4ba59$var$MigrationSuccessFlagComponent = ({ contentId: contentId, flags: flags })=>{
    // We only want to show the flag once (we don't want to re-render and show the flag again)
    const didShowFlag = (0, $cozmU.useRef)(false);
    // This key is set previously when a user manually converts a page (i.e. clicks "Convert page")
    const didManualConversionRecently = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).PAGE_JUST_CONVERTED) === contentId;
    // We want to clear the previously set key since we only want to show the flag when the user first lands in the Fabric editor
    const onClose = ()=>(0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).PAGE_JUST_CONVERTED);
    const shouldShowFlag = (0, $cozmU.useMemo)(()=>didManualConversionRecently && !!flags, [
        didManualConversionRecently,
        flags
    ]);
    if (shouldShowFlag && !didShowFlag.current) {
        didShowFlag.current = true;
        flags.showInfoFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $87ee69f0834f1b27$export$a7357cdd1f0b0168).pageHasBeenConvertedTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $87ee69f0834f1b27$export$a7357cdd1f0b0168).pageHasBeenConvertedDescription),
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $87ee69f0834f1b27$export$a7357cdd1f0b0168).pageHasBeenConvertedLearnMore),
                    onClick: (0, $87ee69f0834f1b27$export$91195e10eb787117)
                }
            ],
            // Auto-dismiss the flag after 8 seconds (AtlasKit AutoDismissFlag default dismiss delay)
            isAutoDismiss: true,
            onClose: onClose
        });
    }
    return null;
};
const $9bece82eecc4ba59$var$MigrationSuccessFlagComponentSwitch = (props)=>(0, $6mKj3.expValEquals)('confluence_auto_conversion_success_flag', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87ee69f0834f1b27$export$111652a70d302bfa), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9bece82eecc4ba59$var$MigrationSuccessFlagComponent, props);
const $9bece82eecc4ba59$export$bc6e366e749c654a = (0, $7aRa9.withFlags)($9bece82eecc4ba59$var$MigrationSuccessFlagComponentSwitch);


/**
 * @generated SignedSource<<9f07bbaeba931a2dbb235a0ac720ded7>>
 * @relayHash e581ffa9631cb1e655ff9bbc7de6bb54
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d63822193e91ba43ff49d6a2eca067b94e210af6f6fe6d015557fbe99c6d171
const $27ce1577c439221d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": [
                "current"
            ],
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "concreteType": "PaginatedContentList",
                                    "kind": "LinkedField",
                                    "name": "attachments",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "title"
                                                },
                                                {
                                                    "concreteType": "KeyValueHierarchyMap",
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "value"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SameFileNameWarningFlagQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SameFileNameWarningFlagQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "e581ffa9631cb1e655ff9bbc7de6bb54",
            "id": "5d63822193e91ba43ff49d6a2eca067b94e210af6f6fe6d015557fbe99c6d171",
            "metadata": {},
            "name": "SameFileNameWarningFlagQuery",
            "operationKind": "query",
            "text": "query SameFileNameWarningFlagQuery($contentId:ID!,$status:[String]=[\"current\"]){content(id:$contentId,status:$status){edges{node{id,attachments{nodes{id,title,extensions{key,value}}}}}}}"
        }
    };
}();
$27ce1577c439221d$var$node.hash = "1a2b1f8fba4b4d8d2666f06755932652";
var $27ce1577c439221d$export$2e2bcd8739ae039 = $27ce1577c439221d$var$node;









var $i1t43 = parcelRequire("i1t43");


var $4aRua = parcelRequire("4aRua");


var $llqlc = parcelRequire("llqlc");


var $hfrng = parcelRequire("hfrng");














var $6fil2 = parcelRequire("6fil2");


var $5ZqQS = parcelRequire("5ZqQS");




const $3e63cfb29051b1a8$var$i18n = (0, $kSwu1.defineMessages)({
    sameFileNameTitle: {
        id: "editor-features.same.file.name.title",
        defaultMessage: "\u201C{file}\u201D already exists"
    },
    sameFileNameDescription: {
        id: "editor-features.same.file.name.description",
        defaultMessage: "The file you chose has the same name as an existing attachment, and the new one will replace the existing one."
    },
    sameFileNameLearnMore: {
        id: "editor-features.same.file.name.learn.more",
        defaultMessage: "Learn more about attachments."
    }
});
const $3e63cfb29051b1a8$var$ATTACHMENTS_LINK = 'https://support.atlassian.com/confluence-cloud/docs/manage-uploaded-files/';
const $3e63cfb29051b1a8$var$SameFileNameWarningFlagComponent = ({ editorActions: editorActions, flags: flags, contentId: contentId, intl: intl })=>{
    // [file id]: file name
    const attachmentsMapRef = (0, $cozmU.useRef)({});
    /**
   * parses the editor adf to get media nodes
   * @returns mediaNodes[]
   */ const getMediaNodesFromAdf = (0, $cozmU.useCallback)(async ()=>{
        const adf = await editorActions.getValue();
        const mediaNodes = (0, $llqlc.filter)(adf, (node)=>node.type === 'media' && !!node?.attrs?.['collection'] && node.attrs?.type !== 'external');
        return mediaNodes;
    }, [
        editorActions
    ]);
    /**
   * sets a map of attachments on the content
   */ const getAttachmentsMap = (0, $cozmU.useCallback)(async ()=>{
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $27ce1577c439221d$export$2e2bcd8739ae039),
            variables: {
                contentId: contentId,
                status: [
                    'current',
                    'draft'
                ]
            },
            fetchPolicy: 'network-only' // should get the latest ids
            ,
            __callerPackage__: "editor-features"
        }).catch((e)=>{
            if ((0, $1uFM6.isUnauthorizedError)(e) || (0, $6fil2.containsNetworkError)(e)) (0, $7Sm4c.markErrorAsHandled)(e);
            else (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: (0, $3IBnw.Attribution).PAGE_MODES
            });
            return {
                data: null
            };
        });
        if (data === null) return;
        const attachmentsMap = data.content?.edges?.[0]?.node?.attachments?.nodes?.reduce((acc, curr)=>{
            const fileId = curr?.extensions?.find((i)=>i?.key === 'fileId')?.value;
            if (curr?.title && fileId) acc[fileId] = curr.title;
            return acc;
        }, {}) || {};
        Object.assign(attachmentsMapRef.current, attachmentsMap);
    }, [
        contentId
    ]);
    /**
   * @param filename
   */ const showSameFileNameFlag = (0, $cozmU.useCallback)((filename)=>{
        flags.showWarningFlag({
            id: `file-with-same-name-${filename}`,
            title: intl.formatMessage($3e63cfb29051b1a8$var$i18n.sameFileNameTitle, {
                file: filename
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "p"
            }, intl.formatMessage($3e63cfb29051b1a8$var$i18n.sameFileNameDescription), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: $3e63cfb29051b1a8$var$ATTACHMENTS_LINK,
                target: "_blank"
            }, intl.formatMessage($3e63cfb29051b1a8$var$i18n.sameFileNameLearnMore)))
        });
    }, [
        flags,
        intl
    ]);
    /**
   * globalMediaEventEmitter callback, compares uploaded file name to file names on the editor
   * @param uploadedFileDetails parameter from globalMediaEventEmitter
   */ const checkForDuplicateFileNames = (0, $cozmU.useCallback)(async (uploadedFileDetails)=>{
        const { name: uploadedFileName, id: uploadedFileId } = uploadedFileDetails;
        const mediaNodes = await getMediaNodesFromAdf();
        for (const mediaNode of mediaNodes){
            const mediaNodeFileId = mediaNode?.attrs?.id;
            // no id and do not check self
            if (!mediaNodeFileId || mediaNodeFileId === uploadedFileId) continue;
            if (attachmentsMapRef.current[mediaNodeFileId] === uploadedFileName) {
                showSameFileNameFlag(uploadedFileName);
                break;
            }
        }
        attachmentsMapRef.current[uploadedFileId] = uploadedFileName;
    }, [
        getMediaNodesFromAdf,
        showSameFileNameFlag
    ]);
    (0, $cozmU.useEffect)(()=>{
        (0, $hfrng.globalMediaEventEmitter).on('file-added', checkForDuplicateFileNames);
        return ()=>{
            (0, $hfrng.globalMediaEventEmitter).off('file-added', checkForDuplicateFileNames);
        };
    }, [
        checkForDuplicateFileNames
    ]);
    (0, $cozmU.useEffect)(()=>{
        getAttachmentsMap();
    }, [
        getAttachmentsMap
    ]);
    return null;
};
const $3e63cfb29051b1a8$export$cf6bace5e57a00db = (0, $7aRa9.withFlags)((0, $kSwu1.injectIntl)($3e63cfb29051b1a8$var$SameFileNameWarningFlagComponent));


const $f5a9a69398726f05$var$HEARTBEAT_ERROR_FLAGS = [
    'tenant-unavailable',
    'unauthorised',
    'UNAUTHORIZED'
];
const $f5a9a69398726f05$var$EditorSuccessFlags = (0, $7aRa9.withFlags)((0, $601vk.EditorFlags));
const $f5a9a69398726f05$var$styles = {
    wrapper: "_0jFU0Va1xH _39xV02N91d",
    withPanels: "_3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _1mT5xdRAKS"
}; // Note: this component extracts the props that we don't want to send to the DOM
// This avoids styled errors about these props being passed to the DOM
/* eslint-disable @typescript-eslint/no-unused-vars */ const $f5a9a69398726f05$var$PanelWrapper = ({ showPanel: showPanel, children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, children);
}; /* eslint-enable @typescript-eslint/no-unused-vars */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5a9a69398726f05$var$Panel = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $f5a9a69398726f05$var$PanelWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _3YEZNOdnbC _0aFT5vbt8w",
            __cmplp?.showPanel ? "_3iDTPbQ4SZ" : "_3iDTPbYbGa",
            __cmplp.className
        ])
    });
});
const $f5a9a69398726f05$var$getFlagData = (0, $dOBRD.default)((flagData)=>flagData, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $f5a9a69398726f05$export$c0ee4c2a5005a714 = ({ attribution: attribution, forceDisableEditor: forceDisableEditor, collabEditState: collabEditState, contentType: contentType, contentId: contentId, children: children, isUnpublishedDraft: isUnpublishedDraft, editorActions: editorActions, heartbeatError: heartbeatError, stopHeartbeatCallback: stopHeartbeatCallback, saveDraftError: saveDraftError, isLivePage: isLivePage, editorDisabled: editorDisabled })=>{
    const { includeTopNav: includeTopNav } = (0, $cozmU.useContext)((0, $jxpvN.BannerContext));
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { collabEditInitialized: collabEditInitialized, collabEditError: collabEditError, collabRecoveryError: collabRecoveryError } = collabEditState;
    const [showCreateFromExtensionFlag, setShowCreateFromExtensionFlag] = (0, $cozmU.useState)({
        showFlag: false,
        flagData: undefined
    });
    const [showRestoreSuccessFlag, setShowRestoreSuccessFlag] = (0, $cozmU.useState)(false);
    const [blogifyConversionSuccess, setBlogifyConversionSuccess] = (0, $cozmU.useState)({
        showFlag: false,
        flagData: undefined
    });
    const [heartbeatErrorFlag, setHeartbeatErrorFlag] = (0, $cozmU.useState)({
        showFlag: false,
        heartbeatError: undefined
    });
    const [isAutoConverted] = (0, $sLZsl.useAutoConvertState)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    const previousHasSaveDraftError = (0, $cozmU.useRef)(false);
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)(); // Analytics
    const migratedRecently = (0, $bUSKZ.useMigratedRecently)(contentId); // track publish experience in page migration
    // copied from ContentEditorBindingsComponent
    if (migratedRecently) experienceTracker.start({
        name: (0, $irVI7.MIGRATE_PAGE_PUBLISH_EXPERIENCE),
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH
    });
     // Show a draft create success flag if this draft was created from the create page extension
    (0, $cozmU.useEffect)(()=>{
        // Ensure editor is ready
        if (collabEditInitialized && !editorDisabled) {
            const parentContentId = (0, $6jB9o.getParentContentId)();
            if (parentContentId) {
                // Get the parent page title & show a draft create success flag
                let flagTimeout;
                (0, $c0rhi.queryInterop)({
                    query: (0, $duklN.default),
                    variables: {
                        contentId: parentContentId
                    },
                    __callerPackage__: "editor-features"
                }).then((result)=>{
                    const parentTitle = result.data?.singleContent?.title;
                    flagTimeout = setTimeout(()=>{
                        setShowCreateFromExtensionFlag({
                            showFlag: true,
                            flagData: {
                                parentTitle: parentTitle,
                                parentContentId: parentContentId
                            }
                        });
                    }, 1000);
                }).catch((e)=>{
                    if ((0, $1uFM6.isUnauthorizedError)(e) || (0, $95rLf.isExpectedApolloError)(e)) (0, $7Sm4c.markErrorAsHandled)(e);
                });
                return ()=>{
                    clearTimeout(flagTimeout);
                };
            }
        }
    }, [
        collabEditInitialized,
        editorDisabled
    ]);
    const showBlogifyConversionSuccessFlag = blogifyConversionSuccess.showFlag;
    const blogifyConversionSuccessFlagData = blogifyConversionSuccess.flagData;
    const handleRestore = (0, $cozmU.useCallback)((_delta, response)=>{
        const { trigger: trigger } = response?.pageUpdated || {};
        const { accountId: accountId } = response || {};
        if (trigger === 'restore') // Show this flag only if the same user triggered the restore
        // Otherwise, useUpdateEvent handles when a different user restores
        return !showRestoreSuccessFlag && userId === accountId && setShowRestoreSuccessFlag(true);
        return false;
    }, [
        showRestoreSuccessFlag,
        userId
    ]);
    const onBlogifySubscriptionEvent = (0, $cozmU.useCallback)((_eventName, response)=>{
        // force disable NCS editor whenever page is converted to blogpost
        forceDisableEditor && forceDisableEditor(true);
        !showBlogifyConversionSuccessFlag && response?.pageBlogified && setBlogifyConversionSuccess({
            showFlag: true,
            flagData: response?.pageBlogified
        });
    }, [
        forceDisableEditor,
        showBlogifyConversionSuccessFlag
    ]); /**
                                                               * To ensure that the editor is the correct height and doesn't have double scrollbars,
                                                               */ 
    const panelHeight = (0, $2tHI8.useGeneralWebPanelHeight)(); /**
                                                   * The access-link notice sits above the editor rather than in the page-top banner slot, so its
                                                   * height is not in `bannerState` and has to be subtracted separately.
                                                   */ 
    const { bannerHeight: accessLinkBannerHeight = 0 } = (0, $cozmU.useContext)((0, $4Wxqa.AccessLinkHeaderReplacementsContext));
    (0, $cozmU.useEffect)(()=>{
        if (heartbeatError) {
            if (heartbeatError.reason === 'tenant-unavailable') forceDisableEditor(true);
            else if ((0, $5MyXJ.isPermissionError)(heartbeatError)) stopHeartbeatCallback();
            if (heartbeatErrorFlag.heartbeatError?.reason !== heartbeatError.reason) // Only update error flag data if error is different
            setHeartbeatErrorFlag({
                showFlag: $f5a9a69398726f05$var$HEARTBEAT_ERROR_FLAGS.includes(heartbeatError.reason),
                heartbeatError: heartbeatError
            });
        } // exclude heartbeatErrorFlag.heartbeatError?.reason from dep list to prevent firing twice in a row
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        heartbeatError,
        forceDisableEditor,
        stopHeartbeatCallback
    ]);
    const { isAMN: isAMN, isRecurringParent: isRecurringParent } = (0, $iSXh4.useAutomatedMeetingNotesPageProperties)(contentId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (!isLivePage && isAMN) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'editAMNPage',
                attributes: {
                    isRecurringParent: isRecurringParent,
                    referralSource: (0, $iVU5h.getAMNReferralSourceFromQueryParam)()
                }
            }
        }).fire();
    }, [
        contentId,
        isAMN,
        isRecurringParent,
        createAnalyticsEvent,
        isLivePage
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        subscriberId: 'EditorWrapperSubscriptionPageRestore',
        onDataReceived: handleRestore,
        delta: 'pageUpdated'
    }); // GraphQL subscription for page blogified event
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        subscriberId: 'EditorWrapperSubscription',
        delta: 'pageBlogified',
        skip: // only listen for blogify events on pages
        contentType === 'blogpost',
        onDataReceived: onBlogifySubscriptionEvent
    }); // Update the URL of the draft with new space key
    // 1. when another users move the page to different space
    // 2. when user returns to a bookmarked page which has since been moved
    (0, $99aa1354571330dd$export$486cb94e63be330f)({
        contentType: contentType
    });
    (0, $cozmU.useEffect)(()=>{
        // Disable editor when saveDraftError exists, re-enable when error is reset
        if (saveDraftError) {
            forceDisableEditor(true);
            previousHasSaveDraftError.current = true;
        }
        if (saveDraftError === null && previousHasSaveDraftError.current === true) {
            // saveDraftError gets set to null explicitely when reset
            forceDisableEditor(false);
            previousHasSaveDraftError.current = false;
        }
    }, [
        saveDraftError,
        forceDisableEditor
    ]);
    if (collabRecoveryError) {
        // Collab Reset mutation can return 403 or 404 directly from Confluence upon editor loading (i.e. perms/page deleted hasn't changed during editing session, so no flag)
        if (collabRecoveryError instanceof (0, $1iuay.CollabRecoveryErrorType) && collabRecoveryError.status === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MSEP.RestrictedPage), {
            accessType: "edit",
            contentId: contentId
        });
        else if (collabRecoveryError instanceof (0, $1iuay.CollabRecoveryErrorType) && collabRecoveryError.status === 404) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), null);
    }
    const isResourceDeletedOrArchived = collabEditError && 'reason' in collabEditError && collabEditError.reason === (0, $5pjrL.NATIVE_COLLAB_ERROR_REASONS).RESOURCE_DELETED;
    if (collabEditError?.status === 403) {
        // The collab service has emitted an error.
        // Cases for the 403:
        //  (1) on initial editor load when the collab provider is not initialized
        //  (2) user's permissions are revoked during the editing session.
        //  (3) page was deleted or archived: if this is the case, reason will be NATIVE_COLLAB_ERROR_REASONS.RESOURCE_DELETED
        // Most of the time when a 403 occurs, we want to kick the user out of the editor, and in the second case we want to show an error flag explaining that permissions have changed.
        // If we're on a live page and the page was deleted or archived, we don't want to show <NotFound /> nor kick the user out. Instead we expect the editor to be disabled and we'll show a flag. (This also helps resolve a race condition where <NotFound /> can be shown before the archiving user gets redirected.)
        if (!isLivePage || isLivePage && !isResourceDeletedOrArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, collabEditInitialized && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5pjrL.NativeCollabErrorFlags), {
            collabEditError: collabEditError
        }), isResourceDeletedOrArchived ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MSEP.RestrictedPage), {
            accessType: "edit",
            contentId: contentId
        }));
        else if (isLivePage && isResourceDeletedOrArchived) // Stop the heartbeat callback to prevent it from kicking the user out of the editor. We want the user to stay in the editor with a flag visible, until they refresh (or if they're the archiver, are redirected).
        stopHeartbeatCallback();
    }
    const checkPermissionsErrorHandler = (0, $hNtOj.ssrPermissionsErrorHandler).getRestrictedRoute() === 'edit';
    if (!isTransition && checkPermissionsErrorHandler) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MSEP.RestrictedPage), {
        accessType: "edit",
        contentId: contentId
    });
    if ((0, $5MyXJ.isPermissionError)(heartbeatError)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5pjrL.NativeCollabErrorFlags), {
        heartbeatError: heartbeatError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MSEP.RestrictedPage), {
        accessType: "edit",
        contentId: contentId
    }));
    if (saveDraftError) {
        // For non 403 and non 404 saveDraft errors, we still want to render editor content, but in disabled state
        if (saveDraftError.statusCode === 403 || saveDraftError.statusCode === 404) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5pjrL.NativeCollabErrorFlags), {
            saveDraftError: saveDraftError
        }), saveDraftError.statusCode === 403 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MSEP.RestrictedPage), {
            accessType: "edit",
            contentId: contentId
        }), saveDraftError.statusCode === 404 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), null));
    }
    return(// TODO: display ADFParseError if passed in as a prop (from content reconciliation)
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        modal: true,
        attribution: attribution
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "editor-wrapper",
            "data-fabric-mode": isUnpublishedDraft ? 'create' : 'edit',
            "data-content-subtype": isLivePage ? 'live' : undefined,
            className: (0, $hekY6.default)([
                $f5a9a69398726f05$var$styles.wrapper,
                "wiki-content"
            ]),
            style: {
                // We want to set the banner height to 0 when in Embedded Confluence because banners are inserted in the
                // BannerContainer component, which is rendered in the PageLayout component, which is not rendered in Embedded Confluence.
                '--ak-editor-wrapper-banner-height': isEmbeddedConfluence ? '0px' : `${bannerState.getTotalHeight(includeTopNav) + panelHeight + accessLinkBannerHeight}px`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $f5a9a69398726f05$var$styles.withPanels
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
            name: "atl-general-web-panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5a9a69398726f05$var$Panel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocation), {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first"
        }))), children, !isLivePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5a9a69398726f05$var$Panel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocation), {
            location: (0, $eSLr0.ATL_EDITOR_SAVEBAR)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
            name: "atl-footer-web-panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5a9a69398726f05$var$Panel, {
            showPanel: false,
            "data-testid": "atl-footer-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocation), {
            location: (0, $eSLr0.ATL_FOOTER)
        }))), heartbeatErrorFlag.showFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5pjrL.NativeCollabErrorFlags), {
            heartbeatError: heartbeatErrorFlag.heartbeatError
        }), collabEditError && (collabEditError.status === 500 || collabEditError.code === (0, $jbOus.PROVIDER_ERROR_CODE).LOCKED || // Document blocked (blacklisted, e.g. kill switch): keep the editor mounted but
        // disabled and show the blocked warning flag. Inert unless the error is emitted,
        // which only happens when platform_editor_blocked_document_ux is on.
        collabEditError.code === (0, $jbOus.PROVIDER_ERROR_CODE).DOCUMENT_BLOCKED) && // unhandled error, no recovery steps at this point
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5pjrL.NativeCollabErrorFlags), {
            collabEditError: collabEditError
        }), collabRecoveryError && collabRecoveryError instanceof (0, $1iuay.CollabRecoveryErrorType) && collabRecoveryError.status === 500 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5pjrL.NativeCollabErrorFlags), {
            collabRecoveryError: collabRecoveryError
        }), isLivePage && collabEditError?.status === 403 && isResourceDeletedOrArchived && // If page is archived or deleted while on a live page, show a flag
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5pjrL.NativeCollabErrorFlags), {
            collabEditError: collabEditError
        }), showRestoreSuccessFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5a9a69398726f05$var$EditorSuccessFlags, {
            flagData: $f5a9a69398726f05$var$getFlagData({
                [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).RESTORE_CONTENT_SUCCESS]: true
            }),
            contentId: contentId,
            contentType: contentType,
            isUnpublishedDraft: isUnpublishedDraft
        }), showBlogifyConversionSuccessFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5a9a69398726f05$var$EditorSuccessFlags, {
            flagData: $f5a9a69398726f05$var$getFlagData({
                [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).BLOGIFY_BLOGPOST_SUCCESS]: true,
                ...blogifyConversionSuccessFlagData
            }),
            contentId: contentId,
            contentType: contentType,
            isUnpublishedDraft: isUnpublishedDraft
        }), showCreateFromExtensionFlag.showFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5a9a69398726f05$var$EditorSuccessFlags, {
            flagData: $f5a9a69398726f05$var$getFlagData({
                [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CREATED_FROM_EXTENSION]: true,
                ...showCreateFromExtensionFlag.flagData
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9bece82eecc4ba59$export$bc6e366e749c654a), {
            contentId: contentId
        }), editorActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3e63cfb29051b1a8$export$cf6bace5e57a00db), {
            editorActions: editorActions,
            contentId: contentId
        }) : null, isAutoConverted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0c186b876cfe191c$export$5960959cfc832bcd), null) : null, saveDraftError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5pjrL.NativeCollabErrorFlags), {
            saveDraftError: saveDraftError
        })))));
};
module.exports["EditorWrapper"] = $f5a9a69398726f05$export$c0ee4c2a5005a714;

});

parcelRegister("cgPr2", function(module, exports) {

let $8eeee0999f3e6bb3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8eeee0999f3e6bb3$var$load("dJjs8").then(()=>parcelRequire('8Ya0K'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("cvzKy", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $b8pma = parcelRequire("b8pma");


var $hDLmU = parcelRequire("hDLmU");


var $c411D = parcelRequire("c411D");


var $jOO7o = parcelRequire("jOO7o");


var $9wGTI = parcelRequire("9wGTI");


var $dPJCf = parcelRequire("dPJCf");


var $9eE57 = parcelRequire("9eE57");


var $5q601 = parcelRequire("5q601");


var $eqOQ5 = parcelRequire("eqOQ5");


var $ZugQS = parcelRequire("ZugQS");


var $kvJHJ = parcelRequire("kvJHJ");


var $7boqA = parcelRequire("7boqA");


var $lLRfG = parcelRequire("lLRfG");


var $9137z = parcelRequire("9137z");


var $iFjdQ = parcelRequire("iFjdQ");


var $j8hiR = parcelRequire("j8hiR");


var $hYoU4 = parcelRequire("hYoU4");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $7r2px = parcelRequire("7r2px");


var $juCeZ = parcelRequire("juCeZ");


var $eSLr0 = parcelRequire("eSLr0");


var $koYWo = parcelRequire("koYWo");


var $3VbV8 = parcelRequire("3VbV8");


var $26lLV = parcelRequire("26lLV");

function $61eafb12aab3b3f9$export$4bc0e880260ffe3f() {
    return (0, $26lLV.sniffUserBrowserExtensions)({
        extensions: [
            'grammarly'
        ]
    });
}



var $4EPzQ = parcelRequire("4EPzQ");

const $049334d04d2ef297$var$extensionNodeSet = new Set([
    'extension',
    'inlineExtension',
    'bodiedExtension'
]);
const $049334d04d2ef297$export$81add81ff014aa45 = (draftBody)=>{
    if (!draftBody) return {};
    try {
        const doc = JSON.parse(draftBody);
        return (0, $4EPzQ.reduce)(doc, (acc, node)=>{
            const key = $049334d04d2ef297$var$extensionNodeSet.has(node.type) ? `${node.type}:${node.attrs?.extensionKey}` : node.type;
            acc[key] = (acc[key] || 0) + 1;
            return acc;
        }, {});
    } catch (e) {
        return {};
    }
};



var $iSo43 = parcelRequire("iSo43");

const $50ece43bf392701d$var$markFMPExperienceActionMeasures = (fmpTimestamp)=>{
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EDIT_INTENT_EDIT_FMP_ACTION), fmpTimestamp);
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EDIT_ROUTE_CHANGE_TO_FMP_ACTION), fmpTimestamp);
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EMBEDDED_EDIT_FMP_ACTION), fmpTimestamp);
};
const $50ece43bf392701d$var$markTTIExperienceActionMeasures = (ttiTimestamp)=>{
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EDIT_INTENT_EDIT_TTI_ACTION), ttiTimestamp);
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EDIT_ROUTE_CHANGE_TO_TTI_ACTION), ttiTimestamp);
    (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_INIT, ttiTimestamp);
    (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EMBEDDED_EDIT_TTI_ACTION), ttiTimestamp);
};
const $50ece43bf392701d$var$PageLoadWrapperComponent = /*#__PURE__*/ (0, $cozmU.memo)(({ contentId: contentId, proseMirrorRenderedData: proseMirrorRenderedData, disabled: disabled, isCreate: isCreate, editSource: editSource, embeddedConfluenceSource: embeddedConfluenceSource, isLivePage: isLivePage, customPerfData: customPerfData, draftBody: draftBody })=>{
    // When editor content is rendered on server, FMP should be reported as TTR on initial load,
    // as the moment when initial HTML is rendered, not when proseMirrorRenderedData is available.
    const isTransition = (0, $dPJCf.useIsTransition)();
    const initialFmpTimestamp = !isTransition && window.__SSR_RENDERED__ ? (0, $9eE57.getMark)('CFP-63.ssr-ttr') : undefined;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [renderPageLoadEnd, setRenderPageLoadEnd] = (0, $cozmU.useState)(false);
    const [renderPageSegmentLoadEnd, setPageSegmentLoadEnd] = (0, $cozmU.useState)(false);
    const [editorEnabledTimestamp, setEditorEnabledTimestamp] = (0, $cozmU.useState)();
    const [fmpTimestamp, setFMPTimestamp] = (0, $cozmU.useState)();
    const [{ hasInitialDraft: hasInitialDraft }] = (0, $hYoU4.useNativeCollabState)();
    const sendMetrics = (0, $c411D.useEmbeddedConfluenceEventMarkers)();
    const panelsModuleKeysAtlGeneral = (0, $juCeZ.useConnectAppsData)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    });
    const panelsModuleKeysAtlFooter = (0, $juCeZ.useConnectAppsData)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_FOOTER)
    });
    const contentExtensionMetrics = (0, $cozmU.useMemo)(()=>{
        let metrics = customPerfData?.contentExtensionMetrics || {};
        if (draftBody && Object.keys(metrics).length === 0) metrics = (0, $7r2px.retrieveContentExtensionMetrics)(draftBody);
        return metrics;
    }, [
        draftBody,
        customPerfData?.contentExtensionMetrics
    ]);
    const smartlinksInitialState = !isTransition && window.__SSR_RENDERED__ && window['__SSR_SMARTLINKS__'];
    const preloadSmartlinksCount = (0, $cozmU.useMemo)(()=>{
        if (!smartlinksInitialState) return 0;
        return Object.keys(smartlinksInitialState).length;
    }, [
        smartlinksInitialState
    ]);
    // When buffering is enabled, there are scenarios in which TTI can be marked prior to FMP.
    // In these cases, we wait until PM data becomes available and set TTI to be FMP.
    const markPageLoad = (fmpTimestamp, stopTime, isLivePage)=>{
        const ttiTimestamp = stopTime < fmpTimestamp ? fmpTimestamp : stopTime;
        $50ece43bf392701d$var$markTTIExperienceActionMeasures(ttiTimestamp);
        setEditorEnabledTimestamp(ttiTimestamp);
        setPageSegmentLoadEnd(true);
        if (!isLivePage) setRenderPageLoadEnd(true);
    };
    const pmRenderedTimestamp = proseMirrorRenderedData?.proseMirrorRenderedTimestamp;
    const documentStats = (0, $cozmU.useMemo)(()=>(0, $049334d04d2ef297$export$81add81ff014aa45)(draftBody), [
        draftBody
    ]);
    const totalNodes = (0, $cozmU.useMemo)(()=>{
        const allNodesCount = Object.values(documentStats);
        return allNodesCount.reduce((acc, nodeCnt)=>acc + nodeCnt, 0);
    }, [
        documentStats
    ]);
    const renderedSsrChunks = (0, $cozmU.useMemo)(()=>!isTransition && window.__SSR_RENDERED__ ? (0, $iSo43.getRenderedSsrChunks)() : [], [
        isTransition
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isTransition || (0, $9wGTI.fg)('platform_editor_add_ssr_chunk_tracking')) return;
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                actionSubject: 'ssrChunk',
                action: 'measured',
                source: 'editPageScreen',
                attributes: {
                    actionSubjectId: 'editor_main',
                    rendered: renderedSsrChunks.includes((0, $iSo43.EDITOR_MAIN_SSR_CHUNK_NAME)),
                    isLivePage: Boolean(isLivePage)
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isLivePage,
        isTransition,
        renderedSsrChunks
    ]);
    (0, $cozmU.useEffect)(()=>{
        const renderContentTimestamp = pmRenderedTimestamp || initialFmpTimestamp;
        // mark FMP only once proseMirrorRenderedData has a defined value
        if (!fmpTimestamp && renderContentTimestamp) {
            setFMPTimestamp(renderContentTimestamp);
            $50ece43bf392701d$var$markFMPExperienceActionMeasures(renderContentTimestamp);
        }
        // Initially, when TTI is being marked for the first time, PM data either be defined or undefined
        if (typeof editorEnabledTimestamp === 'undefined' && !disabled) {
            const stopTime = performance.now();
            if (editSource === 'EmbeddedEditor') {
                const observableObject = (0, $jOO7o.getIframeObservable_DO_NOT_USE)();
                const uniqueKey = observableObject?.object?.uniqueKey;
                sendMetrics({
                    timestamp: Date.now(),
                    ...uniqueKey ? {
                        customData: {
                            uniqueKey: uniqueKey
                        }
                    } : {}
                }, `${(0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX)}${(0, $hDLmU.EMBEDDED_EDITOR_TTI)}`);
            }
            // if PM data is already available, mark the TTI and page load end
            if (fmpTimestamp && !renderPageLoadEnd) markPageLoad(fmpTimestamp, stopTime, isLivePage);
            else {
                // if PM data is not yet available, save the TTI to be used later when FMP becomes defined
                $50ece43bf392701d$var$markTTIExperienceActionMeasures(stopTime);
                setEditorEnabledTimestamp(stopTime);
            }
            (0, $koYWo.sendEditorStartedPageEvent)(createAnalyticsEvent, {
                isCreate: isCreate
            });
        } else if (editorEnabledTimestamp) // once PM data is available, mark the TTI and page load end
        {
            if (fmpTimestamp && !renderPageLoadEnd) markPageLoad(fmpTimestamp, editorEnabledTimestamp, isLivePage);
        }
    }, [
        initialFmpTimestamp,
        pmRenderedTimestamp,
        editorEnabledTimestamp,
        fmpTimestamp,
        disabled,
        renderPageLoadEnd,
        createAnalyticsEvent,
        isCreate,
        isLivePage,
        customPerfData,
        editSource,
        sendMetrics
    ]);
    // PageSegmentLoadEnd & PageLoadEnd have common custom data. PageLoadEnd is only fired for non-live pages.
    const commonCustomData = {
        fabric: true,
        isLivePage: isLivePage,
        embeddedConfluenceSource: embeddedConfluenceSource,
        documentStats: documentStats,
        contentExtensionMetrics: contentExtensionMetrics,
        preloadSmartlinksCount: preloadSmartlinksCount,
        totalNodes: totalNodes,
        [(0, $iSo43.RENDERED_SSR_CHUNKS_CUSTOM_DATA_KEY)]: renderedSsrChunks
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "AwaitEditorSegment",
        hold: !renderPageSegmentLoadEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $3VbV8.EDITOR_METRIC)
    }), fmpTimestamp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqOQ5.PageLoadMarkFMP), {
        timestamp: fmpTimestamp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ZugQS.UFOTransitionMarkFMP), {
        timestamp: fmpTimestamp
    })), renderPageSegmentLoadEnd && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        key: `end-segment-${contentId}`,
        metric: (0, $3VbV8.EDITOR_METRIC),
        stopTime: editorEnabledTimestamp,
        customData: {
            ...commonCustomData,
            ...customPerfData
        }
    }), renderPageLoadEnd && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLRfG.PageLoadEnd), {
        key: `end-page-${contentId}`,
        metric: editSource === 'EmbeddedEditor' ? (0, $3VbV8.EMBEDDED_EDIT_PAGE_LOAD) : (0, $3VbV8.EDIT_PAGE_LOAD),
        stopTime: editorEnabledTimestamp,
        customData: {
            ...commonCustomData,
            contentId: contentId,
            isCreate: isCreate,
            collabService: 'ncs',
            experienceActionMeasures: (0, $iFjdQ.ExperienceActionMeasures).getMeasures(),
            collabEditProviderMeasures: (0, $9137z.CollabEditProviderMeasures).getMeasures(),
            editSource: editSource,
            proseMirrorRenderedData: proseMirrorRenderedData,
            hasInitialDraft: hasInitialDraft,
            browserExtensions: (0, $61eafb12aab3b3f9$export$4bc0e880260ffe3f)(),
            webPanelsAtlGeneral: panelsModuleKeysAtlGeneral,
            webPanelsAtlFooter: panelsModuleKeysAtlFooter
        }
    }));
});
const $50ece43bf392701d$export$cff79a690992c9f3 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($50ece43bf392701d$var$PageLoadWrapperComponent);
module.exports["PageLoadWrapper"] = $50ece43bf392701d$export$cff79a690992c9f3;

});

parcelRegister("dWbBL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $laFNM = parcelRequire("laFNM");


var $8hUXc = parcelRequire("8hUXc");


var $6mKj3 = parcelRequire("6mKj3");


var $8rj8Z = parcelRequire("8rj8Z");





var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $aJPUt = parcelRequire("aJPUt");


var $7boqA = parcelRequire("7boqA");


var $ep3mz = parcelRequire("ep3mz");


var $7QM6o = parcelRequire("7QM6o");


var $jX1qB = parcelRequire("jX1qB");





var $9DHhW = parcelRequire("9DHhW");

const $f0ac822d8f33c68a$export$55a4b363793a10d0 = (isContentCreationPanelShown, contentId)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasScreenEventFired = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!hasScreenEventFired.current && isContentCreationPanelShown) {
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'templateDrawer',
                    objectId: contentId
                }
            }).fire();
            hasScreenEventFired.current = true;
        }
        // dont fire a close event until its been opened before
        if (hasScreenEventFired.current) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'templateDrawer',
                action: isContentCreationPanelShown ? 'opened' : 'closed',
                actionSubject: 'templateDrawer',
                objectId: contentId,
                actionSubjectId: isContentCreationPanelShown ? 'templateDrawerOpened' : 'templateDrawerClosed'
            }
        }).fire();
    }, [
        isContentCreationPanelShown,
        createAnalyticsEvent,
        contentId
    ]);
};






var $1kHsc = parcelRequire("1kHsc");





var $gykrH = parcelRequire("gykrH");


var $1A7bE = parcelRequire("1A7bE");

const $97753ca4d20e5422$export$e27c5ac29356c803 = [
    (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_SPACE_SELECTOR_EXPERIENCE),
    (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_TEMPLATE_LIST_EXPERIENCE),
    (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE)
];
const $97753ca4d20e5422$export$5af17974359daea7 = (experienceTracker, subExperiences)=>(event)=>{
        const editPageExperienceEnded = event.name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) && (0, $gykrH.isStop)(event);
        if (editPageExperienceEnded) $97753ca4d20e5422$export$fbef40dd3c73dfed(experienceTracker, subExperiences, `${(0, $irVI7.EDIT_PAGE_EXPERIENCE)} experience ended`);
    };
const $97753ca4d20e5422$export$fbef40dd3c73dfed = (experienceTracker, subExperiences, reason)=>{
    const allLoadPanelExperiences = [
        (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_EXPERIENCE),
        ...subExperiences
    ];
    allLoadPanelExperiences.forEach((name)=>{
        experienceTracker.abort({
            name: name,
            reason: reason
        });
    });
};
const $97753ca4d20e5422$export$7bbca367109bb861 = (subExperiences)=>(events, experience)=>{
        (0, $1A7bE.collectAll)(subExperiences)(events, experience);
    };
const $97753ca4d20e5422$export$592985e5f8127ac4 = (isSpacePickerDisabled)=>{
    if (isSpacePickerDisabled) return $97753ca4d20e5422$export$e27c5ac29356c803.filter((subexperience)=>subexperience !== (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_SPACE_SELECTOR_EXPERIENCE));
    return $97753ca4d20e5422$export$e27c5ac29356c803;
};


const $3c4a4cbc3a864190$export$b6c47fafdd5a8f13 = ()=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $cozmU.useEffect)(()=>{
        return experienceTracker.subscribe((0, $97753ca4d20e5422$export$5af17974359daea7)(experienceTracker, (0, $97753ca4d20e5422$export$e27c5ac29356c803)));
    }, [
        experienceTracker
    ]);
    const abortExperiences = (0, $cozmU.useCallback)((reason)=>{
        (0, $97753ca4d20e5422$export$fbef40dd3c73dfed)(experienceTracker, (0, $97753ca4d20e5422$export$e27c5ac29356c803), reason);
    }, [
        experienceTracker
    ]);
    return {
        abortTemplatePanelLoadExperiences: abortExperiences
    };
};


/**
 * @generated SignedSource<<584a16b0094482cf352dcb664350db61>>
 * @relayHash f39304a70c71e45add248e90ced5372d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 68faf2d9ef8f69244b1fcc4dc0dc34521ed8149553747b1106590a0992b0bf53
const $39d1fac194a31071$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "ancestors",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentCreationPanelTabsTemplatePanelContentQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentCreationPanelTabsTemplatePanelContentQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f39304a70c71e45add248e90ced5372d",
            "id": "68faf2d9ef8f69244b1fcc4dc0dc34521ed8149553747b1106590a0992b0bf53",
            "metadata": {},
            "name": "ContentCreationPanelTabsTemplatePanelContentQuery",
            "operationKind": "query",
            "text": "query ContentCreationPanelTabsTemplatePanelContentQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,ancestors{id,title}}}}"
        }
    };
}();
$39d1fac194a31071$var$node.hash = "863362ed24343499d1d0b2f9551928fb";
var $39d1fac194a31071$export$2e2bcd8739ae039 = $39d1fac194a31071$var$node;






var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $hMjUh = parcelRequire("hMjUh");


var $dkVNA = parcelRequire("dkVNA");


var $bxtKM = parcelRequire("bxtKM");


var $22LbG = parcelRequire("22LbG");





var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");





var $gfIPU = parcelRequire("gfIPU");


var $7zgzO = parcelRequire("7zgzO");


var $c3Qwv = parcelRequire("c3Qwv");


var $jmjWc = parcelRequire("jmjWc");


const $39d8ff3835a36bb3$export$67b0eaa8bfcb2d1f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Xum4K",
    name: "TemplatePanel",
    loader: async ()=>(await (parcelRequire("8lItS"))).TemplatePanel
});






const $063472e56b7451b3$export$b3ebd135320cfc = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "T0xtm",
    name: "SourcesList",
    loader: async ()=>(await (parcelRequire("2kMtD"))).SourcesList
});



var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $c5gk7 = parcelRequire("c5gk7");


var $lTuad = parcelRequire("lTuad");

/**
 * Looking for gridSize? Use space tokens instead. If you need a token above 80px, or if you're setting width/height, just hardcode your value e.g. 240px.
 * Looking for borderRadius? Use a hardcoded 3px until tokens are available.
 */ // TODO(brizvash): move it to separate package or check is atlaskit will become compatible with compiled
const $81d67ebdabda9710$export$ddefa1de84eb00c6 = 400; // layers.layer()
const $81d67ebdabda9710$export$e2b78fc999d64ab4 = 300; // layers.dialog()
const $81d67ebdabda9710$export$ae37325b3735a1de = 200; // layers.navigation()



var $bDgLe = parcelRequire("bDgLe");








var $ad7Ou = parcelRequire("ad7Ou");


var $gVrmv = parcelRequire("gVrmv");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $6H0Pg = parcelRequire("6H0Pg");


var $2sWSU = parcelRequire("2sWSU");


var $6sN9o = parcelRequire("6sN9o");


var $8aF6s = parcelRequire("8aF6s");


var $4oS56 = parcelRequire("4oS56");


var $dcvq8 = parcelRequire("dcvq8");


var $lx6jn = parcelRequire("lx6jn");


var $bQm3c = parcelRequire("bQm3c");


var $7Voxz = parcelRequire("7Voxz");


var $hPTbh = parcelRequire("hPTbh");


var $kBRLU = parcelRequire("kBRLU");


var $5Vsx9 = parcelRequire("5Vsx9");


var $2mmJ0 = parcelRequire("2mmJ0");


var $jxXkP = parcelRequire("jxXkP");


var $cg3fp = parcelRequire("cg3fp");


var $5B99W = parcelRequire("5B99W");


var $bUH8D = parcelRequire("bUH8D");


var $dZUkS = parcelRequire("dZUkS");








var $eb3ax = parcelRequire("eb3ax");


var $fPHWO = parcelRequire("fPHWO");


var $cgTkH = parcelRequire("cgTkH");

var $90d10ce89a54f40b$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $90d10ce89a54f40b$var$isEqual(first, second) {
    if (first === second) return true;
    if ($90d10ce89a54f40b$var$safeIsNaN(first) && $90d10ce89a54f40b$var$safeIsNaN(second)) return true;
    return false;
}
function $90d10ce89a54f40b$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$90d10ce89a54f40b$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $90d10ce89a54f40b$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $90d10ce89a54f40b$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $90d10ce89a54f40b$export$2e2bcd8739ae039 = $90d10ce89a54f40b$var$memoizeOne;






var $1eVGO = parcelRequire("1eVGO");

// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var $3a234a709e943cf8$var$hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var $3a234a709e943cf8$var$now = $3a234a709e943cf8$var$hasNativePerformanceNow ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
function $3a234a709e943cf8$var$cancelTimeout(timeoutID) {
    cancelAnimationFrame(timeoutID.id);
}
function $3a234a709e943cf8$var$requestTimeout(callback, delay) {
    var start = $3a234a709e943cf8$var$now();
    function tick() {
        if ($3a234a709e943cf8$var$now() - start >= delay) callback.call(null);
        else timeoutID.id = requestAnimationFrame(tick);
    }
    var timeoutID = {
        id: requestAnimationFrame(tick)
    };
    return timeoutID;
}
var $3a234a709e943cf8$var$size = -1; // This utility copied from "dom-helpers" package.
function $3a234a709e943cf8$var$getScrollbarSize(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($3a234a709e943cf8$var$size === -1 || recalculate) {
        var div = document.createElement('div');
        var style = div.style;
        style.width = '50px';
        style.height = '50px';
        style.overflow = 'scroll';
        document.body.appendChild(div);
        $3a234a709e943cf8$var$size = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    }
    return $3a234a709e943cf8$var$size;
}
var $3a234a709e943cf8$var$cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.
function $3a234a709e943cf8$var$getRTLOffsetType(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($3a234a709e943cf8$var$cachedRTLResult === null || recalculate) {
        var outerDiv = document.createElement('div');
        var outerStyle = outerDiv.style;
        outerStyle.width = '50px';
        outerStyle.height = '50px';
        outerStyle.overflow = 'scroll';
        outerStyle.direction = 'rtl';
        var innerDiv = document.createElement('div');
        var innerStyle = innerDiv.style;
        innerStyle.width = '100px';
        innerStyle.height = '100px';
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) $3a234a709e943cf8$var$cachedRTLResult = 'positive-descending';
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) $3a234a709e943cf8$var$cachedRTLResult = 'negative';
            else $3a234a709e943cf8$var$cachedRTLResult = 'positive-ascending';
        }
        document.body.removeChild(outerDiv);
        return $3a234a709e943cf8$var$cachedRTLResult;
    }
    return $3a234a709e943cf8$var$cachedRTLResult;
}
var $3a234a709e943cf8$var$IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
var $3a234a709e943cf8$var$defaultItemKey = function defaultItemKey(_ref) {
    var columnIndex = _ref.columnIndex, data = _ref.data, rowIndex = _ref.rowIndex;
    return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $3a234a709e943cf8$var$devWarningsOverscanCount = null;
var $3a234a709e943cf8$var$devWarningsOverscanRowsColumnsCount = null;
var $3a234a709e943cf8$var$devWarningsTagName = null;
function $3a234a709e943cf8$var$createGridComponent(_ref2) {
    var _class;
    var getColumnOffset = _ref2.getColumnOffset, getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset, getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex, getColumnWidth = _ref2.getColumnWidth, getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight, getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth, getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment, getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment, getRowHeight = _ref2.getRowHeight, getRowOffset = _ref2.getRowOffset, getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset, getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex, initInstanceProps = _ref2.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref2.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $cgTkH.default)(Grid, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function Grid(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $fPHWO.default)(_this));
            _this._resetIsScrollingTimeoutId = null;
            _this._outerRef = void 0;
            _this.state = {
                instance: (0, $fPHWO.default)(_this),
                isScrolling: false,
                horizontalScrollDirection: 'forward',
                scrollLeft: typeof _this.props.initialScrollLeft === 'number' ? _this.props.initialScrollLeft : 0,
                scrollTop: typeof _this.props.initialScrollTop === 'number' ? _this.props.initialScrollTop : 0,
                scrollUpdateWasRequested: false,
                verticalScrollDirection: 'forward'
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $90d10ce89a54f40b$export$2e2bcd8739ae039)(function(overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
                return _this.props.onItemsRendered({
                    overscanColumnStartIndex: overscanColumnStartIndex,
                    overscanColumnStopIndex: overscanColumnStopIndex,
                    overscanRowStartIndex: overscanRowStartIndex,
                    overscanRowStopIndex: overscanRowStopIndex,
                    visibleColumnStartIndex: visibleColumnStartIndex,
                    visibleColumnStopIndex: visibleColumnStopIndex,
                    visibleRowStartIndex: visibleRowStartIndex,
                    visibleRowStopIndex: visibleRowStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $90d10ce89a54f40b$export$2e2bcd8739ae039)(function(scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    horizontalScrollDirection: horizontalScrollDirection,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    verticalScrollDirection: verticalScrollDirection,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(rowIndex, columnIndex) {
                var _this$props = _this.props, columnWidth = _this$props.columnWidth, direction = _this$props.direction, rowHeight = _this$props.rowHeight;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);
                var key = rowIndex + ":" + columnIndex;
                var style;
                if (itemStyleCache.hasOwnProperty(key)) style = itemStyleCache[key];
                else {
                    var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);
                    var isRtl = direction === 'rtl';
                    itemStyleCache[key] = style = {
                        position: 'absolute',
                        left: isRtl ? undefined : _offset,
                        right: isRtl ? _offset : undefined,
                        top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
                        height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
                        width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $90d10ce89a54f40b$export$2e2bcd8739ae039)(function(_, __, ___) {
                return {};
            });
            _this._onScroll = function(event) {
                var _event$currentTarget = event.currentTarget, clientHeight = _event$currentTarget.clientHeight, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop, scrollHeight = _event$currentTarget.scrollHeight, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    var calculatedScrollLeft = scrollLeft;
                    if (direction === 'rtl') switch($3a234a709e943cf8$var$getRTLOffsetType()){
                        case 'negative':
                            calculatedScrollLeft = -scrollLeft;
                            break;
                        case 'positive-descending':
                            calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
                    var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
                        scrollLeft: calculatedScrollLeft,
                        scrollTop: calculatedScrollTop,
                        verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward',
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === 'function') outerRef(ref);
                else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $3a234a709e943cf8$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $3a234a709e943cf8$var$requestTimeout(_this._resetIsScrolling, $3a234a709e943cf8$var$IS_SCROLLING_DEBOUNCE_INTERVAL);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1);
                });
            };
            return _this;
        }
        Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $3a234a709e943cf8$var$validateSharedProps(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = Grid.prototype;
        _proto.scrollTo = function scrollTo(_ref3) {
            var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
            if (scrollLeft !== undefined) scrollLeft = Math.max(0, scrollLeft);
            if (scrollTop !== undefined) scrollTop = Math.max(0, scrollTop);
            this.setState(function(prevState) {
                if (scrollLeft === undefined) scrollLeft = prevState.scrollLeft;
                if (scrollTop === undefined) scrollTop = prevState.scrollTop;
                if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) return null;
                return {
                    horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollUpdateWasRequested: true,
                    verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward'
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(_ref4) {
            var _ref4$align = _ref4.align, align = _ref4$align === void 0 ? 'auto' : _ref4$align, columnIndex = _ref4.columnIndex, rowIndex = _ref4.rowIndex;
            var _this$props2 = this.props, columnCount = _this$props2.columnCount, height = _this$props2.height, rowCount = _this$props2.rowCount, width = _this$props2.width;
            var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            var scrollbarSize = $3a234a709e943cf8$var$getScrollbarSize();
            if (columnIndex !== undefined) columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
            if (rowIndex !== undefined) rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
            // to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
            var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
            this.scrollTo({
                scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
                scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
            });
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, initialScrollLeft = _this$props3.initialScrollLeft, initialScrollTop = _this$props3.initialScrollTop;
            if (this._outerRef != null) {
                var outerRef = this._outerRef;
                if (typeof initialScrollLeft === 'number') outerRef.scrollLeft = initialScrollLeft;
                if (typeof initialScrollTop === 'number') outerRef.scrollTop = initialScrollTop;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var direction = this.props.direction;
            var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollTop = _this$state2.scrollTop, scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                // So we need to determine which browser behavior we're dealing with, and mimic it.
                var outerRef = this._outerRef;
                if (direction === 'rtl') switch($3a234a709e943cf8$var$getRTLOffsetType()){
                    case 'negative':
                        outerRef.scrollLeft = -scrollLeft;
                        break;
                    case 'positive-ascending':
                        outerRef.scrollLeft = scrollLeft;
                        break;
                    default:
                        var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                        outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                        break;
                }
                else outerRef.scrollLeft = Math.max(0, scrollLeft);
                outerRef.scrollTop = Math.max(0, scrollTop);
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $3a234a709e943cf8$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, columnCount = _this$props4.columnCount, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $3a234a709e943cf8$var$defaultItemKey : _this$props4$itemKey, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, rowCount = _this$props4.rowCount, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling;
            var _this$_getHorizontalR = this._getHorizontalRangeToRender(), columnStartIndex = _this$_getHorizontalR[0], columnStopIndex = _this$_getHorizontalR[1];
            var _this$_getVerticalRan = this._getVerticalRangeToRender(), rowStartIndex = _this$_getVerticalRan[0], rowStopIndex = _this$_getVerticalRan[1];
            var items = [];
            if (columnCount > 0 && rowCount) {
                for(var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++)for(var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++)items.push((0, $cozmU.createElement)(children, {
                    columnIndex: _columnIndex,
                    data: itemData,
                    isScrolling: useIsScrolling ? isScrolling : undefined,
                    key: itemKey({
                        columnIndex: _columnIndex,
                        data: itemData,
                        rowIndex: _rowIndex
                    }),
                    rowIndex: _rowIndex,
                    style: this._getItemStyle(_rowIndex, _columnIndex)
                }));
            } // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
            return (0, $cozmU.createElement)(outerElementType || outerTagName || 'div', {
                className: className,
                onScroll: this._onScroll,
                ref: this._outerRefSetter,
                style: (0, $eb3ax.default)({
                    position: 'relative',
                    height: height,
                    width: width,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform',
                    direction: direction
                }, style)
            }, (0, $cozmU.createElement)(innerElementType || innerTagName || 'div', {
                children: items,
                ref: innerRef,
                style: {
                    height: estimatedTotalHeight,
                    pointerEvents: isScrolling ? 'none' : undefined,
                    width: estimatedTotalWidth
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            var _this$props5 = this.props, columnCount = _this$props5.columnCount, onItemsRendered = _this$props5.onItemsRendered, onScroll = _this$props5.onScroll, rowCount = _this$props5.rowCount;
            if (typeof onItemsRendered === 'function') {
                if (columnCount > 0 && rowCount > 0) {
                    var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(), _overscanColumnStartIndex = _this$_getHorizontalR2[0], _overscanColumnStopIndex = _this$_getHorizontalR2[1], _visibleColumnStartIndex = _this$_getHorizontalR2[2], _visibleColumnStopIndex = _this$_getHorizontalR2[3];
                    var _this$_getVerticalRan2 = this._getVerticalRangeToRender(), _overscanRowStartIndex = _this$_getVerticalRan2[0], _overscanRowStopIndex = _this$_getVerticalRan2[1], _visibleRowStartIndex = _this$_getVerticalRan2[2], _visibleRowStopIndex = _this$_getVerticalRan2[3];
                    this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
                }
            }
            if (typeof onScroll === 'function') {
                var _this$state3 = this.state, _horizontalScrollDirection = _this$state3.horizontalScrollDirection, _scrollLeft = _this$state3.scrollLeft, _scrollTop = _this$state3.scrollTop, _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested, _verticalScrollDirection = _this$state3.verticalScrollDirection;
                this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
            var _this$props6 = this.props, columnCount = _this$props6.columnCount, overscanColumnCount = _this$props6.overscanColumnCount, overscanColumnsCount = _this$props6.overscanColumnsCount, overscanCount = _this$props6.overscanCount, rowCount = _this$props6.rowCount;
            var _this$state4 = this.state, horizontalScrollDirection = _this$state4.horizontalScrollDirection, isScrolling = _this$state4.isScrolling, scrollLeft = _this$state4.scrollLeft;
            var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
            var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || horizontalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || horizontalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
            var _this$props7 = this.props, columnCount = _this$props7.columnCount, overscanCount = _this$props7.overscanCount, overscanRowCount = _this$props7.overscanRowCount, overscanRowsCount = _this$props7.overscanRowsCount, rowCount = _this$props7.rowCount;
            var _this$state5 = this.state, isScrolling = _this$state5.isScrolling, verticalScrollDirection = _this$state5.verticalScrollDirection, scrollTop = _this$state5.scrollTop;
            var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
            var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || verticalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || verticalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return Grid;
    }((0, $cozmU.PureComponent)), _class.defaultProps = {
        direction: 'ltr',
        itemData: undefined,
        useIsScrolling: false
    }, _class;
}
var $3a234a709e943cf8$var$validateSharedProps = function validateSharedProps(_ref5, _ref6) {
    var children = _ref5.children, direction = _ref5.direction, height = _ref5.height, innerTagName = _ref5.innerTagName, outerTagName = _ref5.outerTagName, overscanColumnsCount = _ref5.overscanColumnsCount, overscanCount = _ref5.overscanCount, overscanRowsCount = _ref5.overscanRowsCount, width = _ref5.width;
    var instance = _ref6.instance;
};
var $3a234a709e943cf8$var$DEFAULT_ESTIMATED_ITEM_SIZE = 50;
var $3a234a709e943cf8$var$getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
    var rowCount = _ref.rowCount;
    var rowMetadataMap = _ref2.rowMetadataMap, estimatedRowHeight = _ref2.estimatedRowHeight, lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredRowIndex >= rowCount) lastMeasuredRowIndex = rowCount - 1;
    if (lastMeasuredRowIndex >= 0) {
        var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $3a234a709e943cf8$var$getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
    var columnCount = _ref3.columnCount;
    var columnMetadataMap = _ref4.columnMetadataMap, estimatedColumnWidth = _ref4.estimatedColumnWidth, lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredColumnIndex >= columnCount) lastMeasuredColumnIndex = columnCount - 1;
    if (lastMeasuredColumnIndex >= 0) {
        var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $3a234a709e943cf8$var$getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
    var itemMetadataMap, itemSize, lastMeasuredIndex;
    if (itemType === 'column') {
        itemMetadataMap = instanceProps.columnMetadataMap;
        itemSize = props.columnWidth;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        itemSize = props.rowHeight;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        if (itemType === 'column') instanceProps.lastMeasuredColumnIndex = index;
        else instanceProps.lastMeasuredRowIndex = index;
    }
    return itemMetadataMap[index];
};
var $3a234a709e943cf8$var$findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
    var itemMetadataMap, lastMeasuredIndex;
    if (itemType === 'column') {
        itemMetadataMap = instanceProps.columnMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $3a234a709e943cf8$var$findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $3a234a709e943cf8$var$findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $3a234a709e943cf8$var$findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $3a234a709e943cf8$var$getItemMetadata(itemType, props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $3a234a709e943cf8$var$findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
    var itemCount = itemType === 'column' ? props.columnCount : props.rowCount;
    var interval = 1;
    while(index < itemCount && $3a234a709e943cf8$var$getItemMetadata(itemType, props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $3a234a709e943cf8$var$findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $3a234a709e943cf8$var$getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var size = itemType === 'column' ? props.width : props.height;
    var itemMetadata = $3a234a709e943cf8$var$getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.
    var estimatedTotalSize = itemType === 'column' ? $3a234a709e943cf8$var$getEstimatedTotalWidth(props, instanceProps) : $3a234a709e943cf8$var$getEstimatedTotalHeight(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);
    if (align === 'smart') {
        if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
        else align = 'center';
    }
    switch(align){
        case 'start':
            return maxOffset;
        case 'end':
            return minOffset;
        case 'center':
            return Math.round(minOffset + (maxOffset - minOffset) / 2);
        case 'auto':
        default:
            if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
            else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
            // this value can be larger than maxOffset when at the end of the list
            return minOffset;
            else if (scrollOffset < minOffset) return minOffset;
            else return maxOffset;
    }
};
var $3a234a709e943cf8$export$32c206c84102e73c = /*#__PURE__*/ $3a234a709e943cf8$var$createGridComponent({
    getColumnOffset: function getColumnOffset(props, index, instanceProps) {
        return $3a234a709e943cf8$var$getItemMetadata('column', props, index, instanceProps).offset;
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
        return $3a234a709e943cf8$var$findNearestItem('column', props, instanceProps, scrollLeft);
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
        var columnCount = props.columnCount, width = props.width;
        var itemMetadata = $3a234a709e943cf8$var$getItemMetadata('column', props, startIndex, instanceProps);
        var maxOffset = scrollLeft + width;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < columnCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $3a234a709e943cf8$var$getItemMetadata('column', props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    getColumnWidth: function getColumnWidth(props, index, instanceProps) {
        return instanceProps.columnMetadataMap[index].size;
    },
    getEstimatedTotalHeight: $3a234a709e943cf8$var$getEstimatedTotalHeight,
    getEstimatedTotalWidth: $3a234a709e943cf8$var$getEstimatedTotalWidth,
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $3a234a709e943cf8$var$getOffsetForIndexAndAlignment('column', props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $3a234a709e943cf8$var$getOffsetForIndexAndAlignment('row', props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getRowOffset: function getRowOffset(props, index, instanceProps) {
        return $3a234a709e943cf8$var$getItemMetadata('row', props, index, instanceProps).offset;
    },
    getRowHeight: function getRowHeight(props, index, instanceProps) {
        return instanceProps.rowMetadataMap[index].size;
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
        return $3a234a709e943cf8$var$findNearestItem('row', props, instanceProps, scrollTop);
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
        var rowCount = props.rowCount, height = props.height;
        var itemMetadata = $3a234a709e943cf8$var$getItemMetadata('row', props, startIndex, instanceProps);
        var maxOffset = scrollTop + height;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < rowCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $3a234a709e943cf8$var$getItemMetadata('row', props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref5 = props, estimatedColumnWidth = _ref5.estimatedColumnWidth, estimatedRowHeight = _ref5.estimatedRowHeight;
        var instanceProps = {
            columnMetadataMap: {},
            estimatedColumnWidth: estimatedColumnWidth || $3a234a709e943cf8$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            estimatedRowHeight: estimatedRowHeight || $3a234a709e943cf8$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            lastMeasuredColumnIndex: -1,
            lastMeasuredRowIndex: -1,
            rowMetadataMap: {}
        };
        instance.resetAfterColumnIndex = function(columnIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                columnIndex: columnIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterRowIndex = function(rowIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                rowIndex: rowIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterIndices = function(_ref6) {
            var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex, _ref6$shouldForceUpda = _ref6.shouldForceUpdate, shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;
            if (typeof columnIndex === 'number') instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
            if (typeof rowIndex === 'number') instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
             // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref7) {
        var columnWidth = _ref7.columnWidth, rowHeight = _ref7.rowHeight;
    }
});
var $3a234a709e943cf8$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var $3a234a709e943cf8$var$defaultItemKey$1 = function defaultItemKey(index, data) {
    return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $3a234a709e943cf8$var$devWarningsDirection = null;
var $3a234a709e943cf8$var$devWarningsTagName$1 = null;
function $3a234a709e943cf8$var$createListComponent(_ref) {
    var _class;
    var getItemOffset = _ref.getItemOffset, getEstimatedTotalSize = _ref.getEstimatedTotalSize, getItemSize = _ref.getItemSize, getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset = _ref.getStartIndexForOffset, getStopIndexForStartIndex = _ref.getStopIndexForStartIndex, initInstanceProps = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $cgTkH.default)(List, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function List(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $fPHWO.default)(_this));
            _this._outerRef = void 0;
            _this._resetIsScrollingTimeoutId = null;
            _this.state = {
                instance: (0, $fPHWO.default)(_this),
                isScrolling: false,
                scrollDirection: 'forward',
                scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
                scrollUpdateWasRequested: false
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $90d10ce89a54f40b$export$2e2bcd8739ae039)(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
                return _this.props.onItemsRendered({
                    overscanStartIndex: overscanStartIndex,
                    overscanStopIndex: overscanStopIndex,
                    visibleStartIndex: visibleStartIndex,
                    visibleStopIndex: visibleStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $90d10ce89a54f40b$export$2e2bcd8739ae039)(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    scrollDirection: scrollDirection,
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(index) {
                var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
                var style;
                if (itemStyleCache.hasOwnProperty(index)) style = itemStyleCache[index];
                else {
                    var _offset = getItemOffset(_this.props, index, _this._instanceProps);
                    var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"
                    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
                    var isRtl = direction === 'rtl';
                    var offsetHorizontal = isHorizontal ? _offset : 0;
                    itemStyleCache[index] = style = {
                        position: 'absolute',
                        left: isRtl ? undefined : offsetHorizontal,
                        right: isRtl ? offsetHorizontal : undefined,
                        top: !isHorizontal ? _offset : 0,
                        height: !isHorizontal ? size : '100%',
                        width: isHorizontal ? size : '100%'
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $90d10ce89a54f40b$export$2e2bcd8739ae039)(function(_, __, ___) {
                return {};
            });
            _this._onScrollHorizontal = function(event) {
                var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollLeft) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction;
                    var scrollOffset = scrollLeft;
                    if (direction === 'rtl') // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    switch($3a234a709e943cf8$var$getRTLOffsetType()){
                        case 'negative':
                            scrollOffset = -scrollLeft;
                            break;
                        case 'positive-descending':
                            scrollOffset = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._onScrollVertical = function(event) {
                var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === 'function') outerRef(ref);
                else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $3a234a709e943cf8$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $3a234a709e943cf8$var$requestTimeout(_this._resetIsScrolling, $3a234a709e943cf8$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1, null);
                });
            };
            return _this;
        }
        List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $3a234a709e943cf8$var$validateSharedProps$1(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = List.prototype;
        _proto.scrollTo = function scrollTo(scrollOffset) {
            scrollOffset = Math.max(0, scrollOffset);
            this.setState(function(prevState) {
                if (prevState.scrollOffset === scrollOffset) return null;
                return {
                    scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: true
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(index, align) {
            if (align === void 0) align = 'auto';
            var _this$props2 = this.props, itemCount = _this$props2.itemCount, layout = _this$props2.layout;
            var scrollOffset = this.state.scrollOffset;
            index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            // This is an edge case for lists; normally they only scroll in the dominant direction.
            var scrollbarSize = 0;
            if (this._outerRef) {
                var outerRef = this._outerRef;
                if (layout === 'vertical') scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? $3a234a709e943cf8$var$getScrollbarSize() : 0;
                else scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? $3a234a709e943cf8$var$getScrollbarSize() : 0;
            }
            this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, direction = _this$props3.direction, initialScrollOffset = _this$props3.initialScrollOffset, layout = _this$props3.layout;
            if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === 'horizontal' || layout === 'horizontal') outerRef.scrollLeft = initialScrollOffset;
                else outerRef.scrollTop = initialScrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var _this$props4 = this.props, direction = _this$props4.direction, layout = _this$props4.layout;
            var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === 'horizontal' || layout === 'horizontal') {
                    if (direction === 'rtl') // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // So we need to determine which browser behavior we're dealing with, and mimic it.
                    switch($3a234a709e943cf8$var$getRTLOffsetType()){
                        case 'negative':
                            outerRef.scrollLeft = -scrollOffset;
                            break;
                        case 'positive-ascending':
                            outerRef.scrollLeft = scrollOffset;
                            break;
                        default:
                            var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                            outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                            break;
                    }
                    else outerRef.scrollLeft = scrollOffset;
                } else outerRef.scrollTop = scrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $3a234a709e943cf8$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props5 = this.props, children = _this$props5.children, className = _this$props5.className, direction = _this$props5.direction, height = _this$props5.height, innerRef = _this$props5.innerRef, innerElementType = _this$props5.innerElementType, innerTagName = _this$props5.innerTagName, itemCount = _this$props5.itemCount, itemData = _this$props5.itemData, _this$props5$itemKey = _this$props5.itemKey, itemKey = _this$props5$itemKey === void 0 ? $3a234a709e943cf8$var$defaultItemKey$1 : _this$props5$itemKey, layout = _this$props5.layout, outerElementType = _this$props5.outerElementType, outerTagName = _this$props5.outerTagName, style = _this$props5.style, useIsScrolling = _this$props5.useIsScrolling, width = _this$props5.width;
            var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"
            var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
            var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
            var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
            var items = [];
            if (itemCount > 0) for(var _index = startIndex; _index <= stopIndex; _index++)items.push((0, $cozmU.createElement)(children, {
                data: itemData,
                key: itemKey(_index, itemData),
                index: _index,
                isScrolling: useIsScrolling ? isScrolling : undefined,
                style: this._getItemStyle(_index)
            }));
             // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
            return (0, $cozmU.createElement)(outerElementType || outerTagName || 'div', {
                className: className,
                onScroll: onScroll,
                ref: this._outerRefSetter,
                style: (0, $eb3ax.default)({
                    position: 'relative',
                    height: height,
                    width: width,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform',
                    direction: direction
                }, style)
            }, (0, $cozmU.createElement)(innerElementType || innerTagName || 'div', {
                children: items,
                ref: innerRef,
                style: {
                    height: isHorizontal ? '100%' : estimatedTotalSize,
                    pointerEvents: isScrolling ? 'none' : undefined,
                    width: isHorizontal ? estimatedTotalSize : '100%'
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            if (typeof this.props.onItemsRendered === 'function') {
                var itemCount = this.props.itemCount;
                if (itemCount > 0) {
                    var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
                    this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
                }
            }
            if (typeof this.props.onScroll === 'function') {
                var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
                this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getRangeToRender = function _getRangeToRender() {
            var _this$props6 = this.props, itemCount = _this$props6.itemCount, overscanCount = _this$props6.overscanCount;
            var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
            if (itemCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
            var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
            var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return List;
    }((0, $cozmU.PureComponent)), _class.defaultProps = {
        direction: 'ltr',
        itemData: undefined,
        layout: 'vertical',
        overscanCount: 2,
        useIsScrolling: false
    }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.
var $3a234a709e943cf8$var$validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
    var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
    var instance = _ref3.instance;
    var isHorizontal;
};
var $3a234a709e943cf8$var$DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var $3a234a709e943cf8$var$getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
    var _ref = props, itemSize = _ref.itemSize;
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        instanceProps.lastMeasuredIndex = index;
    }
    return itemMetadataMap[index];
};
var $3a234a709e943cf8$var$findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $3a234a709e943cf8$var$findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $3a234a709e943cf8$var$findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $3a234a709e943cf8$var$findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $3a234a709e943cf8$var$getItemMetadata$1(props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $3a234a709e943cf8$var$findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
    var itemCount = props.itemCount;
    var interval = 1;
    while(index < itemCount && $3a234a709e943cf8$var$getItemMetadata$1(props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $3a234a709e943cf8$var$findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $3a234a709e943cf8$var$getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
    var itemCount = _ref2.itemCount;
    var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
    var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredIndex >= itemCount) lastMeasuredIndex = itemCount - 1;
    if (lastMeasuredIndex >= 0) {
        var itemMetadata = itemMetadataMap[lastMeasuredIndex];
        totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
    return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var $3a234a709e943cf8$export$d8ac3b6b20be856e = /*#__PURE__*/ $3a234a709e943cf8$var$createListComponent({
    getItemOffset: function getItemOffset(props, index, instanceProps) {
        return $3a234a709e943cf8$var$getItemMetadata$1(props, index, instanceProps).offset;
    },
    getItemSize: function getItemSize(props, index, instanceProps) {
        return instanceProps.itemMetadataMap[index].size;
    },
    getEstimatedTotalSize: $3a234a709e943cf8$var$getEstimatedTotalSize,
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = props.direction, height = props.height, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var itemMetadata = $3a234a709e943cf8$var$getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
        // To ensure it reflects actual measurements instead of just estimates.
        var estimatedTotalSize = $3a234a709e943cf8$var$getEstimatedTotalSize(props, instanceProps);
        var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
        var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size + scrollbarSize);
        if (align === 'smart') {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                return Math.round(minOffset + (maxOffset - minOffset) / 2);
            case 'auto':
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
        return $3a234a709e943cf8$var$findNearestItem$1(props, instanceProps, offset);
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var itemMetadata = $3a234a709e943cf8$var$getItemMetadata$1(props, startIndex, instanceProps);
        var maxOffset = scrollOffset + size;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < itemCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $3a234a709e943cf8$var$getItemMetadata$1(props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
        var instanceProps = {
            itemMetadataMap: {},
            estimatedItemSize: estimatedItemSize || $3a234a709e943cf8$var$DEFAULT_ESTIMATED_ITEM_SIZE$1,
            lastMeasuredIndex: -1
        };
        instance.resetAfterIndex = function(index, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref5) {
        var itemSize = _ref5.itemSize;
    }
});
var $3a234a709e943cf8$export$f331158cccad7361 = /*#__PURE__*/ $3a234a709e943cf8$var$createGridComponent({
    getColumnOffset: function getColumnOffset(_ref, index) {
        var columnWidth = _ref.columnWidth;
        return index * columnWidth;
    },
    getColumnWidth: function getColumnWidth(_ref2, index) {
        var columnWidth = _ref2.columnWidth;
        return columnWidth;
    },
    getRowOffset: function getRowOffset(_ref3, index) {
        var rowHeight = _ref3.rowHeight;
        return index * rowHeight;
    },
    getRowHeight: function getRowHeight(_ref4, index) {
        var rowHeight = _ref4.rowHeight;
        return rowHeight;
    },
    getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
        var rowCount = _ref5.rowCount, rowHeight = _ref5.rowHeight;
        return rowHeight * rowCount;
    },
    getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
        var columnCount = _ref6.columnCount, columnWidth = _ref6.columnWidth;
        return columnWidth * columnCount;
    },
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
        var columnCount = _ref7.columnCount, columnWidth = _ref7.columnWidth, width = _ref7.width;
        var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
        var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
        var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);
        if (align === 'smart') {
            if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(width / 2)) return 0; // near the beginning
                else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) return lastColumnOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollLeft >= minOffset && scrollLeft <= maxOffset) return scrollLeft;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollLeft < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
        var rowHeight = _ref8.rowHeight, height = _ref8.height, rowCount = _ref8.rowCount;
        var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
        var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
        var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);
        if (align === 'smart') {
            if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(height / 2)) return 0; // near the beginning
                else if (middleOffset > lastRowOffset + Math.floor(height / 2)) return lastRowOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollTop >= minOffset && scrollTop <= maxOffset) return scrollTop;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollTop < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
        var columnWidth = _ref9.columnWidth, columnCount = _ref9.columnCount;
        return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
        var columnWidth = _ref10.columnWidth, columnCount = _ref10.columnCount, width = _ref10.width;
        var left = startIndex * columnWidth;
        var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
        return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
        ));
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
        var rowHeight = _ref11.rowHeight, rowCount = _ref11.rowCount;
        return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
        var rowHeight = _ref12.rowHeight, rowCount = _ref12.rowCount, height = _ref12.height;
        var top = startIndex * rowHeight;
        var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
        return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref13) {
        var columnWidth = _ref13.columnWidth, rowHeight = _ref13.rowHeight;
    }
});
var $3a234a709e943cf8$export$ae9e55e1d8a2f4b7 = /*#__PURE__*/ $3a234a709e943cf8$var$createListComponent({
    getItemOffset: function getItemOffset(_ref, index) {
        var itemSize = _ref.itemSize;
        return index * itemSize;
    },
    getItemSize: function getItemSize(_ref2, index) {
        var itemSize = _ref2.itemSize;
        return itemSize;
    },
    getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
        var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
        return itemSize * itemCount;
    },
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var lastItemOffset = Math.max(0, itemCount * itemSize - size);
        var maxOffset = Math.min(lastItemOffset, index * itemSize);
        var minOffset = Math.max(0, index * itemSize - size + itemSize + scrollbarSize);
        if (align === 'smart') {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(size / 2)) return 0; // near the beginning
                else if (middleOffset > lastItemOffset + Math.floor(size / 2)) return lastItemOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
        var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
        return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
        var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var offset = startIndex * itemSize;
        var size = isHorizontal ? width : height;
        var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
        return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref7) {
        var itemSize = _ref7.itemSize;
    }
});
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function $3a234a709e943cf8$var$shallowDiffers(prev, next) {
    for(var attribute in prev){
        if (!(attribute in next)) return true;
    }
    for(var _attribute in next){
        if (prev[_attribute] !== next[_attribute]) return true;
    }
    return false;
}
var $3a234a709e943cf8$var$_excluded = [
    "style"
], $3a234a709e943cf8$var$_excluded2 = [
    "style"
];
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo
function $3a234a709e943cf8$export$b141efd0b0fb9174(prevProps, nextProps) {
    var prevStyle = prevProps.style, prevRest = (0, $1eVGO.default)(prevProps, $3a234a709e943cf8$var$_excluded);
    var nextStyle = nextProps.style, nextRest = (0, $1eVGO.default)(nextProps, $3a234a709e943cf8$var$_excluded2);
    return !$3a234a709e943cf8$var$shallowDiffers(prevStyle, nextStyle) && !$3a234a709e943cf8$var$shallowDiffers(prevRest, nextRest);
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate
function $3a234a709e943cf8$export$aa365c903ed149ff(nextProps, nextState) {
    return !$3a234a709e943cf8$export$b141efd0b0fb9174(this.props, nextProps) || $3a234a709e943cf8$var$shallowDiffers(this.state, nextState);
}
 //# sourceMappingURL=index.esm.js.map












var $55fM8 = parcelRequire("55fM8");


var $cK21K = parcelRequire("cK21K");


var $jp2Q3 = parcelRequire("jp2Q3");





var $w6R6I = parcelRequire("w6R6I");





var $hSqtY = parcelRequire("hSqtY");

const $1248c59454548f36$export$37d1385b51ab57d = 32;
const $1248c59454548f36$export$64bdf88fbfd838fe = 16;
const $1248c59454548f36$export$6bba9ddbe7f71bbe = 82;
const $1248c59454548f36$export$c61afba3696e8231 = (previewRect, hoverItemRect)=>{
    const { scrollY: scrollY, innerHeight: innerHeight } = window;
    const previewLeftPosition = hoverItemRect.left - previewRect.width - $1248c59454548f36$export$37d1385b51ab57d;
    const hoverItemCenter = hoverItemRect.top + hoverItemRect.height / 2;
    const previewCenter = previewRect.height / 2;
    const previewTopPosition = scrollY + (hoverItemCenter - previewCenter);
    const maxTopPosition = scrollY + innerHeight - $1248c59454548f36$export$64bdf88fbfd838fe - previewRect.height;
    if (previewTopPosition > maxTopPosition) return {
        top: maxTopPosition,
        left: previewLeftPosition
    };
    const minTopPosition = scrollY + $1248c59454548f36$export$6bba9ddbe7f71bbe + $1248c59454548f36$export$64bdf88fbfd838fe;
    if (previewTopPosition < minTopPosition) return {
        top: minTopPosition,
        left: previewLeftPosition
    };
    return {
        top: previewTopPosition,
        left: previewLeftPosition
    };
};


















var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");


var $67NtX = parcelRequire("67NtX");

const $f7834430d91b24b7$var$PREVIEW_WIDTH_VW = '40vw';
const $f7834430d91b24b7$var$PREVIEW_MAX_WIDTH_PX = 1000;
const $f7834430d91b24b7$var$PREVIEW_MIN_WIDTH_PX = 480;
const $f7834430d91b24b7$var$PREVIEW_MAX_HEIGHT_VW = '60vh';
const $f7834430d91b24b7$var$PREVIEW_PADDING = "var(--ds-space-200, 16px)";
const $f7834430d91b24b7$var$styles = {
    container: "_4FKVYE5zaO _0bjKvD8fU6 _39xV02Fvff _1EqgXl0Qmj _4ouGXIOm3a _0NUa3rCNRn _4kiQYAgZxp _0KLXrulfZc _2OUyjtGk8v _3iDTPbQ4SZ _0aFT5vbt8w _02iE7ZYbGa",
    header: "_2Y7lL41Y8M _1x1D3gOeNX _1wydGW8HPE",
    previewWrapper: "_4bt5LAnQyn _2WAcuGnQyn _4c065U2ADO _3iDTPbQ4SZ _37wbyuDIqT _2O5Vij7dHp _3YEZNO7dHp _0jFU0VWOll",
    name: "_2sNsIgEqul _4bt5LAnQyn _2WAcuGnQyn _1kk5Tkf7mX _39HuIbz8Lp _3iDTPbgJ9S _1U1ZhbbI28 _4Gn54R7LI7"
};
const $f7834430d91b24b7$var$SnippetInfo = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { snippet: snippet } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $f7834430d91b24b7$var$styles.header
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== snippet.name) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "h2",
            xcss: $f7834430d91b24b7$var$styles.name
        }, snippet.name);
        $[1] = snippet.name;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== snippet.description) {
        t3 = snippet.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            size: "small",
            maxLines: 2
        }, snippet.description);
        $[3] = snippet.description;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "snippet-info",
            className: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t2, t3));
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};
const $f7834430d91b24b7$export$70af21b1b3f189cb = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { snippet: snippet } = t0;
    const widthBeforeMinimum = `min(${$f7834430d91b24b7$var$PREVIEW_WIDTH_VW}, ${$f7834430d91b24b7$var$PREVIEW_MAX_WIDTH_PX}px)`;
    const previewWrapperWidth = `max(${widthBeforeMinimum}, ${$f7834430d91b24b7$var$PREVIEW_MIN_WIDTH_PX}px)`;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $f7834430d91b24b7$var$styles.container
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== snippet) {
        t2 = snippet && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7834430d91b24b7$var$SnippetInfo, {
            snippet: snippet
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $f7834430d91b24b7$var$styles.previewWrapper
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67NtX.SnippetPreview), {
            snippet: snippet,
            dimensions: {
                width: previewWrapperWidth,
                maxHeight: $f7834430d91b24b7$var$PREVIEW_MAX_HEIGHT_VW
            },
            renderWidth: 800,
            loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                size: "large"
            })
        })));
        $[1] = snippet;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, t2);
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};


const $a95239449d7ef54f$var$HIDE_TIMEOUT = 250;
const $a95239449d7ef54f$var$RENDER_DEBOUNCE_TIME = 80;
const $a95239449d7ef54f$var$styles = {
    previewBox: "_1mT5xdy1CL",
    hidden: "_1YKVNsdnbC _1pp6NdYbGa"
};
const $a95239449d7ef54f$var$SnippetPopupPreviewContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    showPreview: ()=>{},
    hidePreview: ()=>{}
});
const $a95239449d7ef54f$export$eb5bcab93fe60d7 = ()=>{
    return (0, $cozmU.useContext)($a95239449d7ef54f$var$SnippetPopupPreviewContext);
};
const $a95239449d7ef54f$export$59de135692368d24 = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { children: children } = t0;
    const previewRef = (0, $cozmU.useRef)(null);
    const { currentSnippet: currentSnippet, position: position, resumePreview: resumePreview, showPreview: showPreview, hidePreview: hidePreview, shouldShowPopup: shouldShowPopup } = $a95239449d7ef54f$var$useSnippetPopupPreviewController(previewRef);
    let t1;
    if ($[0] !== hidePreview || $[1] !== showPreview) {
        t1 = {
            showPreview: showPreview,
            hidePreview: hidePreview
        };
        $[0] = hidePreview;
        $[1] = showPreview;
        $[2] = t1;
    } else t1 = $[2];
    const contextValue = t1;
    const t2 = (!currentSnippet || !shouldShowPopup) && $a95239449d7ef54f$var$styles.hidden;
    let t3;
    if ($[3] !== t2) {
        t3 = (0, $w6R6I.cx)($a95239449d7ef54f$var$styles.previewBox, t2);
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = position?.top ?? 0;
    const t5 = position?.left ?? 0;
    const t6 = shouldShowPopup ? 1 : 0;
    const t7 = shouldShowPopup ? "top 250ms linear, left 250ms linear, height 1000ms linear, opacity 100ms linear" : "none";
    let t8;
    if ($[5] !== t4 || $[6] !== t5 || $[7] !== t6 || $[8] !== t7) {
        t8 = {
            top: t4,
            left: t5,
            opacity: t6,
            transition: t7
        };
        $[5] = t4;
        $[6] = t5;
        $[7] = t6;
        $[8] = t7;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== currentSnippet) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7834430d91b24b7$export$70af21b1b3f189cb), {
            snippet: currentSnippet
        });
        $[10] = currentSnippet;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== hidePreview || $[13] !== resumePreview || $[14] !== t3 || $[15] !== t8 || $[16] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
            zIndex: (0, $jp2Q3.layers).modal() - 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: previewRef,
            onMouseEnter: resumePreview,
            onMouseLeave: hidePreview,
            xcss: t3,
            style: t8
        }, t9)));
        $[12] = hidePreview;
        $[13] = resumePreview;
        $[14] = t3;
        $[15] = t8;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== children || $[19] !== contextValue || $[20] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a95239449d7ef54f$var$SnippetPopupPreviewContext.Provider, {
            value: contextValue
        }, t10, children);
        $[18] = children;
        $[19] = contextValue;
        $[20] = t10;
        $[21] = t11;
    } else t11 = $[21];
    return t11;
};
const $a95239449d7ef54f$var$useSnippetPopupPreviewController = (previewRef)=>{
    const $ = (0, $bDgLe.c)(20);
    const [currentSnippet, setCurrentSnippet] = (0, $cozmU.useState)();
    const [itemRect, setItemRect] = (0, $cozmU.useState)();
    const [position, setPosition] = (0, $cozmU.useState)();
    const [shouldShowPopup, setShouldShowPopup] = (0, $cozmU.useState)(false);
    const hideTimeout = (0, $cozmU.useRef)();
    const prevPositionRef = (0, $cozmU.useRef)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((snippet, rect)=>{
            setCurrentSnippet(snippet);
            setItemRect(rect);
        }, $a95239449d7ef54f$var$RENDER_DEBOUNCE_TIME);
        $[0] = t0;
    } else t0 = $[0];
    const debouncedSetSnippet = t0;
    let t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>()=>{
                debouncedSetSnippet.cancel();
                clearTimeout(hideTimeout.current);
            };
        t2 = [
            debouncedSetSnippet
        ];
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[3] !== currentSnippet || $[4] !== itemRect || $[5] !== previewRef) {
        t3 = ()=>{
            let frame;
            if (currentSnippet && previewRef.current && itemRect) {
                const newPosition = (0, $1248c59454548f36$export$c61afba3696e8231)(previewRef.current.getBoundingClientRect(), itemRect);
                setPosition(newPosition);
                if (!prevPositionRef.current) frame = requestAnimationFrame(()=>{
                    setShouldShowPopup(true);
                });
                prevPositionRef.current = newPosition;
            }
            return ()=>{
                if (frame) cancelAnimationFrame(frame);
            };
        };
        t4 = [
            currentSnippet,
            previewRef,
            itemRect
        ];
        $[3] = currentSnippet;
        $[4] = itemRect;
        $[5] = previewRef;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            clearTimeout(hideTimeout.current);
            hideTimeout.current = undefined;
        };
        $[8] = t5;
    } else t5 = $[8];
    const resumePreview = t5;
    let t6;
    if ($[9] !== currentSnippet) {
        t6 = (snippet_0, rect_0)=>{
            resumePreview();
            const isSameSnippet = currentSnippet && currentSnippet.snippetId === snippet_0.snippetId;
            if (isSameSnippet) return;
            debouncedSetSnippet(snippet_0, rect_0);
        };
        $[9] = currentSnippet;
        $[10] = t6;
    } else t6 = $[10];
    const showPreview = t6;
    let t7;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            if (hideTimeout.current) return;
            hideTimeout.current = window.setTimeout(()=>{
                setCurrentSnippet(undefined);
                setItemRect(undefined);
                setPosition(undefined);
                setShouldShowPopup(false);
                hideTimeout.current = undefined;
                prevPositionRef.current = undefined;
            }, $a95239449d7ef54f$var$HIDE_TIMEOUT);
        };
        $[11] = t7;
    } else t7 = $[11];
    const hidePreview = t7;
    let t8;
    let t9;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            window.addEventListener("resize", hidePreview);
            return ()=>window.removeEventListener("resize", hidePreview);
        };
        t9 = [];
        $[12] = t8;
        $[13] = t9;
    } else {
        t8 = $[12];
        t9 = $[13];
    }
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    if ($[14] !== currentSnippet || $[15] !== itemRect || $[16] !== position || $[17] !== shouldShowPopup || $[18] !== showPreview) {
        t10 = {
            currentSnippet: currentSnippet,
            position: position,
            itemRect: itemRect,
            resumePreview: resumePreview,
            showPreview: showPreview,
            hidePreview: hidePreview,
            shouldShowPopup: shouldShowPopup
        };
        $[14] = currentSnippet;
        $[15] = itemRect;
        $[16] = position;
        $[17] = shouldShowPopup;
        $[18] = showPreview;
        $[19] = t10;
    } else t10 = $[19];
    return t10;
};












var $4vyVB = parcelRequire("4vyVB");























var $3k5Tv = parcelRequire("3k5Tv");




const $83ffa14fb3047ba9$export$837dc1b65006c6b6 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    const { editorAPI: editorAPI } = (0, $cozmU.useContext)((0, $4oS56.EditorContextPanelContext));
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "editorViewMode"
        ];
        $[0] = t0;
    } else t0 = $[0];
    return (0, $3k5Tv.useSharedPluginStateWithSelector)(editorAPI, t0, $83ffa14fb3047ba9$var$_temp);
};
function $83ffa14fb3047ba9$var$_temp(states) {
    return states.editorViewModeState?.mode === "view";
}



var $b5pIV = parcelRequire("b5pIV");


var $5QVmU = parcelRequire("5QVmU");


var $aUBmi = parcelRequire("aUBmi");





var $2esFu = parcelRequire("2esFu");














const $2f30b999496548c4$var$PREVIEW_WIDTH = 140;
const $2f30b999496548c4$var$PREVIEW_HEIGHT = 80;
const $2f30b999496548c4$var$PREVIEW_PADDING_BLOCK = "var(--ds-space-075, 6px)";
const $2f30b999496548c4$var$PREVIEW_PADDING_INLINE = "var(--ds-space-100, 8px)";
const $2f30b999496548c4$var$styles = {
    preview: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _30huDKOeNX _4c065UgVvo _2Y7lL42ADO _39xV02Vazu _4ouGXIVazu _0jFU0VljYU _0KLXrulfZc _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
const $2f30b999496548c4$export$3c7fb5dd83e912af = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2f30b999496548c4$var$styles.preview
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $2f30b999496548c4$export$6905b264b4feca39 = {
    width: $2f30b999496548c4$var$PREVIEW_WIDTH,
    height: $2f30b999496548c4$var$PREVIEW_HEIGHT,
    paddingBlock: $2f30b999496548c4$var$PREVIEW_PADDING_BLOCK,
    paddingInline: $2f30b999496548c4$var$PREVIEW_PADDING_INLINE
};















var $1l0kj = parcelRequire("1l0kj");


var $kh0hi = parcelRequire("kh0hi");

const $d403889bed2f9ddb$export$1049486e8aafa787 = 100;
const $d403889bed2f9ddb$var$styles = {
    cardWrapper: "_1mT5xdRAKS _3iDTPbQ4SZ _39xV02N91d _0jFU0VQEt6 _0KLXrujOvk _1eOmH6d1Zr",
    cardWrapperActive: "_0KLXrud1Zr",
    cardButtonOverlay: "_4FKVYEPgdg _1mT5xdWVPG _2IhTonPgdg _4ApkO2Pgdg _0Bm75GPgdg _3OE6xYPgdg _0KLXrujOvk _2fwxA5ecOK",
    cardContentLayer: "_2Y7lL4NHnM _1mT5xdRAKS _39xV02N91d _42Yu6B7dHp _1pp6NdYbGa"
};
const $d403889bed2f9ddb$export$54967bd28cc7e35 = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { children: children, onClick: onClick, ariaLabel: ariaLabel, testId: testId, isActive: t1, isDisabled: t2, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = t0;
    const isActive = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const t3 = isActive && $d403889bed2f9ddb$var$styles.cardWrapperActive;
    let t4;
    if ($[0] !== t3) {
        t4 = (0, $w6R6I.cx)($d403889bed2f9ddb$var$styles.cardWrapper, t3);
        $[0] = t3;
        $[1] = t4;
    } else t4 = $[1];
    const t5 = `${testId}-card-wrapper`;
    let t6;
    if ($[2] !== ariaLabel || $[3] !== isDisabled || $[4] !== onClick || $[5] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            xcss: $d403889bed2f9ddb$var$styles.cardButtonOverlay,
            onClick: onClick,
            testId: testId,
            "aria-label": ariaLabel,
            isDisabled: isDisabled
        });
        $[2] = ariaLabel;
        $[3] = isDisabled;
        $[4] = onClick;
        $[5] = testId;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== children) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $d403889bed2f9ddb$var$styles.cardContentLayer,
            alignInline: "start",
            alignBlock: "center",
            space: "space.200"
        }, children);
        $[7] = children;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== onMouseEnter || $[10] !== onMouseLeave || $[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t4,
            testId: t5,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        }, t6, t7);
        $[9] = onMouseEnter;
        $[10] = onMouseLeave;
        $[11] = t4;
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
};





const $4ae988fb1c767900$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    snippetCardAriaLabel: {
        id: "snippets.panel.item.card.aria-label",
        defaultMessage: "Block Template: {name}"
    },
    snippetPreview: {
        id: "snippets.panel.item.preview",
        defaultMessage: "Preview"
    }
});












var $I7hWB = parcelRequire("I7hWB");

















var $bL1ca = parcelRequire("bL1ca");


var $6ATU7 = parcelRequire("6ATU7");


var $f3452 = parcelRequire("f3452");


var $dh4hm = parcelRequire("dh4hm");


var $jffWD = parcelRequire("jffWD");

const $e911f5425d517b68$var$contentStyles = {
    upperContainer: "_1bHrqE4cDz",
    titleContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2fwxA5ecOK",
    titleContainerFilled: "_39xV02N91d",
    actionsContainer: "_1pp6NdIZbP _3YEZNOdnbC"
};
const $e911f5425d517b68$export$30e00acfcf43753a = (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { snippet: snippet, isHovered: isHovered, showActions: showActions, showPanelActions: showPanelActions, onMenuOpenChange: onMenuOpenChange, contentId: contentId, spaceId: spaceId, spaceKey: spaceKey } = t0;
    const analyticsOrigin = (0, $hPTbh.ANALYTICS_ORIGIN).SNIPPET_PANEL;
    const shouldFillContainer = !isHovered;
    let t1;
    if ($[0] !== snippet) {
        t1 = (0, $jffWD.shouldShowUsageAndPrivateLabels)(snippet);
        $[0] = snippet;
        $[1] = t1;
    } else t1 = $[1];
    const showUsageAndPrivateLabels = t1;
    const t2 = shouldFillContainer && $e911f5425d517b68$var$contentStyles.titleContainerFilled;
    let t3;
    if ($[2] !== t2) {
        t3 = (0, $w6R6I.cx)($e911f5425d517b68$var$contentStyles.titleContainer, t2);
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== snippet.name) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: 2,
            weight: "bold"
        }, snippet.name));
        $[4] = snippet.name;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t3
        }, t4);
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== contentId || $[10] !== isHovered || $[11] !== onMenuOpenChange || $[12] !== showActions || $[13] !== showPanelActions || $[14] !== snippet || $[15] !== spaceId || $[16] !== spaceKey) {
        t6 = showActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $e911f5425d517b68$var$contentStyles.actionsContainer,
            alignBlock: "center",
            space: "space.050"
        }, showPanelActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bL1ca.SnippetMoreActions), {
            analyticsOrigin: analyticsOrigin,
            snippet: snippet,
            isHovered: isHovered,
            onMenuOpenChange: onMenuOpenChange,
            contentId: contentId,
            spaceId: spaceId,
            spaceKey: spaceKey
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f3452.SnippetFavoriteButton), {
            analyticsOrigin: analyticsOrigin,
            snippet: snippet,
            isHovered: isHovered
        }));
        $[9] = contentId;
        $[10] = isHovered;
        $[11] = onMenuOpenChange;
        $[12] = showActions;
        $[13] = showPanelActions;
        $[14] = snippet;
        $[15] = spaceId;
        $[16] = spaceKey;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== t5 || $[19] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $e911f5425d517b68$var$contentStyles.upperContainer,
            alignBlock: "center",
            space: "space.050",
            grow: "fill"
        }, t5, t6);
        $[18] = t5;
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== snippet.createdBy) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ATU7.SnippetCreatedByAvatar), {
            snippetOwner: snippet.createdBy
        });
        $[21] = snippet.createdBy;
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[23] !== snippet.createdBy.displayName) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 1
        }, snippet.createdBy.displayName);
        $[23] = snippet.createdBy.displayName;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== t8 || $[26] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignInline: "center",
            alignBlock: "center",
            space: "space.050"
        }, t8, t9);
        $[25] = t8;
        $[26] = t9;
        $[27] = t10;
    } else t10 = $[27];
    let t11;
    if ($[28] !== showUsageAndPrivateLabels || $[29] !== snippet) {
        t11 = showUsageAndPrivateLabels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dh4hm.SnippetUsageAndPrivateLabels), {
            snippet: snippet
        });
        $[28] = showUsageAndPrivateLabels;
        $[29] = snippet;
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] !== t10 || $[32] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            separator: "\u2022",
            space: "space.075"
        }, t10, t11);
        $[31] = t10;
        $[32] = t11;
        $[33] = t12;
    } else t12 = $[33];
    let t13;
    if ($[34] !== t12 || $[35] !== t7) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            alignInline: "start",
            alignBlock: "start",
            space: "space.075",
            grow: "fill"
        }, t7, t12);
        $[34] = t12;
        $[35] = t7;
        $[36] = t13;
    } else t13 = $[36];
    return t13;
};


const $9fe074483203ee43$var$EDITOR_PRE_SCALE_WIDTH = 800;
const $9fe074483203ee43$export$3a5e77e0ee8e9941 = (t0)=>{
    const $ = (0, $bDgLe.c)(52);
    const { snippet: snippet, contentId: contentId, spaceId: spaceId, spaceKey: spaceKey } = t0;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const editorAPI = (0, $cozmU.useContext)((0, $4oS56.EditorContextPanelContext)).editorAPI;
    const intl = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isMenuOpen, setIsMenuOpen] = (0, $cozmU.useState)(false);
    const isViewMode = (0, $83ffa14fb3047ba9$export$837dc1b65006c6b6)();
    const insertSnippet = (0, $b5pIV.useInsertSnippet)(editorAPI);
    const snippetsActions = (0, $dZUkS.useSnippetsActions)();
    const { fireButtonClickedAnalytic: fireButtonClickedAnalytic, fireFailedAnalytic: fireFailedAnalytic } = (0, $jxXkP.useSnippetAnalytics)((0, $hPTbh.ANALYTICS_ORIGIN).SNIPPET_PANEL);
    const { showPreview: showPreview, hidePreview: hidePreview } = (0, $a95239449d7ef54f$export$eb5bcab93fe60d7)();
    let t1;
    if ($[0] !== showPreview || $[1] !== snippet) {
        t1 = (event)=>{
            setIsHovered(true);
            showPreview(snippet, event.currentTarget.getBoundingClientRect());
        };
        $[0] = showPreview;
        $[1] = snippet;
        $[2] = t1;
    } else t1 = $[2];
    const handleMouseEnter = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsHovered(false);
        $[3] = t2;
    } else t2 = $[3];
    const handleMouseLeave = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (isOpen)=>setIsMenuOpen(isOpen);
        $[4] = t3;
    } else t3 = $[4];
    const handleMenuOpenChange = t3;
    let t4;
    if ($[5] !== fireButtonClickedAnalytic || $[6] !== snippet.isShared || $[7] !== snippet.scope || $[8] !== snippet.snippetId || $[9] !== snippet.templateType || $[10] !== userId) {
        t4 = ()=>{
            fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).INSERT_SNIPPET, {
                userId: userId ?? undefined,
                scope: snippet.scope,
                snippetId: snippet.snippetId,
                isShared: snippet.isShared,
                templateType: snippet.templateType,
                timestamp: Date.now()
            });
        };
        $[5] = fireButtonClickedAnalytic;
        $[6] = snippet.isShared;
        $[7] = snippet.scope;
        $[8] = snippet.snippetId;
        $[9] = snippet.templateType;
        $[10] = userId;
        $[11] = t4;
    } else t4 = $[11];
    const fireInsertSuccess = t4;
    let t5;
    if ($[12] !== fireFailedAnalytic || $[13] !== snippet.isShared || $[14] !== snippet.scope || $[15] !== snippet.snippetId || $[16] !== snippet.templateType || $[17] !== userId) {
        t5 = (reason)=>{
            fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_INSERT, {
                userId: userId ?? undefined,
                scope: snippet.scope,
                snippetId: snippet.snippetId,
                isShared: snippet.isShared,
                templateType: snippet.templateType,
                reason: reason,
                timestamp: Date.now()
            });
        };
        $[12] = fireFailedAnalytic;
        $[13] = snippet.isShared;
        $[14] = snippet.scope;
        $[15] = snippet.snippetId;
        $[16] = snippet.templateType;
        $[17] = userId;
        $[18] = t5;
    } else t5 = $[18];
    const fireInsertFailure = t5;
    let t6;
    if ($[19] !== editorAPI || $[20] !== fireInsertFailure || $[21] !== fireInsertSuccess || $[22] !== hidePreview || $[23] !== insertSnippet || $[24] !== isViewMode || $[25] !== snippet || $[26] !== snippetsActions) {
        t6 = ()=>{
            if (isViewMode) return;
            if (!(0, $6mKj3.expValEquals)("platform_editor_snippets_plugin_confluence", "isEnabled", true)) {
                const result = insertSnippet(snippet, true);
                if (result.status === "success") {
                    hidePreview();
                    snippetsActions.recordSnippetInsert(snippet.snippetId);
                    fireInsertSuccess();
                } else if (result.status === "error") fireInsertFailure(result.reason);
                return;
            }
            if (!editorAPI?.snippets?.commands.insertSnippet) return;
            try {
                const platformSnippet = (0, $5QVmU.mapConfluenceSnippet)(snippet);
                editorAPI.core.actions.execute(editorAPI.snippets.commands.insertSnippet({
                    snippet: platformSnippet,
                    inputSource: (0, $4vyVB.TEMPLATE_GALLERY_INPUT_SOURCE),
                    onSuccess: ()=>{
                        hidePreview();
                        try {
                            snippetsActions.recordSnippetInsert(snippet.snippetId);
                        } catch (t8) {
                            const error_0 = t8;
                            (0, $aUBmi.reportError)(error_0);
                        }
                        fireInsertSuccess();
                    },
                    onError: fireInsertFailure
                }));
            } catch (t7) {
                const error = t7;
                (0, $aUBmi.reportError)(error);
                fireInsertFailure("insertError");
            }
        };
        $[19] = editorAPI;
        $[20] = fireInsertFailure;
        $[21] = fireInsertSuccess;
        $[22] = hidePreview;
        $[23] = insertSnippet;
        $[24] = isViewMode;
        $[25] = snippet;
        $[26] = snippetsActions;
        $[27] = t6;
    } else t6 = $[27];
    const handleClick = t6;
    const showActions = isHovered || snippet.isFavorite || isMenuOpen;
    const showPanelActions = isHovered || isMenuOpen;
    let t7;
    if ($[28] !== intl || $[29] !== snippet.name) {
        t7 = intl.formatMessage((0, $4ae988fb1c767900$export$defe85febe8b728c).snippetCardAriaLabel, {
            name: snippet.name
        });
        $[28] = intl;
        $[29] = snippet.name;
        $[30] = t7;
    } else t7 = $[30];
    const t8 = `snippet-card-button-${snippet.snippetId}`;
    let t9;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            width: `calc(${(0, $2f30b999496548c4$export$6905b264b4feca39).width}px - (${(0, $2f30b999496548c4$export$6905b264b4feca39).paddingInline} * 2))`,
            maxHeight: `calc(${(0, $2f30b999496548c4$export$6905b264b4feca39).height}px - (${(0, $2f30b999496548c4$export$6905b264b4feca39).paddingBlock} * 2))`
        };
        $[31] = t9;
    } else t9 = $[31];
    let t10;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2esFu.SnippetPreviewSkeleton), null);
        $[32] = t10;
    } else t10 = $[32];
    let t11;
    if ($[33] !== snippet) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2f30b999496548c4$export$3c7fb5dd83e912af), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67NtX.SnippetPreview), {
            snippet: snippet,
            dimensions: t9,
            renderWidth: $9fe074483203ee43$var$EDITOR_PRE_SCALE_WIDTH,
            loadingComponent: t10
        }));
        $[33] = snippet;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== contentId || $[36] !== isHovered || $[37] !== showActions || $[38] !== showPanelActions || $[39] !== snippet || $[40] !== spaceId || $[41] !== spaceKey) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e911f5425d517b68$export$30e00acfcf43753a), {
            snippet: snippet,
            isHovered: isHovered,
            showActions: showActions,
            showPanelActions: showPanelActions,
            onMenuOpenChange: handleMenuOpenChange,
            contentId: contentId,
            spaceId: spaceId,
            spaceKey: spaceKey
        });
        $[35] = contentId;
        $[36] = isHovered;
        $[37] = showActions;
        $[38] = showPanelActions;
        $[39] = snippet;
        $[40] = spaceId;
        $[41] = spaceKey;
        $[42] = t12;
    } else t12 = $[42];
    let t13;
    if ($[43] !== handleClick || $[44] !== handleMouseEnter || $[45] !== isMenuOpen || $[46] !== isViewMode || $[47] !== t11 || $[48] !== t12 || $[49] !== t7 || $[50] !== t8) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d403889bed2f9ddb$export$54967bd28cc7e35), {
            isActive: isMenuOpen,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onClick: handleClick,
            isDisabled: isViewMode,
            ariaLabel: t7,
            testId: t8
        }, t11, t12);
        $[43] = handleClick;
        $[44] = handleMouseEnter;
        $[45] = isMenuOpen;
        $[46] = isViewMode;
        $[47] = t11;
        $[48] = t12;
        $[49] = t7;
        $[50] = t8;
        $[51] = t13;
    } else t13 = $[51];
    return t13;
};



const $35ff15f955ef7b49$var$styles = {
    container: "_4bt5LAnQyn _2WAcuGnQyn _2YLqiKUgYP _2O5Vij7dHp _4kiQYAdnbC"
};
const $35ff15f955ef7b49$export$33e29ce434f9a2e7 = (containerRef)=>{
    const $ = (0, $bDgLe.c)(5);
    const [containerHeight, setContainerHeight] = (0, $cozmU.useState)(0);
    let t0;
    let t1;
    if ($[0] !== containerRef) {
        t0 = ()=>{
            const node = containerRef.current;
            if (!node) return;
            const observer = new ResizeObserver((entries)=>{
                const entry = entries[0];
                if (entry) setContainerHeight(entry.contentRect.height);
            });
            observer.observe(node);
            return ()=>observer.disconnect();
        };
        t1 = [
            containerRef
        ];
        $[0] = containerRef;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[3] !== containerHeight) {
        t2 = {
            containerHeight: containerHeight
        };
        $[3] = containerHeight;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
const $35ff15f955ef7b49$var$SnippetPanelListRow = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { data: t1, index: index, style: style } = t0;
    const { snippets: snippets, contentId: contentId, spaceId: spaceId, spaceKey: spaceKey } = t1;
    const t2 = snippets[index];
    let t3;
    if ($[0] !== contentId || $[1] !== spaceId || $[2] !== spaceKey || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9fe074483203ee43$export$3a5e77e0ee8e9941), {
            snippet: t2,
            contentId: contentId,
            spaceId: spaceId,
            spaceKey: spaceKey
        });
        $[0] = contentId;
        $[1] = spaceId;
        $[2] = spaceKey;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== style || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: style,
            role: "listitem"
        }, t3);
        $[5] = style;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};
const $35ff15f955ef7b49$var$getItemKey = (index, data)=>data.snippets[index].snippetId;
const $35ff15f955ef7b49$export$53c9a51d6103acb5 = (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { snippets: snippets, contentId: contentId, spaceId: spaceId, spaceKey: spaceKey } = t0;
    const { hidePreview: hidePreview } = (0, $a95239449d7ef54f$export$eb5bcab93fe60d7)();
    const containerRef = (0, $cozmU.useRef)(null);
    const listRef = (0, $cozmU.useRef)(null);
    const { containerHeight: containerHeight } = $35ff15f955ef7b49$export$33e29ce434f9a2e7(containerRef);
    let t1;
    if ($[0] !== snippets) {
        t1 = snippets.map($35ff15f955ef7b49$var$_temp).sort().join(",");
        $[0] = snippets;
        $[1] = t1;
    } else t1 = $[1];
    const snippetIds = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            listRef.current?.scrollTo(0);
        };
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== snippetIds) {
        t3 = [
            snippetIds
        ];
        $[3] = snippetIds;
        $[4] = t3;
    } else t3 = $[4];
    (0, $cozmU.useEffect)(t2, t3);
    const itemCount = snippets.length;
    let t4;
    if ($[5] !== contentId || $[6] !== snippets || $[7] !== spaceId || $[8] !== spaceKey) {
        t4 = {
            snippets: snippets,
            contentId: contentId,
            spaceId: spaceId,
            spaceKey: spaceKey
        };
        $[5] = contentId;
        $[6] = snippets;
        $[7] = spaceId;
        $[8] = spaceKey;
        $[9] = t4;
    } else t4 = $[9];
    const itemData = t4;
    let t5;
    if ($[10] !== containerHeight || $[11] !== itemCount || $[12] !== itemData) {
        t5 = containerHeight > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3a234a709e943cf8$export$ae9e55e1d8a2f4b7), {
            ref: listRef,
            height: containerHeight,
            itemCount: itemCount,
            itemData: itemData,
            itemSize: (0, $d403889bed2f9ddb$export$1049486e8aafa787),
            width: "100%",
            itemKey: $35ff15f955ef7b49$var$getItemKey,
            overscanCount: 3
        }, $35ff15f955ef7b49$var$SnippetPanelListRow);
        $[10] = containerHeight;
        $[11] = itemCount;
        $[12] = itemData;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== hidePreview || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $35ff15f955ef7b49$var$styles.container,
            ref: containerRef,
            onMouseLeave: hidePreview
        }, t5);
        $[14] = hidePreview;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
};
function $35ff15f955ef7b49$var$_temp(snippet) {
    return snippet.snippetId;
}













var $7sJoX = parcelRequire("7sJoX");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $7ZB0A = parcelRequire("7ZB0A");














var $gPFNt = parcelRequire("gPFNt");

const $2373de1ac335f36f$var$styles = {
    wrapper: "_3iDTPbQ4SZ _0hPCNLQame",
    dropdownContainer: "_39xV02gZxp _2XsHFM2ADO _0adFHs2ADO"
};
const $2373de1ac335f36f$var$messages = (0, $kSwu1.defineMessages)({
    sortByLabel: {
        id: "snippets.panel.sort-by.label",
        defaultMessage: "Sort by"
    },
    createdAtLabel: {
        id: "snippets.panel.sort-by.option.created-at.label",
        defaultMessage: "Created at"
    },
    lastUpdatedLabel: {
        id: "snippets.panel.sort-by.option.last-updated.label",
        defaultMessage: "Last updated"
    },
    popularityLabel: {
        id: "snippets.panel.sort-by.option.popularity.label",
        defaultMessage: "Popularity"
    },
    alphabeticalLabel: {
        id: "snippets.panel.sort-by.option.alphabetical.label",
        defaultMessage: "Alphabetical"
    }
});
const $2373de1ac335f36f$var$optionLabels = {
    [(0, $gPFNt.SnippetSortOrder).CREATED_AT]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$2373de1ac335f36f$var$messages.createdAtLabel,
        key: $2373de1ac335f36f$var$messages.createdAtLabel.id
    }),
    [(0, $gPFNt.SnippetSortOrder).LAST_UPDATED]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$2373de1ac335f36f$var$messages.lastUpdatedLabel,
        key: $2373de1ac335f36f$var$messages.lastUpdatedLabel.id
    }),
    [(0, $gPFNt.SnippetSortOrder).POPULARITY]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$2373de1ac335f36f$var$messages.popularityLabel,
        key: $2373de1ac335f36f$var$messages.popularityLabel.id
    }),
    [(0, $gPFNt.SnippetSortOrder).ALPHABETICAL]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$2373de1ac335f36f$var$messages.alphabeticalLabel,
        key: $2373de1ac335f36f$var$messages.alphabeticalLabel.id
    })
};
const $2373de1ac335f36f$export$3a1b423fdeb0b8a9 = (t0)=>{
    const $ = (0, $bDgLe.c)(39);
    const { onChange: onChange, value: value, isDisabled: t1 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const [isMenuOpen, setIsMenuOpen] = (0, $cozmU.useState)(false);
    const { fireDropdownItemClickedAnalytic: fireDropdownItemClickedAnalytic } = (0, $jxXkP.useSnippetAnalytics)((0, $hPTbh.ANALYTICS_ORIGIN).SNIPPET_PANEL);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (t3)=>{
            const { isOpen: isOpen } = t3;
            setIsMenuOpen(isOpen);
        };
        $[0] = t2;
    } else t2 = $[0];
    const handleOpenChange = t2;
    let t3;
    if ($[1] !== fireDropdownItemClickedAnalytic || $[2] !== onChange || $[3] !== value) {
        t3 = (selectedSortOption)=>()=>{
                fireDropdownItemClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).SNIPPET_SORT_ORDER, {
                    previousSortingScheme: value,
                    newSortingScheme: selectedSortOption
                });
                onChange(selectedSortOption);
            };
        $[1] = fireDropdownItemClickedAnalytic;
        $[2] = onChange;
        $[3] = value;
        $[4] = t3;
    } else t3 = $[4];
    const handleSortOrderChange = t3;
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            weight: "medium",
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2373de1ac335f36f$var$messages.sortByLabel));
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== isDisabled || $[7] !== isMenuOpen || $[8] !== value) {
        t5 = (t6)=>{
            const { triggerRef: triggerRef, ...props } = t6;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                ...props,
                appearance: "subtle",
                isDisabled: isDisabled,
                shouldFitContainer: true,
                style: {
                    textAlign: "left"
                },
                isSelected: isMenuOpen,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: "",
                    size: "small"
                }),
                ref: triggerRef
            }, $2373de1ac335f36f$var$optionLabels[value]);
        };
        $[6] = isDisabled;
        $[7] = isMenuOpen;
        $[8] = value;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== handleSortOrderChange) {
        t6 = handleSortOrderChange((0, $gPFNt.SnippetSortOrder).CREATED_AT);
        $[10] = handleSortOrderChange;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2373de1ac335f36f$var$messages.createdAtLabel);
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            onClick: t6
        }, t7);
        $[13] = t6;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== handleSortOrderChange) {
        t9 = handleSortOrderChange((0, $gPFNt.SnippetSortOrder).LAST_UPDATED);
        $[15] = handleSortOrderChange;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2373de1ac335f36f$var$messages.lastUpdatedLabel);
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            onClick: t9
        }, t10);
        $[18] = t9;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== handleSortOrderChange) {
        t12 = handleSortOrderChange((0, $gPFNt.SnippetSortOrder).POPULARITY);
        $[20] = handleSortOrderChange;
        $[21] = t12;
    } else t12 = $[21];
    let t13;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2373de1ac335f36f$var$messages.popularityLabel);
        $[22] = t13;
    } else t13 = $[22];
    let t14;
    if ($[23] !== t12) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            onClick: t12
        }, t13);
        $[23] = t12;
        $[24] = t14;
    } else t14 = $[24];
    let t15;
    if ($[25] !== handleSortOrderChange) {
        t15 = handleSortOrderChange((0, $gPFNt.SnippetSortOrder).ALPHABETICAL);
        $[25] = handleSortOrderChange;
        $[26] = t15;
    } else t15 = $[26];
    let t16;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2373de1ac335f36f$var$messages.alphabeticalLabel);
        $[27] = t16;
    } else t16 = $[27];
    let t17;
    if ($[28] !== t15) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            onClick: t15
        }, t16);
        $[28] = t15;
        $[29] = t17;
    } else t17 = $[29];
    let t18;
    if ($[30] !== t11 || $[31] !== t14 || $[32] !== t17 || $[33] !== t8) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, t8, t11, t14, t17);
        $[30] = t11;
        $[31] = t14;
        $[32] = t17;
        $[33] = t8;
        $[34] = t18;
    } else t18 = $[34];
    let t19;
    if ($[35] !== isMenuOpen || $[36] !== t18 || $[37] !== t5) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2373de1ac335f36f$var$styles.wrapper
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2373de1ac335f36f$var$styles.dropdownContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            appearance: "tall",
            trigger: t5,
            isOpen: isMenuOpen,
            onOpenChange: handleOpenChange,
            placement: "bottom-start",
            shouldFlip: false
        }, t18)));
        $[35] = isMenuOpen;
        $[36] = t18;
        $[37] = t5;
        $[38] = t19;
    } else t19 = $[38];
    return t19;
};




















const $32792490397e160a$var$styles = {
    searchBarContainer: "_0bjKvDKTcp _0jFU0VUF4f _39xV02N91d _0KLXruGsB2 _1DCdHi2ADO"
};
const $32792490397e160a$export$9aa973586059796c = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $32792490397e160a$var$styles.searchBarContainer
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};














const $c68bbe301cfc15ae$var$styles = {
    categoryItem: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _0bjKvDKTcp _0jFU0VUofl _4ouGXIljYU _0KLXruGsB2"
};
const $c68bbe301cfc15ae$export$af28f945e0fd1a8 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c68bbe301cfc15ae$var$styles.categoryItem
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c68bbe301cfc15ae$var$styles.categoryItem
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c68bbe301cfc15ae$var$styles.categoryItem
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};











const $9951cf1e1232c1ac$var$styles = {
    dropdown: "_0bjKvDKTcp _0jFU0VUofl _39xV02gZxp _0KLXruGsB2"
};
const $9951cf1e1232c1ac$export$2a336dc9585ce2f5 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $9951cf1e1232c1ac$var$styles.dropdown
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};

















const $ee289c3c737d72ec$var$styles = {
    card: "_2Zuz6Q1Y8M _1ZnuxbdnbC _0Of8r22ADO _1wydGW2ADO _39xV02N91d _0jFU0VQEt6 _0KLXrujOvk",
    skeletonPreview: "_0bjKvD8fU6 _0jFU0VG9sM _39xV02v6H3 _0KLXruGsB2",
    placeholderTitle: "_0bjKvDKxmn _0jFU0Vey7F _39xV02N91d _0KLXruGsB2",
    placeholderSubtitle: "_0bjKvDKxmn _0jFU0Vey7F _39xV02ygnw _0KLXruGsB2",
    skeletonAvatar: "_0bjKvDKxmn _0jFU0Vey7F _39xV02ey7F _4ouGXIey7F _0KLXruGsB2",
    fullWidth: "_39xV02N91d"
};
const $ee289c3c737d72ec$export$8fdbf8ba72a7b625 = ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ee289c3c737d72ec$var$styles.skeletonPreview
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ee289c3c737d72ec$var$styles.placeholderTitle
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ee289c3c737d72ec$var$styles.card
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $ee289c3c737d72ec$var$styles.fullWidth,
            alignInline: "start",
            alignBlock: "center",
            space: "space.150"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $ee289c3c737d72ec$var$styles.fullWidth,
            alignInline: "start",
            alignBlock: "center",
            space: "space.075"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $ee289c3c737d72ec$var$styles.fullWidth,
            alignInline: "start",
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ee289c3c737d72ec$var$styles.skeletonAvatar
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ee289c3c737d72ec$var$styles.placeholderSubtitle
        })))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};


const $2e9cdc1c3e4e67e5$export$f8c40a5ae5bad2bc = ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32792490397e160a$export$9aa973586059796c), null);
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c68bbe301cfc15ae$export$af28f945e0fd1a8), null);
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9951cf1e1232c1ac$export$2a336dc9585ce2f5), null);
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
    }
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200",
            grow: "fill"
        }, t0, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ee289c3c737d72ec$export$8fdbf8ba72a7b625), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ee289c3c737d72ec$export$8fdbf8ba72a7b625), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ee289c3c737d72ec$export$8fdbf8ba72a7b625), null)));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
};


const $a6866ef267e2cffc$var$messages = (0, $kSwu1.defineMessages)({
    snippetsRecommended: {
        id: "snippets.panel.recommended",
        defaultMessage: "Recommended"
    },
    searchSnippetsPlaceholderText: {
        id: "snippets.panel.search.placeholderText",
        defaultMessage: "Search author or topic"
    },
    feedbackButtonLabel: {
        id: "snippets.panel.feedback.button",
        defaultMessage: "Give feedback"
    }
});
const $a6866ef267e2cffc$var$styles = {
    feedbackBar: "_4c065U8HPE _2Y7lL4Pgdg _2bqfgdOeNX _0KLXrulfZc",
    searchBarWrapper: "_0jFU0VUofl",
    categoriesWrapper: "_313842Pgdg _0adFHs1Y8M _1DCdHiPgdg"
};
const $a6866ef267e2cffc$export$bd9af633abea831d = (t0)=>{
    const $ = (0, $bDgLe.c)(56);
    const { contentId: contentId, spaceId: spaceId, spaceKey: spaceKey } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const analyticsOrigin = (0, $hPTbh.ANALYTICS_ORIGIN).SNIPPET_PANEL;
    const { fireButtonClickedAnalytic: fireButtonClickedAnalytic, fireTextFieldTypedAnalytic: fireTextFieldTypedAnalytic, fireScreenViewedAnalytic: fireScreenViewedAnalytic } = (0, $jxXkP.useSnippetAnalytics)(analyticsOrigin);
    const previousCategoryRef = (0, $cozmU.useRef)(null);
    const [t1] = (0, $dZUkS.useSnippets)();
    const { isLoading: isLoading, snippets: snippets } = t1;
    (0, $cg3fp.useSnippetViewedOnce)(fireScreenViewedAnalytic);
    const { selectedCategoryId: selectedCategoryId, searchQuery: searchQuery, sortOrder: sortOrder, filteredSnippets: filteredSnippets, setSearchQuery: setSearchQuery, setCategoryFilter: setCategoryFilter, setSortOrder: setSortOrder } = (0, $5B99W.useSnippetFilterAndSort)(snippets);
    const categories = (0, $5Vsx9.useSnippetFilterCategories)();
    let t2;
    if ($[0] !== fireButtonClickedAnalytic || $[1] !== setCategoryFilter) {
        t2 = (category)=>{
            const previousCategoryId = previousCategoryRef.current;
            previousCategoryRef.current = category.id;
            fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).SNIPPET_CATEGORY_FILTER, {
                selectedCategoryId: category.id,
                ...previousCategoryId != null && {
                    previousCategoryId: previousCategoryId
                }
            });
            setCategoryFilter(category.id);
        };
        $[0] = fireButtonClickedAnalytic;
        $[1] = setCategoryFilter;
        $[2] = t2;
    } else t2 = $[2];
    const handleCategorySelected = t2;
    let t3;
    if ($[3] !== fireTextFieldTypedAnalytic || $[4] !== setSearchQuery) {
        t3 = (query)=>{
            if (query.length > 0) fireTextFieldTypedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).SNIPPET_SEARCH, {
                searchQueryLength: query.length
            });
            setSearchQuery(query);
        };
        $[3] = fireTextFieldTypedAnalytic;
        $[4] = setSearchQuery;
        $[5] = t3;
    } else t3 = $[5];
    const handleSearch = t3;
    const [showFeedbackCollector, setShowFeedbackCollector] = (0, $cozmU.useState)(false);
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { editorAPI: editorAPI } = (0, $cozmU.useContext)((0, $4oS56.EditorContextPanelContext));
    let t4;
    if ($[6] !== selectedCategoryId || $[7] !== snippets || $[8] !== userId) {
        t4 = (0, $5B99W.filterSnippets)(snippets, selectedCategoryId, "", userId);
        $[6] = selectedCategoryId;
        $[7] = snippets;
        $[8] = userId;
        $[9] = t4;
    } else t4 = $[9];
    const snippetsInCategoryOnly = t4;
    const isCategoryEmpty = snippetsInCategoryOnly.length === 0;
    let t5;
    if ($[10] !== isCategoryEmpty || $[11] !== selectedCategoryId) {
        t5 = (0, $7Voxz.getEmptyStateVariant)(isCategoryEmpty, selectedCategoryId);
        $[10] = isCategoryEmpty;
        $[11] = selectedCategoryId;
        $[12] = t5;
    } else t5 = $[12];
    const emptyStateVariant = t5;
    if (isLoading) {
        let t6;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e9cdc1c3e4e67e5$export$f8c40a5ae5bad2bc), null);
            $[13] = t6;
        } else t6 = $[13];
        return t6;
    }
    let t6;
    if ($[14] !== setCategoryFilter) {
        t6 = ()=>setCategoryFilter((0, $kBRLU.SNIPPET_CATEGORY_IDS).ALL);
        $[14] = setCategoryFilter;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== contentId || $[17] !== editorAPI || $[18] !== showModal || $[19] !== spaceId || $[20] !== spaceKey) {
        t7 = ()=>showModal((0, $bUH8D.CreateSnippetModal), {
                contentId: contentId,
                spaceId: spaceId,
                spaceKey: spaceKey,
                editorAPI: editorAPI,
                analyticsOrigin: analyticsOrigin,
                createSource: (0, $hPTbh.ANALYTICS_CREATE_SOURCE).EMPTY_PANEL
            });
        $[16] = contentId;
        $[17] = editorAPI;
        $[18] = showModal;
        $[19] = spaceId;
        $[20] = spaceKey;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== t6 || $[23] !== t7) {
        t8 = {
            [(0, $7Voxz.EMPTY_STATE_VARIANT).FAVORITES]: t6,
            [(0, $7Voxz.EMPTY_STATE_VARIANT).MY_TEMPLATES]: t7
        };
        $[22] = t6;
        $[23] = t7;
        $[24] = t8;
    } else t8 = $[24];
    const emptyStatePrimaryActionMap = t8;
    const emptyStatePrimaryAction = emptyStatePrimaryActionMap[emptyStateVariant];
    let t9;
    if ($[25] !== intl) {
        t9 = intl.formatMessage($a6866ef267e2cffc$var$messages.searchSnippetsPlaceholderText);
        $[25] = intl;
        $[26] = t9;
    } else t9 = $[26];
    const t10 = searchQuery || "";
    let t11;
    if ($[27] !== handleSearch || $[28] !== t10 || $[29] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a6866ef267e2cffc$var$styles.searchBarWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6sN9o.DebouncedSearchBar), {
            placeholder: t9,
            isCompact: true,
            onChange: handleSearch,
            initialValue: t10
        }));
        $[27] = handleSearch;
        $[28] = t10;
        $[29] = t9;
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] !== selectedCategoryId) {
        t12 = [
            selectedCategoryId
        ];
        $[31] = selectedCategoryId;
        $[32] = t12;
    } else t12 = $[32];
    let t13;
    if ($[33] !== categories || $[34] !== handleCategorySelected || $[35] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a6866ef267e2cffc$var$styles.categoriesWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2sWSU.CategorySelector), {
            categories: categories,
            selectedCategoryIds: t12,
            onCategorySelected: handleCategorySelected
        }));
        $[33] = categories;
        $[34] = handleCategorySelected;
        $[35] = t12;
        $[36] = t13;
    } else t13 = $[36];
    let t14;
    if ($[37] !== setSortOrder || $[38] !== sortOrder) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2373de1ac335f36f$export$3a1b423fdeb0b8a9), {
            onChange: setSortOrder,
            value: sortOrder
        });
        $[37] = setSortOrder;
        $[38] = sortOrder;
        $[39] = t14;
    } else t14 = $[39];
    let t15;
    if ($[40] !== contentId || $[41] !== emptyStatePrimaryAction || $[42] !== emptyStateVariant || $[43] !== filteredSnippets || $[44] !== spaceId || $[45] !== spaceKey) {
        t15 = filteredSnippets.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2mmJ0.EmptySnippets), {
            origin: analyticsOrigin,
            variant: emptyStateVariant,
            primaryAction: emptyStatePrimaryAction
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a95239449d7ef54f$export$59de135692368d24), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6H0Pg.default), {
            name: "snippet-panel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35ff15f955ef7b49$export$53c9a51d6103acb5), {
            snippets: filteredSnippets,
            contentId: contentId,
            spaceId: spaceId,
            spaceKey: spaceKey
        })));
        $[40] = contentId;
        $[41] = emptyStatePrimaryAction;
        $[42] = emptyStateVariant;
        $[43] = filteredSnippets;
        $[44] = spaceId;
        $[45] = spaceKey;
        $[46] = t15;
    } else t15 = $[46];
    let t16;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a6866ef267e2cffc$var$styles.feedbackBar
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gVrmv))),
            appearance: "subtle",
            onClick: ()=>setShowFeedbackCollector(true)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a6866ef267e2cffc$var$messages.feedbackButtonLabel)));
        $[47] = t16;
    } else t16 = $[47];
    let t17;
    if ($[48] !== showFeedbackCollector) {
        t17 = showFeedbackCollector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcvq8.LazyGlobalFeedbackCollector), {
            feedbackSource: (0, $lx6jn.FeedbackSource).EDITOR,
            onClose: ()=>setShowFeedbackCollector(false),
            onCloseComplete: $a6866ef267e2cffc$var$_temp
        });
        $[48] = showFeedbackCollector;
        $[49] = t17;
    } else t17 = $[49];
    let t18;
    if ($[50] !== t11 || $[51] !== t13 || $[52] !== t14 || $[53] !== t15 || $[54] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100",
            grow: "fill"
        }, t11, t13, t14, t15, t16, t17);
        $[50] = t11;
        $[51] = t13;
        $[52] = t14;
        $[53] = t15;
        $[54] = t17;
        $[55] = t18;
    } else t18 = $[55];
    return t18;
};
function $a6866ef267e2cffc$var$_temp() {}









var $dPJCf = parcelRequire("dPJCf");


var $lJDEI = parcelRequire("lJDEI");


var $jMyy4 = parcelRequire("jMyy4");











var $cJ0FD = parcelRequire("cJ0FD");


var $lsxnT = parcelRequire("lsxnT");


var $bEwOV = parcelRequire("bEwOV");


var $ivb8S = parcelRequire("ivb8S");





var $5vi32 = parcelRequire("5vi32");

var $d43fdbd07c8d374e$exports = {};
$d43fdbd07c8d374e$exports = new URL("snippetsSpotlightImage.74d48d20.svg", import.meta.url).toString();



var $2K2hA = parcelRequire("2K2hA");


var $6OwHS = parcelRequire("6OwHS");


var $4enp7 = parcelRequire("4enp7");


var $6VFk2 = parcelRequire("6VFk2");


var $2Vz7H = parcelRequire("2Vz7H");


var $l3ydK = parcelRequire("l3ydK");


var $4AC39 = parcelRequire("4AC39");


var $gi4qj = parcelRequire("gi4qj");


var $uyMbP = parcelRequire("uyMbP");


var $3eYzF = parcelRequire("3eYzF");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");


var $dOlTT = parcelRequire("dOlTT");

const $7ca55c714f63b99f$var$i18n = (0, $kSwu1.defineMessages)({
    snippetsTabSpotlightTitle: {
        id: "snippets.snippets-tab-spotlight.title",
        defaultMessage: "Save time with block templates"
    },
    snippetsTabSpotlightBody: {
        id: "snippets.snippets-tab-spotlight.body",
        defaultMessage: "Save any content as a block template. Find and reuse it from the Block tab."
    },
    snippetsTabSpotlightDone: {
        id: "snippets.snippets-tab-spotlight.done",
        defaultMessage: "Done"
    }
});
const $7ca55c714f63b99f$export$820b3ded717c559e = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $cozmU.useState)(false);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { data: data, loading: isOnboardingStateLoading, error: isOnboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $bEwOV.SNIPPETS_ONBOARDING).HAS_SEEN_SNIPPETS_TAB_SPOTLIGHT
    ], !(0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false));
    const { hasSeenSnippetsTabSpotlight: hasSeenSnippetsTabSpotlight } = (0, $ivb8S.deserializeState)(data);
    const handleSpotlightStart = (0, $cozmU.useCallback)(()=>{
        setOnboardingState({
            key: (0, $bEwOV.SNIPPETS_ONBOARDING).HAS_SEEN_SNIPPETS_TAB_SPOTLIGHT,
            value: 'true'
        });
        setIsSpotlightActive(true);
    }, [
        setOnboardingState
    ]);
    const handleSpotlightStop = (0, $cozmU.useCallback)(()=>{
        setIsSpotlightActive(false);
    }, []);
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const choreographer = useChoreographer('SnippetsTabSpotlight', {
        start: handleSpotlightStart,
        stop: handleSpotlightStop
    });
    const handleOnClick = (0, $cozmU.useCallback)(()=>{
        choreographer.stopMessage();
    }, [
        choreographer
    ]);
    const handleOnDismiss = (0, $cozmU.useCallback)(()=>{
        choreographer.stopMessage();
    }, [
        choreographer
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isEmbeddedConfluence && !isOnboardingStateLoading && !isOnboardingStateError && !hasSeenSnippetsTabSpotlight && (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        choreographer.startMessage();
    }, [
        isEmbeddedConfluence,
        isOnboardingStateLoading,
        isOnboardingStateError,
        hasSeenSnippetsTabSpotlight,
        choreographer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        dismiss: handleOnDismiss,
        isVisible: isSpotlightActive,
        placement: "bottom-start",
        offset: [
            0,
            6
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
        testId: "snippets-tab-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, formatMessage($7ca55c714f63b99f$var$i18n.snippetsTabSpotlightTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OwHS.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d43fdbd07c8d374e$exports))),
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($7ca55c714f63b99f$var$i18n.snippetsTabSpotlightBody))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
        onClick: handleOnClick
    }, formatMessage($7ca55c714f63b99f$var$i18n.snippetsTabSpotlightDone)))))));
};


const $a9fe7ee9063c2de8$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    templatesTabLabel: {
        id: "editor-context-panel-content-creation-panel.template-panel.tabs.templates.label",
        defaultMessage: "Templates"
    },
    importDocTabLabel: {
        id: "editor-context-panel-content-creation-panel.template-panel.tabs.import-doc.label",
        defaultMessage: "Import"
    },
    closeLabel: {
        id: "editor-context-panel-content-creation-panel.close-label",
        defaultMessage: "Close templates and import"
    },
    closeLabelSnippets: {
        id: "editor-context-panel-content-creation-panel.close-label-snippets",
        defaultMessage: "Close templates"
    },
    blockLabel: {
        id: "editor-context-panel-content-creation-panel.block-label",
        defaultMessage: "Block"
    },
    pageLabel: {
        id: "editor-context-panel-content-creation-panel.page-label",
        defaultMessage: "Page"
    }
});
// Tab indices - the actual tab at each index varies by mode:
// - platform_editor_blocks_conf OFF (legacy): [Templates, Import]
// - platform_editor_blocks_conf ON + templates mode: [Page, Block]
// - platform_editor_blocks_conf ON + import mode: [Import] (only one tab)
const $a9fe7ee9063c2de8$var$FIRST_TAB_INDEX = 0;
const $a9fe7ee9063c2de8$var$SECOND_TAB_INDEX = 1;
const $a9fe7ee9063c2de8$var$ContentWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0KLXrulfZc _1mT5xdRAKS _0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w",
            __cmplp.disabled ? "_0wOv4Q2mtD" : "_0wOv4Q18ZR",
            __cmplp.className
        ])
    });
}); // header > body allows the sticky tabs to be on top of the tab body content as it scrolls
const $a9fe7ee9063c2de8$var$StickyTabsHeaderWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31f1VbW _1mT5xdHE3j _2IhTonUgYP _1wydGW5zaO _42Yu6BPvK5",
            __cmplp.className
        ])
    });
});
const $a9fe7ee9063c2de8$var$closeIconWrapperStyles = (0, $buxP3.xcss)({
    height: '0px',
    position: 'absolute',
    right: '0',
    zIndex: 'dialog'
});
const $a9fe7ee9063c2de8$var$CustomTabPanel = ({ children: children })=>{
    const tabPanelAttributes = (0, $22LbG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...tabPanelAttributes,
        style: {
            padding: `0 ${"var(--ds-space-050, 4px)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            zIndex: (0, $81d67ebdabda9710$export$ae37325b3735a1de)
        },
        tabIndex: -1
    }, children);
};
const $a9fe7ee9063c2de8$var$getParentPageId = (data)=>{
    const contentAncestors = data?.content?.nodes?.[0]?.ancestors ?? [];
    return contentAncestors.slice(-1)[0]?.id || '';
}; // When platform_editor_blocks_conf is ON:
//   - 'import' target tab → opens import-only mode (single Import content)
//   - 'templates', 'block', or none target tab → opens templates mode (Page | Block tabs)
// When platform_editor_blocks_conf is OFF:
//   - Always templates mode (Templates | Import tabs)
const $a9fe7ee9063c2de8$var$getPanelMode = (tabTarget, isImportDisabled)=>{
    if ((0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) {
        if (tabTarget === (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_IMPORT) && !isImportDisabled) return 0, $lJDEI.PANEL_MODE_IMPORT;
        return 0, $lJDEI.PANEL_MODE_TEMPLATES;
    }
    return 0, $lJDEI.PANEL_MODE_TEMPLATES;
}; // Gets the initial tab index based on mode and query params.
// When platform_editor_blocks_conf is ON in templates mode: page=0, block=1
// When platform_editor_blocks_conf is ON in import mode: import=0 (only one tab)
// When platform_editor_blocks_conf is OFF: templates=0, import=1
const $a9fe7ee9063c2de8$var$getInitialTabTarget = (queryParams, panelMode, isImportDisabled)=>{
    const tabTarget = (0, $c3Qwv.getSingleParam)(queryParams, (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET));
    if ((0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) {
        if (panelMode === (0, $lJDEI.PANEL_MODE_TEMPLATES) && tabTarget === (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_BLOCK)) return $a9fe7ee9063c2de8$var$SECOND_TAB_INDEX;
        return $a9fe7ee9063c2de8$var$FIRST_TAB_INDEX; // Default to first tab
    } // Legacy behavior: templates=0, import=1
    if (tabTarget === (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_IMPORT) && !isImportDisabled) return $a9fe7ee9063c2de8$var$SECOND_TAB_INDEX;
    return $a9fe7ee9063c2de8$var$FIRST_TAB_INDEX;
};
const $a9fe7ee9063c2de8$export$ea9a941ad7141159 = ({ currentSpaceKey: currentSpaceKey, contentId: contentId, spaceId: spaceId, title: title, onContentUpdated: onContentUpdated, isPanelDisabled: isPanelDisabled, beforeTemplateSelect: beforeTemplateSelect, hasUserAddedContent: hasUserAddedContent, beforeUpdateRequest: beforeUpdateRequest, onError: onError, closeConfigPanel: closeConfigPanel, abortTemplatePanelLoadExperiences: abortTemplatePanelLoadExperiences, templateAllowList: templateAllowList, isImportDisabled: isImportDisabled, isAlwaysDiscardChanges: isAlwaysDiscardChanges, isSpacePickerDisabled: isSpacePickerDisabled })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext)); // Derive panelMode from query params so that switching modes updates the tabs
    const queryParams = getQueryParams();
    const tabTarget = (0, $c3Qwv.getSingleParam)(queryParams, (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET));
    const panelMode = (0, $cozmU.useMemo)(()=>$a9fe7ee9063c2de8$var$getPanelMode(tabTarget, isImportDisabled), [
        tabTarget,
        isImportDisabled
    ]);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const [selectedTab, setSelectedTab] = (0, $cozmU.useState)(()=>$a9fe7ee9063c2de8$var$getInitialTabTarget(getQueryParams(), panelMode, isImportDisabled)); // Update selected tab when panelMode or tabTarget changes
    const prevStateRef = (0, $cozmU.useRef)({
        panelMode: panelMode,
        tabTarget: tabTarget
    });
    (0, $cozmU.useEffect)(()=>{
        // When neither platform_editor_blocks_conf nor cwr_blank_object_experiment is enabled, skip this effect
        // to preserve the initial tab selection and avoid race condition.
        if (!(0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false) && (!isRovoLLMEnabled || !(0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false))) return;
        const prevState = prevStateRef.current;
        const hasPanelModeChanged = prevState.panelMode !== panelMode;
        const hasTabTargetChanged = prevState.tabTarget !== tabTarget; // Update tab when mode changes, or when tab target changes in templates mode
        if (hasPanelModeChanged || hasTabTargetChanged && panelMode === (0, $lJDEI.PANEL_MODE_TEMPLATES)) {
            const newTab = $a9fe7ee9063c2de8$var$getInitialTabTarget(getQueryParams(), panelMode, isImportDisabled);
            setSelectedTab(newTab);
        }
        prevStateRef.current = {
            panelMode: panelMode,
            tabTarget: tabTarget
        };
    }, [
        panelMode,
        tabTarget,
        getQueryParams,
        isImportDisabled,
        isRovoLLMEnabled
    ]);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $39d1fac194a31071$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "editor-context-panel-content-creation-panel"
    });
    const parentPageId = $a9fe7ee9063c2de8$var$getParentPageId(data);
    const handleTabSelect = (0, $cozmU.useCallback)((selectedIndex)=>{
        let actionSubjectId;
        if ((0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) {
            if (panelMode === (0, $lJDEI.PANEL_MODE_TEMPLATES)) {
                // Templates mode: Page (0), Block (1)
                actionSubjectId = selectedIndex === $a9fe7ee9063c2de8$var$SECOND_TAB_INDEX ? 'blockTab' : 'pageTab';
                const tabTargetQueryParam = selectedIndex === $a9fe7ee9063c2de8$var$SECOND_TAB_INDEX ? (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_BLOCK) : (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_TEMPLATES);
                setQueryParams({
                    [(0, $lJDEI.CONTEXT_PANEL_TAB_TARGET)]: tabTargetQueryParam
                }, true);
            } else // Import mode: Import (0) - only one tab
            actionSubjectId = 'importTab';
        } else {
            // Legacy: Templates (0), Import (1)
            actionSubjectId = selectedIndex === $a9fe7ee9063c2de8$var$SECOND_TAB_INDEX ? 'importTab' : 'templatesTab'; // When cwr_blank_object_experiment is enabled, we need to update the query param
            // to properly track which tab is selected (Templates vs Import)
            if (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false)) {
                const tabTargetQueryParam = selectedIndex === $a9fe7ee9063c2de8$var$SECOND_TAB_INDEX ? (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_IMPORT) : (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_TEMPLATES);
                setQueryParams({
                    [(0, $lJDEI.CONTEXT_PANEL_TAB_TARGET)]: tabTargetQueryParam
                }, true);
            }
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'editorRightRail',
                action: 'clicked',
                actionSubject: 'tab',
                actionSubjectId: actionSubjectId
            }
        }).fire();
        setSelectedTab(selectedIndex);
    }, [
        setSelectedTab,
        createAnalyticsEvent,
        panelMode,
        setQueryParams,
        isRovoLLMEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (selectedTab !== $a9fe7ee9063c2de8$var$FIRST_TAB_INDEX) abortTemplatePanelLoadExperiences('templates tab is not selected');
    }, [
        selectedTab,
        abortTemplatePanelLoadExperiences
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Clear contextPanelTabTarget when both experiments are disabled
        if (!(0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false) && (!isRovoLLMEnabled || !(0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false))) setQueryParams({
            [(0, $lJDEI.CONTEXT_PANEL_TAB_TARGET)]: null
        }, true);
    }, [
        setQueryParams,
        isRovoLLMEnabled
    ]);
    if (loading) return null; // if this tabs array gets more complex, we will need to refactor the TEMPLATES_TAB_INDEX and CONTEXT_PANEL_TAB_TARGET concept into something that isnt hardcoded here
    const tabs = (()=>{
        if ((0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) {
            // When platform_editor_blocks_conf is ON, we have two distinct modes:
            // 1. Templates mode: Page | Block tabs
            // 2. Import mode: Import only (single content)
            if (panelMode === (0, $lJDEI.PANEL_MODE_IMPORT)) return [
                {
                    label: $a9fe7ee9063c2de8$export$a7357cdd1f0b0168.importDocTabLabel,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $063472e56b7451b3$export$b3ebd135320cfc), {
                        hasUserAddedContent: hasUserAddedContent,
                        contentId: contentId,
                        parentPageId: parentPageId,
                        currentSpace: currentSpaceKey
                    })
                }
            ];
             // Templates mode: Page | Block
            return [
                {
                    label: $a9fe7ee9063c2de8$export$a7357cdd1f0b0168.pageLabel,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39d8ff3835a36bb3$export$67b0eaa8bfcb2d1f), {
                        parentPageId: parentPageId,
                        currentSpaceKey: currentSpaceKey,
                        contentId: contentId,
                        title: title,
                        onContentUpdated: onContentUpdated,
                        isPanelDisabled: isPanelDisabled,
                        beforeTemplateSelect: beforeTemplateSelect,
                        hasUserAddedContent: hasUserAddedContent,
                        beforeUpdateRequest: beforeUpdateRequest,
                        onError: onError,
                        templateAllowList: templateAllowList,
                        isAlwaysDiscardChanges: isAlwaysDiscardChanges,
                        isSpacePickerDisabled: isSpacePickerDisabled
                    })
                },
                {
                    label: $a9fe7ee9063c2de8$export$a7357cdd1f0b0168.blockLabel,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6866ef267e2cffc$export$bd9af633abea831d), {
                        contentId: contentId,
                        spaceId: spaceId,
                        spaceKey: currentSpaceKey
                    })
                }
            ];
        } // When platform_editor_blocks_conf is OFF: Templates | Import (legacy behavior)
        return [
            {
                label: $a9fe7ee9063c2de8$export$a7357cdd1f0b0168.templatesTabLabel,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39d8ff3835a36bb3$export$67b0eaa8bfcb2d1f), {
                    parentPageId: parentPageId,
                    currentSpaceKey: currentSpaceKey,
                    contentId: contentId,
                    title: title,
                    onContentUpdated: onContentUpdated,
                    isPanelDisabled: isPanelDisabled,
                    beforeTemplateSelect: beforeTemplateSelect,
                    hasUserAddedContent: hasUserAddedContent,
                    beforeUpdateRequest: beforeUpdateRequest,
                    onError: onError,
                    templateAllowList: templateAllowList,
                    isAlwaysDiscardChanges: isAlwaysDiscardChanges,
                    isSpacePickerDisabled: isSpacePickerDisabled
                })
            },
            ...!isImportDisabled ? [
                {
                    label: $a9fe7ee9063c2de8$export$a7357cdd1f0b0168.importDocTabLabel,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $063472e56b7451b3$export$b3ebd135320cfc), {
                        hasUserAddedContent: hasUserAddedContent,
                        contentId: contentId,
                        parentPageId: parentPageId,
                        currentSpace: currentSpaceKey
                    })
                }
            ] : []
        ];
    })();
    const panelWidth = (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false) ? 400 : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lTuad.EditorContextPanelItem), {
        itemName: "template-panel",
        closeSelf: closeConfigPanel,
        customWidth: panelWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES
    }, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_EXPERIENCE),
        error: error
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a9fe7ee9063c2de8$var$ContentWrapper, {
        disabled: isPanelDisabled,
        "data-testid": "content-creation-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMjUh.default), {
        onChange: handleTabSelect,
        selected: selectedTab,
        id: "editorContextPanelContentCreationTabs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a9fe7ee9063c2de8$var$StickyTabsHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $a9fe7ee9063c2de8$var$closeIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5gk7.CloseButton), {
        onClose: closeConfigPanel,
        label: intl.formatMessage((0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false) ? $a9fe7ee9063c2de8$export$a7357cdd1f0b0168.closeLabelSnippets : $a9fe7ee9063c2de8$export$a7357cdd1f0b0168.closeLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dkVNA.default), null, tabs.map((tab, index)=>{
        const tabElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tab.label)); // Wrap the Block tab (second tab) with the spotlight
        if (panelMode === (0, $lJDEI.PANEL_MODE_TEMPLATES) && index === $a9fe7ee9063c2de8$var$SECOND_TAB_INDEX && (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ca55c714f63b99f$export$820b3ded717c559e), {
            key: index
        }, tabElement);
        return tabElement;
    }))), tabs.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a9fe7ee9063c2de8$var$CustomTabPanel, {
            key: index
        }, tab.content))))));
};



const $2f3d6b030a611bed$export$aaff6b6704dfdcef = /*#__PURE__*/ (0, $cozmU.memo)(({ hasUserAddedContent: hasUserAddedContent, isPanelDisabled: isPanelDisabled, title: title, onContentUpdated: onContentUpdated, beforeTemplateSelect: beforeTemplateSelect, isContentCreationPanelShown: isContentCreationPanelShown, onClickCloseContentCreationPanel: onClickCloseContentCreationPanel, beforeUpdateRequest: beforeUpdateRequest, onError: onError, templateAllowList: templateAllowList, isImportDisabled: isImportDisabled, isAlwaysDiscardChanges: isAlwaysDiscardChanges, isSpacePickerDisabled: isSpacePickerDisabled })=>{
    const [currentSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    (0, $f0ac822d8f33c68a$export$55a4b363793a10d0)(isContentCreationPanelShown, contentId);
    const { abortTemplatePanelLoadExperiences: abortTemplatePanelLoadExperiences } = (0, $3c4a4cbc3a864190$export$b6c47fafdd5a8f13)();
    const subExperiences = (0, $cozmU.useMemo)(()=>(0, $97753ca4d20e5422$export$592985e5f8127ac4)(isSpacePickerDisabled), [
        isSpacePickerDisabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isContentCreationPanelShown) abortTemplatePanelLoadExperiences('closing template panel');
    }, [
        isContentCreationPanelShown,
        abortTemplatePanelLoadExperiences
    ]);
    if (isContentCreationPanelShown && currentSpaceKey && contentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_EXPERIENCE),
        collect: (0, $97753ca4d20e5422$export$7bbca367109bb861)(subExperiences),
        timeout: (0, $aJPUt.ExperienceTimeout).IN_EDITOR_TEMPLATE_PANEL_LOAD
    }), subExperiences.map((name)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: name,
            key: name
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metricKey: (0, $jX1qB.IN_EDITOR_TEMPLATES_SEGMENT_KEY)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9fe7ee9063c2de8$export$ea9a941ad7141159), {
        currentSpaceKey: currentSpaceKey,
        contentId: contentId,
        spaceId: spaceId ?? '',
        title: title,
        onContentUpdated: onContentUpdated,
        isPanelDisabled: isPanelDisabled,
        beforeTemplateSelect: beforeTemplateSelect,
        hasUserAddedContent: hasUserAddedContent,
        beforeUpdateRequest: beforeUpdateRequest,
        onError: onError,
        closeConfigPanel: onClickCloseContentCreationPanel,
        abortTemplatePanelLoadExperiences: abortTemplatePanelLoadExperiences,
        templateAllowList: templateAllowList,
        isImportDisabled: isImportDisabled,
        isAlwaysDiscardChanges: isAlwaysDiscardChanges,
        isSpacePickerDisabled: isSpacePickerDisabled
    }));
    return null;
});



var $3jwuS = parcelRequire("3jwuS");


var $i9VoI = parcelRequire("i9VoI");

















var $1NBp8 = parcelRequire("1NBp8");








var $3IZob = parcelRequire("3IZob");










const $0c83309d3c4c183d$var$POST_BE_SYNCHRONOUS_REFRESH_EDITOR_TIMEOUT = 1500;
const $0c83309d3c4c183d$var$DELAY_INITIAL_CHECK_TIMEOUT = 4000;
const $0c83309d3c4c183d$var$isContentCreationPanelOpen = (getQueryParams)=>{
    return (0, $lJDEI.isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen)(getQueryParams);
};
const $0c83309d3c4c183d$export$d0c9d99895e9eacb = ({ cancelDebouncedSaveDraft: cancelDebouncedSaveDraft, contentId: contentId, draftShareId: draftShareId, editorActions: editorActions, hideSpinner: hideSpinner, showSpinner: showSpinner, isUnpublishedDraft: isUnpublishedDraft, isEmbeddedEditor: isEmbeddedEditor })=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { setQueryParams: setQueryParams, getQueryParams: getQueryParams, replace: replace } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const _skipLocalChangesCheck = (0, $cozmU.useRef)((0, $lJDEI.getCreatedWithTemplateQueryParamValue)(getQueryParams));
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [hasUserAddedContent, setHasUserAddedContent] = (0, $cozmU.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange } = (0, $3IZob.useDocChangeContext)();
    (0, $cozmU.useEffect)(()=>{
        setTimeout(()=>{
            _skipLocalChangesCheck.current = false;
        }, $0c83309d3c4c183d$var$DELAY_INITIAL_CHECK_TIMEOUT);
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    const onDocChange = (0, $cozmU.useCallback)(()=>{
        const editorHasContent = !editorActions.isDocumentEmpty();
        const wasTemplatesPanelAutoClosed = (0, $lJDEI.getInEditorTemplatesPanelQueryParamValue)(getQueryParams) === (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED);
        if (isUnpublishedDraft && !editorHasContent && wasTemplatesPanelAutoClosed) (0, $lJDEI.setInEditorTemplatesPanelQueryParam)(setQueryParams, (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_OPEN));
        if (!_skipLocalChangesCheck.current) {
            if ((0, $lJDEI.isInEditorTemplatesPanelQueryParamValueOpen)(getQueryParams) && editorHasContent) setQueryParams({
                [(0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME)]: (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED),
                [(0, $lJDEI.CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME)]: null
            }, true);
            setHasUserAddedContent(editorHasContent);
        }
    }, [
        editorActions,
        _skipLocalChangesCheck,
        getQueryParams,
        setQueryParams,
        isUnpublishedDraft
    ]);
    (0, $cozmU.useEffect)(()=>{
        subscribeDocChange(onDocChange);
        return ()=>unsubscribeDocChange(onDocChange);
    }, [
        onDocChange
    ]);
    const onClickCloseContentCreationPanel = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'templateDrawer',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'templateDismissButton'
            }
        }).fire();
        (0, $lJDEI.removeInEditorTemplatesQueryParam)(setQueryParams, isRovoLLMEnabled);
    }, [
        setQueryParams,
        createAnalyticsEvent,
        isRovoLLMEnabled
    ]);
    const onClickOpenContentCreationPanel = (0, $cozmU.useCallback)((panelMode)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'dropdownMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: panelMode === (0, $lJDEI.PANEL_MODE_IMPORT) ? 'openImportBrowser' : 'openTemplateBrowser'
            }
        }).fire();
        let tabTarget;
        if (panelMode === (0, $lJDEI.PANEL_MODE_IMPORT)) tabTarget = (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_IMPORT);
        else if (!editorActions.isDocumentEmpty() && (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) // When the page has content, default to the Block tab so users
        // can quickly insert block-level snippets instead of full-page templates.
        tabTarget = (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_BLOCK);
        else tabTarget = (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_TEMPLATES);
        (0, $lJDEI.setInEditorTemplatesPanelQueryParam)(setQueryParams, (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN), tabTarget, isRovoLLMEnabled);
    }, [
        setQueryParams,
        createAnalyticsEvent,
        isRovoLLMEnabled,
        editorActions
    ]);
    const beforeUpdateRequest = (0, $cozmU.useCallback)(()=>{
        showSpinner();
        cancelDebouncedSaveDraft();
        _skipLocalChangesCheck.current = true;
    }, [
        showSpinner,
        cancelDebouncedSaveDraft,
        _skipLocalChangesCheck
    ]);
    const postUpdateRequest = (0, $cozmU.useCallback)(()=>{
        setHasUserAddedContent(false);
        (0, $lJDEI.setInEditorTemplatesPanelQueryParam)(setQueryParams, (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_OPEN));
        setTimeout(()=>{
            _skipLocalChangesCheck.current = false;
            hideSpinner();
        }, $0c83309d3c4c183d$var$POST_BE_SYNCHRONOUS_REFRESH_EDITOR_TIMEOUT);
    }, [
        hideSpinner,
        _skipLocalChangesCheck,
        setQueryParams
    ]);
    const handleUpdatedWithTemplate = (0, $cozmU.useCallback)(async ({ spaceKey: spaceKey, subtype: subType })=>{
        try {
            showSpinner();
            experienceTracker.start({
                name: (0, $irVI7.REFRESH_EDITOR_CONTENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
            });
            await (0, $8rj8Z.refetchEditorContent)(contentId);
            let route;
            let query = draftShareId ? {
                draftShareId: draftShareId
            } : {};
            if (isEmbeddedEditor) {
                route = (0, $1NBp8.EDIT_PAGE_EMBED);
                const params = getQueryParams();
                query = {
                    ...query,
                    ...params
                };
            } else if (subType === 'live') {
                route = (0, $1NBp8.VIEW_PAGE);
                // Since live page don't have the concept of drafts, draftShareId is not needed
                query = {};
            } else route = (0, $1NBp8.EDIT_PAGE_V2);
            replace(route.toUrl({
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: 'pages'
            }, {
                query: query
            }));
            experienceTracker.succeed({
                name: (0, $irVI7.REFRESH_EDITOR_CONTENT_EXPERIENCE)
            });
            experienceTracker.succeed({
                name: (0, $irVI7.IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR_EXPERIENCE)
            });
        } catch (error) {
            if (error instanceof Error) {
                experienceTracker.stopOnError({
                    name: (0, $irVI7.REFRESH_EDITOR_CONTENT_EXPERIENCE),
                    error: error
                });
                experienceTracker.stopOnError({
                    name: (0, $irVI7.IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR_EXPERIENCE),
                    error: error
                });
            }
        } finally{
            hideSpinner();
        }
    }, [
        contentId,
        cancelDebouncedSaveDraft,
        draftShareId,
        experienceTracker,
        showSpinner,
        hideSpinner,
        replace,
        isEmbeddedEditor,
        getQueryParams
    ]);
    const onUpdatedWithTemplateSubscriptionEvent = (0, $cozmU.useCallback)(async (_eventName, response)=>{
        cancelDebouncedSaveDraft();
        await handleUpdatedWithTemplate(response.contentUpdatedWithTemplate);
    }, [
        cancelDebouncedSaveDraft,
        handleUpdatedWithTemplate
    ]);
    // Derive the current panel mode from query params
    // 'import' => 'import' mode, 'templates' or 'block' => 'templates' mode
    let contentCreationPanelMode;
    if ((0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) {
        const queryParams = getQueryParams();
        const contextPanelTabTarget = queryParams[0, $lJDEI.CONTEXT_PANEL_TAB_TARGET];
        if (contextPanelTabTarget === (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_BLOCK) || contextPanelTabTarget === (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_TEMPLATES)) contentCreationPanelMode = (0, $lJDEI.PANEL_MODE_TEMPLATES);
        else if (contextPanelTabTarget === (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_IMPORT)) contentCreationPanelMode = (0, $lJDEI.PANEL_MODE_IMPORT);
    }
    // For cwr_blank_object_experiment: derive from tab target query param
    if (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false)) {
        const queryParams = getQueryParams();
        const tabTarget = queryParams[0, $lJDEI.CONTEXT_PANEL_TAB_TARGET];
        if (tabTarget === (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_IMPORT)) contentCreationPanelMode = (0, $lJDEI.PANEL_MODE_IMPORT);
        else if (tabTarget === (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_BLOCK) || tabTarget === (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_TEMPLATES)) contentCreationPanelMode = (0, $lJDEI.PANEL_MODE_TEMPLATES);
        else if (tabTarget === undefined) contentCreationPanelMode = undefined;
    }
    return {
        beforeUpdateRequest: beforeUpdateRequest,
        hasUserAddedContent: hasUserAddedContent,
        isContentCreationPanelOpen: $0c83309d3c4c183d$var$isContentCreationPanelOpen(getQueryParams),
        contentCreationPanelMode: contentCreationPanelMode,
        onDocChange: onDocChange,
        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
        onClickCloseContentCreationPanel: onClickCloseContentCreationPanel,
        postUpdateRequest: postUpdateRequest,
        onUpdatedWithTemplateSubscriptionEvent: onUpdatedWithTemplateSubscriptionEvent
    };
};


const $bc4a316d21499c5a$var$renderContextPanelContentCreationPanel = (0, $dOBRD.default)(({ cancelDebouncedSaveDraft: // TODO: canPublish is used for isPanelDisabled, but and it includes a permission check in
// addition to collab init check which needs to be added for NativeCollab
// canPublish
cancelDebouncedSaveDraft, contentType: contentType, collabEditInitialized: collabEditInitialized, beforeUpdateRequest: beforeUpdateRequest, recoverAndRefreshEditorContent: recoverAndRefreshEditorContent, hideSpinner: hideSpinner, hasUserAddedContent: hasUserAddedContent, isUnpublishedDraft: isUnpublishedDraft, isContentCreationPanelOpen: isContentCreationPanelOpen, onClickCloseContentCreationPanel: onClickCloseContentCreationPanel, renderPanel: renderPanel, title: title, templateAllowList: templateAllowList, isImportDisabled: isImportDisabled, isAlwaysDiscardChanges: isAlwaysDiscardChanges, isSpacePickerDisabled: isSpacePickerDisabled, isLivePage: isLivePage, isDraftLockedForEditing: isDraftLockedForEditing })=>{
    // Render the templates content-creation panel for pages and blogposts.
    const isSupportedContentType = contentType === 'page' || contentType === 'blogpost';
    const _renderPanel = renderPanel && isSupportedContentType && (isUnpublishedDraft || isLivePage || (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false));
    if (_renderPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2f3d6b030a611bed$export$aaff6b6704dfdcef), {
        hasUserAddedContent: hasUserAddedContent,
        isPanelDisabled: !collabEditInitialized || !isLivePage && isDraftLockedForEditing && (0, $6mKj3.expValEquals)('confluence_approval_lock_write_surfaces', 'isEnabled', true),
        title: title,
        onContentUpdated: recoverAndRefreshEditorContent,
        beforeUpdateRequest: beforeUpdateRequest,
        beforeTemplateSelect: cancelDebouncedSaveDraft,
        isContentCreationPanelShown: isContentCreationPanelOpen,
        onClickCloseContentCreationPanel: onClickCloseContentCreationPanel,
        onError: hideSpinner,
        templateAllowList: templateAllowList,
        isImportDisabled: isImportDisabled,
        isAlwaysDiscardChanges: isAlwaysDiscardChanges,
        isSpacePickerDisabled: isSpacePickerDisabled
    });
    return null;
});
const $bc4a316d21499c5a$export$4b19e5011403af51 = ({ children: children, cancelDebouncedSaveDraft: cancelDebouncedSaveDraft, collabEditInitialized: collabEditInitialized, contentId: contentId, contentType: contentType, draftShareId: draftShareId, editorActions: editorActions, hideSpinner: hideSpinner, isUnpublishedDraft: isUnpublishedDraft, renderPanel: renderPanel, showSpinner: showSpinner, title: title, isEmbeddedEditor: isEmbeddedEditor, templateAllowList: templateAllowList, isSpacePickerDisabled: isSpacePickerDisabled })=>{
    const { beforeUpdateRequest: beforeUpdateRequest, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, onClickCloseContentCreationPanel: onClickCloseContentCreationPanel, postUpdateRequest: postUpdateRequest, hasUserAddedContent: hasUserAddedContent, isContentCreationPanelOpen: isContentCreationPanelOpen, contentCreationPanelMode: contentCreationPanelMode, onUpdatedWithTemplateSubscriptionEvent: onUpdatedWithTemplateSubscriptionEvent } = (0, $0c83309d3c4c183d$export$d0c9d99895e9eacb)({
        cancelDebouncedSaveDraft: cancelDebouncedSaveDraft,
        contentId: contentId,
        draftShareId: draftShareId,
        editorActions: editorActions,
        hideSpinner: hideSpinner,
        showSpinner: showSpinner,
        isUnpublishedDraft: isUnpublishedDraft,
        isEmbeddedEditor: isEmbeddedEditor
    });
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { isDraftLockedForEditing: isDraftLockedForEditing } = (0, $laFNM.useApprovals)();
    const { showBlueprintVariableWizard: showBlueprintVariableWizard, showTemplateVariableInputDrawer: showTemplateVariableInputDrawer, onClose: closeCreateDialog } = (0, $cozmU.useContext)((0, $8hUXc.CreateDialogContext));
    (0, $cozmU.useEffect)(()=>{
        if (!isLivePage && isDraftLockedForEditing && (showBlueprintVariableWizard || showTemplateVariableInputDrawer) && (0, $6mKj3.expValEquals)('confluence_approval_lock_write_surfaces', 'isEnabled', true)) closeCreateDialog();
    }, [
        closeCreateDialog,
        isDraftLockedForEditing,
        isLivePage,
        showBlueprintVariableWizard,
        showTemplateVariableInputDrawer
    ]);
    const pubSubResourceType = contentType || 'page';
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'EditorContextPanelPageUpdatedWithTemplateSubscription',
        contentId: contentId,
        delta: 'contentUpdatedWithTemplate',
        contentType: pubSubResourceType,
        onDataReceived: onUpdatedWithTemplateSubscriptionEvent
    });
    const recoverAndRefreshEditorContent = (0, $cozmU.useCallback)(async ()=>{
        await (0, $8rj8Z.refetchEditorContent)(contentId);
        postUpdateRequest();
    }, [
        contentId,
        postUpdateRequest
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children({
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        contentCreationPanelMode: contentCreationPanelMode,
        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
        beforeUpdateRequest: beforeUpdateRequest,
        postUpdateRequest: postUpdateRequest
    }), $bc4a316d21499c5a$var$renderContextPanelContentCreationPanel({
        cancelDebouncedSaveDraft: // canPublish,
        cancelDebouncedSaveDraft,
        collabEditInitialized: collabEditInitialized,
        contentType: contentType,
        beforeUpdateRequest: beforeUpdateRequest,
        recoverAndRefreshEditorContent: recoverAndRefreshEditorContent,
        hasUserAddedContent: hasUserAddedContent,
        isUnpublishedDraft: isUnpublishedDraft,
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        onClickCloseContentCreationPanel: onClickCloseContentCreationPanel,
        hideSpinner: hideSpinner,
        renderPanel: renderPanel,
        title: title,
        templateAllowList: templateAllowList,
        isImportDisabled: isEmbeddedEditor,
        isAlwaysDiscardChanges: isEmbeddedEditor,
        isSpacePickerDisabled: isSpacePickerDisabled,
        isLivePage: isLivePage,
        isDraftLockedForEditing: isDraftLockedForEditing
    }));
};
module.exports["EditorContextContentCreationPanelWrapper"] = $bc4a316d21499c5a$export$4b19e5011403af51;

});

parcelRegister("8lItS", function(module, exports) {

let $6142c9ddaa517a9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6142c9ddaa517a9a$var$load("2NNfQ"),
    $6142c9ddaa517a9a$var$load("4WTdS"),
    $6142c9ddaa517a9a$var$load("5k22f"),
    $6142c9ddaa517a9a$var$load("6G4QQ")
]).then(()=>parcelRequire('dzOK8'));

});

parcelRegister("2kMtD", function(module, exports) {

let $1b330d86bd8dd848$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1b330d86bd8dd848$var$load("72q0k"),
    $1b330d86bd8dd848$var$load("52kTj")
]).then(()=>parcelRequire('4eC1j'));

});

parcelRegister("5IgBW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cZa7r = parcelRequire("cZa7r");


var $4gEXU = parcelRequire("4gEXU");


var $4tTm9 = parcelRequire("4tTm9");


var $3omFm = parcelRequire("3omFm");

const $f7d023b2088a5828$export$a0008e78c876ccee = ()=>{
    const { editorCreateProps: editorCreateProps, editorViewProps: editorViewProps, isOffline: isOffline } = (0, $cZa7r.useAnnotations)();
    const { setEditorCreateProps: setEditorCreateProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const onConfirm = (0, $cozmU.useCallback)(()=>{
        !!editorCreateProps && setEditorCreateProps(null);
        !!editorViewProps && setEditorViewProps(null);
    }, [
        editorCreateProps,
        setEditorCreateProps,
        editorViewProps,
        setEditorViewProps
    ]);
    (0, $4gEXU.usePreemptiveGate)({
        onConfirm: onConfirm
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, editorCreateProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tTm9.CreateComponent), {
        ...editorCreateProps,
        isOffline: isOffline
    }), editorViewProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3omFm.ViewComponent), {
        ...editorViewProps,
        isOffline: isOffline
    }));
};
module.exports["EditorAnnotationProviderComponents"] = $f7d023b2088a5828$export$a0008e78c876ccee;

});

parcelRegister("gKaeO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $fdc21a809c69e224$var$EditorRevertDialogContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $fdc21a809c69e224$export$bb04726afe1ab08f = ({ children: children })=>{
    const [shouldShowRevertDialog, setShouldShowRevertDialog] = (0, $cozmU.useState)(false);
    const [shouldShowRevertDialogDiff, setShouldShowRevertDialogDiff] = (0, $cozmU.useState)(false);
    const hideRevertDialogDiff = (0, $cozmU.useCallback)(()=>setShouldShowRevertDialogDiff(false), []);
    const showRevertDialogDiff = (0, $cozmU.useCallback)(()=>setShouldShowRevertDialogDiff(true), []);
    const hideRevertDialog = (0, $cozmU.useCallback)(()=>setShouldShowRevertDialog(false), []);
    const showRevertDialog = (0, $cozmU.useCallback)(()=>{
        setShouldShowRevertDialog(true);
        setShouldShowRevertDialogDiff(false);
    }, []);
    const editorRevertDialogContextValue = (0, $cozmU.useMemo)(()=>({
            shouldShowRevertDialog: shouldShowRevertDialog,
            shouldShowRevertDialogDiff: shouldShowRevertDialogDiff,
            hideRevertDialogDiff: hideRevertDialogDiff,
            showRevertDialogDiff: showRevertDialogDiff,
            hideRevertDialog: hideRevertDialog,
            showRevertDialog: showRevertDialog
        }), [
        shouldShowRevertDialog,
        shouldShowRevertDialogDiff,
        hideRevertDialogDiff,
        showRevertDialogDiff,
        hideRevertDialog,
        showRevertDialog
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fdc21a809c69e224$var$EditorRevertDialogContext.Provider, {
        value: editorRevertDialogContextValue
    }, children);
};
const $fdc21a809c69e224$export$6ff48c61ddbf94bf = ()=>{
    const context = (0, $cozmU.useContext)($fdc21a809c69e224$var$EditorRevertDialogContext);
    if (context === undefined) throw new Error('EditorRevertDialogContext must be used within an EditorRevertDialogContextProvider');
    return context;
};
function $fdc21a809c69e224$export$bd3b9d76887afd3a(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fdc21a809c69e224$export$bb04726afe1ab08f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, props));
}
module.exports["EditorRevertDialogContextProvider"] = $fdc21a809c69e224$export$bb04726afe1ab08f;
module.exports["useEditorRevertDialogContext"] = $fdc21a809c69e224$export$6ff48c61ddbf94bf;
module.exports["withRevertContext"] = $fdc21a809c69e224$export$bd3b9d76887afd3a;

});

parcelRegister("fE1Ao", function(module, exports) {
/**
 * @generated SignedSource<<021f9bc651ad3046873bca0088183fd3>>
 * @relayHash 3610180b2619c3becd2c82f45e0934c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5df264b8cdfc037a09cc9a3d9abd1ff2e9980516b81c65b8632f61ce9af9f56
const $b53542f437d43025$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Label",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "context"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorRevertDialogContentQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorRevertDialogContentQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "3610180b2619c3becd2c82f45e0934c3",
            "id": "f5df264b8cdfc037a09cc9a3d9abd1ff2e9980516b81c65b8632f61ce9af9f56",
            "metadata": {},
            "name": "EditorRevertDialogContentQuery",
            "operationKind": "query",
            "text": "query EditorRevertDialogContentQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,version{number},metadata{labels{id,name}},links{webui,context}}}}"
        }
    };
}();
$b53542f437d43025$var$node.hash = "db72d9646e7ccd29c2e4d2affd2a90ce";
var $b53542f437d43025$export$2e2bcd8739ae039 = $b53542f437d43025$var$node;



var $cozmU = parcelRequire("cozmU");


var $e9owJ = parcelRequire("e9owJ");


var $8G1o2 = parcelRequire("8G1o2");


var $dqLea = parcelRequire("dqLea");


var $l3Dp5 = parcelRequire("l3Dp5");


var $ge2sX = parcelRequire("ge2sX");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");


var $4o1RV = parcelRequire("4o1RV");


var $jacyh = parcelRequire("jacyh");

/* eslint-disable react/no-this-in-sfc */ /* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage */ 



var $kSwu1 = parcelRequire("kSwu1");


var $aDSIl = parcelRequire("aDSIl");


var $7ZB0A = parcelRequire("7ZB0A");


var $7aRdF = parcelRequire("7aRdF");


var $aRGok = parcelRequire("aRGok");


var $eQiT1 = parcelRequire("eQiT1");


var $fEPJS = parcelRequire("fEPJS");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $lfoFx = parcelRequire("lfoFx");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $kj1gY = parcelRequire("kj1gY");





var $1mHQU = parcelRequire("1mHQU");


var $601vk = parcelRequire("601vk");


var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");










const $db051ff45b440e81$var$headerStyles = (0, $buxP3.xcss)({
    color: 'color.text',
    fontWeight: 'font.weight.medium',
    padding: 'space.250'
});
const $db051ff45b440e81$export$54ae5c5dd05596de = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        as: "h2",
        xcss: $db051ff45b440e81$var$headerStyles
    }, children);
const $db051ff45b440e81$var$contributorListStyles = (0, $buxP3.xcss)({
    listStyle: 'none',
    paddingLeft: 'space.0',
    maxHeight: '160px',
    overflowY: 'auto'
});
const $db051ff45b440e81$export$fbf92180ee7fa390 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        as: "ul",
        xcss: $db051ff45b440e81$var$contributorListStyles,
        testId: "editor-revert-dialog-contributors-list"
    }, children);
const $db051ff45b440e81$var$contributorListItemStyles = (0, $buxP3.xcss)({
    float: 'left',
    width: '50%'
});
const $db051ff45b440e81$export$52d11275ec7751f6 = ({ key: key, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        as: "li",
        xcss: $db051ff45b440e81$var$contributorListItemStyles,
        key: key
    }, children);
const $db051ff45b440e81$var$avatarStyles = (0, $buxP3.xcss)({
    filter: 'grayscale(100%)',
    opacity: 0.7,
    display: 'table-cell',
    verticalAlign: 'middle',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.0',
    paddingRight: 'space.0'
});
const $db051ff45b440e81$export$5d6db156164366c9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $db051ff45b440e81$var$avatarStyles
    }, children);
const $db051ff45b440e81$var$avatarImgStyles = (0, $buxP3.xcss)({
    height: 'size.300',
    borderRadius: 'radius.small'
});
const $db051ff45b440e81$export$62ca698686e2dcfb = ({ src: src, alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        as: "img",
        xcss: $db051ff45b440e81$var$avatarImgStyles,
        src: src,
        alt: alt
    });
const $db051ff45b440e81$var$detailStyles = (0, $buxP3.xcss)({
    display: 'table-cell',
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $db051ff45b440e81$export$e214e3696a2038d = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $db051ff45b440e81$var$detailStyles
    }, children);
const $db051ff45b440e81$var$detailNameStyles = (0, $buxP3.xcss)({
    fontWeight: 'font.weight.bold',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    display: 'block',
    width: '200px',
    overflow: 'hidden'
});
const $db051ff45b440e81$export$8017f73df02c60d6 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        as: "p",
        xcss: $db051ff45b440e81$var$detailNameStyles
    }, children);
const $db051ff45b440e81$var$contributorDetailLastModificationStyles = (0, $buxP3.xcss)({
    display: 'inline-block',
    margin: 'space.0',
    font: 'font.body',
    verticalAlign: 'bottom',
    filter: 'grayscale(100%)',
    opacity: 0.6
});
const $db051ff45b440e81$export$b891b51eaabcd719 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        as: "p",
        xcss: $db051ff45b440e81$var$contributorDetailLastModificationStyles
    }, children);
const $db051ff45b440e81$var$linkActionsStyles = (0, $buxP3.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100',
    marginLeft: 'space.0',
    marginRight: 'space.0'
});
const $db051ff45b440e81$export$73e5e09f3ced9be5 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $db051ff45b440e81$var$linkActionsStyles,
        testId: "editor-revert-dialog-link-actions"
    }, children);


const $99497d85d924fd35$export$dd897410adc66601 = {
    delete: {
        page: {
            one: 'editor.quit-dialog.delete.page.changes.by.one',
            many: 'editor.quit-dialog.delete.page.changes.by.many'
        },
        blogpost: {
            one: 'editor.quit-dialog.delete.blogpost.changes.by.one',
            many: 'editor.quit-dialog.delete.blogpost.changes.by.many'
        }
    },
    revert: {
        page: {
            one: 'editor.quit-dialog.revert.page.changes.by.one',
            many: 'editor.quit-dialog.revert.changes.by.many'
        },
        blogpost: {
            one: 'editor.quit-dialog.revert.blogpost.changes.by.one',
            many: 'editor.quit-dialog.revert.changes.by.many'
        }
    }
};
const $99497d85d924fd35$export$7fddb7b8aca8584f = {
    delete: {
        page: 'editor.quit-dialog.button.delete.page.exit',
        blogpost: 'editor.quit-dialog.button.delete.blog.exit'
    },
    revert: {
        page: 'editor.quit-dialog.button.revert.page.exit',
        blogpost: 'editor.quit-dialog.button.revert.blog.exit'
    }
};


const $0abb7f37a4bc0936$var$JustifyShim = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", props);
const $0abb7f37a4bc0936$var$wrapperSpinnerStyles = (0, $buxP3.xcss)({
    marginBlock: 'space.600',
    marginInline: 'auto',
    textAlign: 'center'
});
const $0abb7f37a4bc0936$var$WrapperSpinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
    xcss: $0abb7f37a4bc0936$var$wrapperSpinnerStyles
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null));
const $0abb7f37a4bc0936$var$RevertExperienceTracker = ({ children: children, analyticsAttributes: analyticsAttributes })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { current: expTrackerConfig } = (0, $cozmU.useRef)({
        name: (0, $irVI7.EDIT_PAGE_REVERT_DRAFT_EXPERIENCE),
        attributes: {
            ...analyticsAttributes,
            isCompanyHub: isCompanyHub
        }
    });
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.start(expTrackerConfig);
        return ()=>experienceTracker.abort({
                ...expTrackerConfig,
                reason: 'Modal closed'
            });
    }, [
        experienceTracker,
        expTrackerConfig
    ]);
    return children({
        experienceResolver: (prom)=>prom.then(()=>experienceTracker.succeed(expTrackerConfig)).catch((error)=>{
                experienceTracker.fail({
                    ...expTrackerConfig,
                    error: error
                });
                throw error;
            })
    });
};
const $0abb7f37a4bc0936$var$closeButtonStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.100'
});
const $0abb7f37a4bc0936$var$CloseButton = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        as: "span",
        xcss: $0abb7f37a4bc0936$var$closeButtonStyles
    }, children);
const $0abb7f37a4bc0936$var$iconDiffNotShownStyles = (0, $buxP3.xcss)({
    transform: 'rotate(0deg)',
    transition: '0.2s'
});
const $0abb7f37a4bc0936$var$iconDiffShownStyles = (0, $buxP3.xcss)({
    transform: 'rotate(90deg)',
    transition: '0.2s'
});
const $0abb7f37a4bc0936$var$DiffExpandIcon = ({ isDiffShown: isDiffShown, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: isDiffShown ? $0abb7f37a4bc0936$var$iconDiffShownStyles : $0abb7f37a4bc0936$var$iconDiffNotShownStyles
    }, children);
};
class $0abb7f37a4bc0936$var$EditorRevertDialogComponentClass extends (0, $cozmU.PureComponent) {
    render() {
        const { shouldShowRevertDialog: shouldShowRevertDialog, fetchingCollaboratorRelations: fetchingCollaboratorRelations, fetchingTouchedRelations: fetchingTouchedRelations, errorFetchingRelations: errorFetchingRelations, isUnpublishedDraft: isUnpublishedDraft } = this.props;
        if (!shouldShowRevertDialog) return null;
        if (errorFetchingRelations) {
            const errorData = {
                [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).REVERT_CONTENT_ERROR]: true,
                status: null
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $601vk.EditorErrorFlags), {
                errorData: errorData
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0abb7f37a4bc0936$var$RevertExperienceTracker, {
            analyticsAttributes: {
                isUnpublishedDraft: isUnpublishedDraft
            }
        }, ({ experienceResolver: experienceResolver })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "editor-revert-modal-dialog"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
                onClose: this._handleRevertDialogDismissed
            }, this._renderHeader(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, fetchingCollaboratorRelations || fetchingTouchedRelations ? $0abb7f37a4bc0936$var$WrapperSpinner : this._renderChildren()), this._renderFooter({
                experienceResolver: experienceResolver
            })()))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            submitting: false
        };
        this._handleRevertDialogDismissed = ()=>this.props.hideRevertDialog();
        this._handleRevertDialogSubmitted = ({ experienceResolver: experienceResolver })=>async ()=>{
                this.setState({
                    submitting: true
                });
                const { isUnpublishedDraft: isUnpublishedDraft, deleteContent: deleteContent, revertContent: revertContent, contentId: contentId, triggerAnalyticsEvent: triggerAnalyticsEvent } = this.props;
                try {
                    if (isUnpublishedDraft) {
                        triggerAnalyticsEvent('deleteContent');
                        await experienceResolver(deleteContent(contentId));
                    } else {
                        triggerAnalyticsEvent('revertContent');
                        await experienceResolver(revertContent({
                            variables: {
                                contentId: contentId
                            }
                        }));
                    }
                } catch (_err) {
                // TODO show a helpful error message
                }
            };
        this._renderHeader = ()=>{
            const { isUnpublishedDraft: isUnpublishedDraft, contentType: contentType, intl: intl } = this.props;
            const headerContent = isUnpublishedDraft ? contentType === (0, $l3Dp5.ContentTypeType).PAGE ? intl.formatMessage({
                id: "editor.quit-dialog.title.page.delete"
            }) : intl.formatMessage({
                id: "editor.quit-dialog.title.blogpost.delete"
            }) : intl.formatMessage({
                id: "editor.quit-dialog.title.discard"
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $db051ff45b440e81$export$54ae5c5dd05596de), null, headerContent);
        };
        this.renderWarningText = (contributorsList)=>{
            const { isUnpublishedDraft: isUnpublishedDraft, contentType: contentType } = this.props;
            const operationType = isUnpublishedDraft ? 'delete' : 'revert';
            const contributionType = contributorsList.length === 0 ? 'one' : 'many';
            const warningTextKey = (0, $99497d85d924fd35$export$dd897410adc66601)[operationType][contentType][contributionType];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: warningTextKey
            });
        };
        this._renderContributorsListSection = (contributorsList)=>{
            const { intl: intl } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $db051ff45b440e81$export$fbf92180ee7fa390), null, contributorsList.map((contributor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $db051ff45b440e81$export$52d11275ec7751f6), {
                    key: contributor?.source?.accountId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $db051ff45b440e81$export$5d6db156164366c9), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $db051ff45b440e81$export$62ca698686e2dcfb), {
                    src: contributor?.source?.profilePicture?.path,
                    alt: ""
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $db051ff45b440e81$export$e214e3696a2038d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $db051ff45b440e81$export$8017f73df02c60d6), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, contributor?.source?.displayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $db051ff45b440e81$export$b891b51eaabcd719), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, intl.formatMessage({
                    id: "editor.quit-dialog.last.edited"
                }), ' ', contributor?.relationData?.friendlyCreatedDate)))))));
        };
        this._calculateContributorsList = (collaboratorRelations, touchedRelations)=>{
            const { currentAccountId: currentAccountId } = this.props;
            const collaboratorAccountIds = collaboratorRelations.map((collaboratorRelation)=>collaboratorRelation?.source?.accountId);
            return touchedRelations.filter((touchedRelation)=>collaboratorAccountIds.indexOf(touchedRelation?.source?.accountId) > -1 && touchedRelation?.source?.accountId !== currentAccountId);
        };
        this._getDialogSubmitButtonText = ()=>{
            const { contentType: contentType, intl: intl } = this.props;
            const submitTextKeyMessage = {
                id: (0, $99497d85d924fd35$export$7fddb7b8aca8584f)[this.getCurrentOperationType()][contentType]
            };
            return intl.formatMessage(submitTextKeyMessage);
        };
        this.getCurrentOperationType = ()=>this.props.isUnpublishedDraft ? 'delete' : 'revert';
        this._renderShowDiffToggle = (isDiffShown)=>{
            const { hideRevertDialogDiff: hideRevertDialogDiff, showRevertDialogDiff: showRevertDialogDiff } = this.props;
            // If the diff is currently shown, the toggle action will HIDE the diff. The toggle action should also show the contributors,
            // though this functionality is currently broken (see CFE-3296).
            // If the diff is not currently shown, the toggle action will SHOW the diff.
            const toggleAction = isDiffShown ? hideRevertDialogDiff : showRevertDialogDiff;
            const toggleActionTextId = isDiffShown ? 'editor.quit-dialog.link.hide.diff' : 'editor.quit-dialog.link.show.diff';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $db051ff45b440e81$export$73e5e09f3ced9be5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                appearance: "link",
                onClick: toggleAction,
                "aria-expanded": isDiffShown,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0abb7f37a4bc0936$var$DiffExpandIcon, {
                    isDiffShown: isDiffShown
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    spacing: "spacious",
                    label: "Toggle diff",
                    size: "small"
                }))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: toggleActionTextId
            })));
        };
        this._renderChildren = ()=>{
            const { shouldShowRevertDialogDiff: shouldShowRevertDialogDiff, contentId: contentId, isUnpublishedDraft: isUnpublishedDraft, collaboratorRelations: collaboratorRelations, touchedRelations: touchedRelations } = this.props;
            const contributorsList = this._calculateContributorsList(collaboratorRelations, touchedRelations);
            const showDiffToggle = this._renderShowDiffToggle(shouldShowRevertDialogDiff);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, this.renderWarningText(contributorsList)), !isUnpublishedDraft && showDiffToggle, shouldShowRevertDialogDiff ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kj1gY.ChangesDiffLoader), {
                contentId: contentId
            }) : this._renderContributorsListSection(contributorsList));
        };
        this._renderFooter = ({ experienceResolver: experienceResolver })=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0abb7f37a4bc0936$var$JustifyShim, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    "data-testid": "submit-button"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                    isDisabled: this.state.submitting,
                    iconAfter: this.state.submitting ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null) : undefined,
                    onClick: this._handleRevertDialogSubmitted({
                        experienceResolver: experienceResolver
                    }),
                    appearance: "primary"
                }, this._getDialogSubmitButtonText())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0abb7f37a4bc0936$var$CloseButton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                    isDisabled: this.state.submitting,
                    onClick: this._handleRevertDialogDismissed,
                    appearance: "subtle"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    id: "close.name"
                })))));
    }
}
$0abb7f37a4bc0936$var$EditorRevertDialogComponentClass.defaultProps = {
    contentType: (0, $l3Dp5.ContentTypeType).PAGE // Setting default value to help with the type error since contentType can be potentially null
};
const $0abb7f37a4bc0936$export$d21522f1fb83d2e9 = (0, $kSwu1.injectIntl)($0abb7f37a4bc0936$var$EditorRevertDialogComponentClass);






var $7Sm4c = parcelRequire("7Sm4c");

// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $eZLpN = parcelRequire("eZLpN");


var $aBfpe = parcelRequire("aBfpe");

const $595d7fd58c9684b8$export$6857b025f902bf11 = ({ variables: variables, onCompleted: onCompleted, onError: onError })=>{
    const { relationName: relationName, sourceType: sourceType, targetKey: targetKey, targetStatus: targetStatus } = variables;
    if (!relationName) throw new Error('relationName is missing');
    if (!sourceType) throw new Error('sourceType is missing');
    if (!targetKey) throw new Error('targetKey is missing');
    if (!targetStatus) throw new Error('targetStatus is missing');
    const parseResult = (response)=>{
        const mapSource = (source)=>{
            if (!source) return null;
            return {
                displayName: source.displayName ?? null,
                accountId: source.accountId ?? null,
                profilePicture: source.profilePicture?.path ? {
                    path: source.profilePicture.path
                } : null
            };
        };
        const mapRelationData = (relationData)=>{
            if (!relationData) return null;
            return {
                friendlyCreatedDate: relationData.friendlyCreatedDate ?? null
            };
        };
        return {
            experimentalRelationsForContent: {
                results: response.results.map((result)=>({
                        source: mapSource(result.source),
                        relationData: mapRelationData(result.relationData)
                    }))
            }
        };
    };
    return (0, $eZLpN.useExperimentalLazyQuery)({
        url: `/wiki/rest/api/relation/${relationName}/to/content/${targetKey}/from/${sourceType}/?targetStatus=${targetStatus}&expand=source,relationData`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: parseResult,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: (error)=>{
            // Check if it's a BadStatusError with response status
            if ('response' in error && error.response?.status) {
                const status = error.response.status;
                if (status === 403) return new Error('User does not have permission to view the relationship');
                else if (status === 404) return new Error('Target entity does not exist');
            }
            return new Error('Unknown error');
        }
    });
};


const $f7ea8bf18291e5f2$var$isKnownError = (error)=>{
    return error.graphQLErrors.some((e)=>e.message === 'User does not have permission to view the relationship' || e.message === 'Target entity does not exist');
};
const $f7ea8bf18291e5f2$export$d68df4b88ddb860f = (relationName, contentId, isUnpublishedDraft)=>{
    const variables = {
        relationName: relationName,
        sourceType: 'user',
        targetKey: contentId,
        targetStatus: 'draft'
    };
    const [getRelations, { data: data, loading: loading, error: error }] = (0, $595d7fd58c9684b8$export$6857b025f902bf11)({
        variables: variables
    });
    (0, $cozmU.useEffect)(()=>{
        // If we're reverting rather than deleting
        if (!isUnpublishedDraft) getRelations();
    }, [
        isUnpublishedDraft,
        getRelations
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (error && $f7ea8bf18291e5f2$var$isKnownError(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    return {
        relations: data?.experimentalRelationsForContent?.results ?? [],
        loading: loading,
        error: error
    };
};



var $gKaeO = parcelRequire("gKaeO");

/**
 * @generated SignedSource<<35a0cc648d3d4ee100a82e20814c29d4>>
 * @relayHash e1ed6aba8da97659395a220f6423a14c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f5e36b4af1fa5ce40301d4c20435e04ebb8ca3ec6b43bd1ac7525444e822ddb
const $c666abe766d6d036$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "action",
                    "value": "DELETE_DRAFT"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "DeleteContentResponsePayload",
            "kind": "LinkedField",
            "name": "deleteContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "DeleteDraftMutationForRevertDialogMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "DeleteDraftMutationForRevertDialogMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e1ed6aba8da97659395a220f6423a14c",
            "id": "5f5e36b4af1fa5ce40301d4c20435e04ebb8ca3ec6b43bd1ac7525444e822ddb",
            "metadata": {},
            "name": "DeleteDraftMutationForRevertDialogMutation",
            "operationKind": "mutation",
            "text": "mutation DeleteDraftMutationForRevertDialogMutation($contentId:ID!){deleteContent(contentId:$contentId,action:DELETE_DRAFT){contentId}}"
        }
    };
}();
$c666abe766d6d036$var$node.hash = "dc1db2a944a11c9fd2ef0167c1bd4133";
var $c666abe766d6d036$export$2e2bcd8739ae039 = $c666abe766d6d036$var$node;


const $359a22a23ec3fd20$export$8d89725053a04255 = {
    'meeting-notes': true,
    decisions: true,
    'kb-how-to-article': true,
    'file-list': true,
    retrospective: true,
    requirements: true,
    'shared-links': true,
    'kb-troubleshooting-article': true,
    'task-report': true,
    jirareport: true
};


const $92e9616f723b6e02$export$5263310017cc26c7 = (content)=>{
    const labels = content?.metadata?.labels ?? [];
    const blueprintLabel = labels.find((item)=>{
        if (item?.name) return (0, $359a22a23ec3fd20$export$8d89725053a04255)[item.name];
    });
    return blueprintLabel?.name ?? '';
};






var $b4EKK = parcelRequire("b4EKK");


var $9o40q = parcelRequire("9o40q");


var $hBkCm = parcelRequire("hBkCm");

const $b274159c92aeba75$export$b9d88f4afc1c4fa7 = ({ onCompleted: onCompleted } = {})=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: (variables)=>{
            if (!variables.contentId) throw new Error('contentId is missing');
            return `/wiki/rest/collab/1.0/content/${variables?.contentId}/changes/unpublished`;
        },
        method: 'DELETE',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: ()=>({
                experimentalRevertContent: true
            }),
        onCompleted: onCompleted,
        transformError: (error)=>{
            if (error instanceof (0, $hBkCm.BadStatusError)) return (0, $b4EKK.getErrorWithResponse)(new Error(`Failed to revert or delete draft: ${error}`), error?.response);
            return error;
        }
    });
};



var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");

const $5f783a6f76a26815$var$EditorRevertDialogContentQuery = (0, $b53542f437d43025$export$2e2bcd8739ae039);
const $5f783a6f76a26815$export$12786e122b13d0cd = (props)=>{
    const { contentId: contentId, isUnpublishedDraft: isUnpublishedDraft } = props;
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($5f783a6f76a26815$var$EditorRevertDialogContentQuery, {
        variables: {
            contentId: contentId,
            status: [
                isUnpublishedDraft ? 'draft' : 'current'
            ]
        },
        __callerPackage__: "editor-revert-dialog"
    });
    if (loading || error) return null;
    const content = (data?.content?.nodes ?? [])[0] ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5f783a6f76a26815$var$EditorRevertDialogContainer, {
        ...props,
        content: content
    });
};
const $5f783a6f76a26815$var$EditorRevertDialogContainer = (props)=>{
    const { relations: collaborators, loading: fetchingCollaboratorRelations, error: errorFetchingCollaborators } = (0, $f7ea8bf18291e5f2$export$d68df4b88ddb860f)('collaborator', props.contentId, props.isUnpublishedDraft);
    const { relations: touched, loading: fetchingTouchedRelations, error: errorFetchingTouched } = (0, $f7ea8bf18291e5f2$export$d68df4b88ddb860f)('touched', props.contentId, props.isUnpublishedDraft);
    const analyticsData = {
        blueprintType: (0, $92e9616f723b6e02$export$5263310017cc26c7)(props.content),
        contentId: props.contentId,
        contentType: props.content?.type ?? '',
        spaceKey: props.spaceKey,
        version: props.content?.version?.number ?? undefined,
        source: 'next-EditorRevertDialogComponent',
        subject: 'revertOrDeleteDialog'
    };
    const { triggerAnalyticsEvent: triggerAnalyticsEvent } = (0, $e9owJ.useEditorAnalyticsEvent)(analyticsData);
    const { forceRefetchBlogTree: forceRefetchBlogTree } = (0, $jacyh.useBlogTreeActions)();
    const { matchSupportedRoute: matchSupportedRoute, push: push, replace: replace, match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const shouldPushInSelf = (path)=>{
        return !routePolicy || routePolicy.willPushInSelf(match?.name, match?.params.contentId, path, undefined);
    };
    const { shouldShowRevertDialog: shouldShowRevertDialog, shouldShowRevertDialogDiff: shouldShowRevertDialogDiff, hideRevertDialogDiff: hideRevertDialogDiff, showRevertDialogDiff: showRevertDialogDiff, hideRevertDialog: hideRevertDialog } = (0, $gKaeO.useEditorRevertDialogContext)();
    const mutationVars = {
        contentId: props.contentId
    };
    const onCompleted = (data)=>{
        if (data.experimentalRevertContent) {
            hideRevertDialog();
            const viewPagePath = (props.content?.links?.context ?? '') + (props.content?.links?.webui ?? '');
            props.cancelDebouncedSaveDraft?.();
            if (shouldPushInSelf(matchSupportedRoute(viewPagePath))) {
                if (viewPagePath !== '') push(viewPagePath);
            }
        }
    };
    const [revertContent] = (0, $b274159c92aeba75$export$b9d88f4afc1c4fa7)({
        onCompleted: onCompleted
    });
    const [deleteContent] = (0, $308Wd.useMutationInterop)((0, $c666abe766d6d036$export$2e2bcd8739ae039), {
        variables: mutationVars,
        onCompleted: (data)=>{
            if (data.deleteContent.contentId) {
                const route = getAncestorRoute(props.spaceKey);
                hideRevertDialog();
                props.cancelDebouncedSaveDraft?.();
                if (shouldPushInSelf(route)) replace(route);
                if (props.content?.type === (0, $l3Dp5.ContentTypeType).BLOGPOST) // update blog tree after unpublished blog draft is deleted
                forceRefetchBlogTree();
            }
        },
        __callerPackage__: "editor-revert-dialog"
    });
    const errorFetchingRelations = errorFetchingCollaborators !== undefined || errorFetchingTouched !== undefined;
    const breadcrumbs = (0, $8G1o2.useEditorBreadcrumbs)(props.contentId);
    const getAncestorRoute = (spaceKey)=>{
        // Gets the nearest ancestor in breadcrumbs. Use space index as fallback route in case of error or if page is a blog
        let url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        });
        if (props.content?.type === (0, $l3Dp5.ContentTypeType).PAGE && breadcrumbs) url = (0, $dqLea.getNearestVisibleAncestor)({
            breadcrumbs: breadcrumbs,
            fallbackUrl: url
        });
        return url;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ge2sX.SessionData), null, (sessionData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0abb7f37a4bc0936$export$d21522f1fb83d2e9), {
            content: props.content,
            contentId: props.contentId,
            isUnpublishedDraft: props.isUnpublishedDraft,
            triggerAnalyticsEvent: triggerAnalyticsEvent,
            collaboratorRelations: collaborators,
            touchedRelations: touched,
            fetchingCollaboratorRelations: fetchingCollaboratorRelations,
            fetchingTouchedRelations: fetchingTouchedRelations,
            shouldShowRevertDialog: shouldShowRevertDialog,
            shouldShowRevertDialogDiff: shouldShowRevertDialogDiff,
            hideRevertDialogDiff: hideRevertDialogDiff,
            showRevertDialogDiff: showRevertDialogDiff,
            hideRevertDialog: hideRevertDialog,
            errorFetchingRelations: errorFetchingRelations,
            revertContent: revertContent,
            deleteContent: deleteContent,
            currentAccountId: sessionData.userId,
            contentType: props.content?.type
        }));
};
module.exports["EditorRevertDialog"] = $5f783a6f76a26815$export$12786e122b13d0cd;

});

parcelRegister("kVuKK", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $da4fb2730df63d94$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    editorEnabled: {
        id: "browser-status-indicator.user.offline.editor.enabled",
        defaultMessage: "We\u2019ve lost our connection to you. Your changes will be saved when we reconnect. Trying to reconnect"
    },
    editorEnabledOfflineMode: {
        id: "browser-status-indicator.user.offline.editor.offline-mode.enabled",
        defaultMessage: "You\u2019re back online. You can now use all editing features."
    },
    editorDisabled: {
        id: "browser-status-indicator.user.offline.editor.disabled",
        defaultMessage: "We\u2019ve lost our connection to you, so we\u2019ve disabled editing to prevent any issues. You\u2019ll be able to edit once we reconnect. Trying to reconnect"
    },
    editorDisabledOfflineMode: {
        id: "browser-status-indicator.user.offline.editor.offline-mode.disabled",
        defaultMessage: "Looks like you\u2019re offline. Any changes you make will be automatically saved. Some features will be unavailable."
    },
    backOnline: {
        id: "browser-status-indicator.back.online",
        defaultMessage: "Editing restored"
    },
    editorDisabledDueToPermissionChange: {
        id: "browser-status-indicator.permission.change.offline",
        defaultMessage: "The access update you made is taking longer than expected to save, so we\u2019ve disabled editing to prevent any issues. You\u2019ll be able to edit once the changes finish saving. Saving"
    },
    collabEditConnectionTimeout: {
        id: "browser-status-indicator.collab.edit.timeout",
        defaultMessage: "We\u2019ve lost our connection to you, so editing is paused to prevent any issues. You can edit again once we reconnect, but you may want to copy and save this work now. Trying to reconnect"
    },
    // TODO: Remove when platform_editor_offline_editing_web_ga_fixes is cleaned up - replaced by editorSyncFailedDueToConflictsUpdated
    editorSyncFailedDueToConflicts: {
        id: "browser-status-indicator.collab.edit.conflicts",
        defaultMessage: "{conflictIcon} We found <conflictLink>{conflictCount, plural, =1 {# conflict} other {# conflicts}}</conflictLink> while syncing your offline edits. Review them below or <saveCopy>save a copy</saveCopy> of your offline edits."
    },
    editorSyncFailedDueToConflictsUpdated: {
        id: "browser-status-indicator.collab.edit.conflicts",
        defaultMessage: "{conflictIcon} We found {conflictCount, plural, one {# conflict} other {# conflicts}} while syncing your offline edits. <conflictLink>Review conflicts</conflictLink>"
    },
    resyncingEditorDisabled: {
        id: "browser-status-indicator.user.offline.editor.resyncing-editor-disabled",
        defaultMessage: "Your offline edits are currently being synced in another tab. You\u2019ll be able to edit once your offline edits finish syncing."
    }
});
module.exports["i18n"] = $da4fb2730df63d94$export$a7357cdd1f0b0168;

});

parcelRegister("e6u60", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $dpqzw = parcelRequire("dpqzw");


var $6mKj3 = parcelRequire("6mKj3");

const $cb9ccc7e1f68f6bb$export$22499ff95fdadf06 = (contentId)=>{
    if ((0, $6mKj3.expVal)('platform_editor_reduce_forced_layout', 'isEnabled', false)) {
        $cb9ccc7e1f68f6bb$var$cleanUpLocalStorageScrolls(); // Still clean up local storage to avoid stale data in future edits
        return;
    }
    // grab the element object from local storage
    const { elementObject: elementObject } = $cb9ccc7e1f68f6bb$var$getScrollParams();
    // cleanup local storage once we have the object
    $cb9ccc7e1f68f6bb$var$cleanUpLocalStorageScrolls();
    // return if elementObject doesn't exist or have index and contentId properties
    if (!elementObject?.index || !elementObject?.contentId) return;
    // return if the index is -1 or stored contentId doesn't match current contentId
    if (elementObject?.index < 0 || elementObject?.contentId !== contentId) return;
    // grab the editor parent element
    const scrollParentElement = Array.from(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementsByClassName((0, $dpqzw.EDITOR_PARENT_CLASS)))[0];
    // return if editor parent doesn't exist
    if (!scrollParentElement) return;
    // set scroll behavior to auto, which will make it "jump" instead of scroll
    scrollParentElement.style.scrollBehavior = 'auto';
    // grab all of the direct children elements from the editor parent
    const elements = Array.from(scrollParentElement.querySelectorAll((0, $dpqzw.EDITOR_CHILDREN_SELECTOR)));
    if (elements.length > 0) {
        const idealElement = elements[elementObject.index];
        if (idealElement) {
            // minor offset for visual whitespace
            const addtlOffset = 10;
            scrollParentElement.scrollTo({
                top: idealElement.offsetTop - addtlOffset
            });
            $cb9ccc7e1f68f6bb$var$placeCursor(idealElement);
        }
    }
    // cleanup scrollBehavior
    scrollParentElement.style.scrollBehavior = '';
};
const $cb9ccc7e1f68f6bb$var$placeCursor = (idealElement)=>{
    // we need to use range to place the cursor inside a contenteditable element
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (document.createRange) {
        // check to see if the direct child of the selected element is a text node, and return if not
        if (!(idealElement?.childNodes[0]?.nodeType === Node.TEXT_NODE)) return;
        // sets the range to contain the contents of the idealElement node, collapse indicating it should be at the end of the text node
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const range = document.createRange();
        range.selectNodeContents(idealElement);
        range.collapse(false);
        // clear existing ranges and add the newly created range
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
};
const $cb9ccc7e1f68f6bb$var$getScrollParams = ()=>{
    return {
        elementObject: (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LOCAL_STORAGE_CONTENT_VIEW_CLOSEST_ELEMENT_SCROLL_POSITION)
    };
};
const $cb9ccc7e1f68f6bb$var$cleanUpLocalStorageScrolls = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).LOCAL_STORAGE_CONTENT_VIEW_CLOSEST_ELEMENT_SCROLL_POSITION);
};
module.exports["scrollToLastViewedPosition"] = $cb9ccc7e1f68f6bb$export$22499ff95fdadf06;

});

parcelRegister("1Vx7O", function(module, exports) {
const $3b89d048e09c7153$export$d9eb6707f6a1e3a = ({ title: title, isPublishingContent: isPublishingContent, userOffline: userOffline = false, forceDisabled: forceDisabled = false })=>{
    if (userOffline || forceDisabled) // no tooltip for publish button when disabled due to internet lost, banner will be shown indicating lost connection
    // no tooltip for publish button when editor is force disabled, this happens when page is converted to blog or converted between live and non live page
    return '';
    else if (!title) return 'editor.buttons.disable.by.empty.title.tooltip';
    else if (isPublishingContent) return 'editor.buttons.disable.by.saving.tooltip';
    return '';
};
module.exports["getPublishButtonDisabledReason"] = $3b89d048e09c7153$export$d9eb6707f6a1e3a;

});

parcelRegister("99ISI", function(module, exports) {
const $382552a311f1e790$export$fa234c370103664 = ({ collabEditInitialized: collabEditInitialized, contentType: contentType, isEditorEmpty: isEditorEmpty, viewMode: viewMode })=>{
    return contentType === 'page' && !viewMode && collabEditInitialized && isEditorEmpty;
};
module.exports["useShouldShowBlankPageQuickActions"] = $382552a311f1e790$export$fa234c370103664;

});

parcelRegister("j7VB5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");

const $627462f2f55d41c2$export$2af2a55f40c03fbe = ({ contentId: contentId, editorPresetAPI: editorPresetAPI, setReadPageContent: setReadPageContent })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('maui_remixable_page_native_embeds')) return;
        return setReadPageContent?.({
            contentId: contentId,
            source: 'editor',
            getPageAdf: async ()=>{
                const pageAdf = await editorPresetAPI?.core?.actions.requestDocumentAsync();
                return pageAdf ? JSON.stringify(pageAdf) : '';
            }
        });
    }, [
        contentId,
        editorPresetAPI,
        setReadPageContent
    ]);
};
module.exports["useRegisterEditorReadPageContent"] = $627462f2f55d41c2$export$2af2a55f40c03fbe;

});

parcelRegister("9ovft", function(module, exports) {

var $cozmU = parcelRequire("cozmU");





var $7S9uM = parcelRequire("7S9uM");


var $gRrX4 = parcelRequire("gRrX4");


var $gfqXk = parcelRequire("gfqXk");


var $kDIns = parcelRequire("kDIns");


var $aHcFH = parcelRequire("aHcFH");


var $hfNnW = parcelRequire("hfNnW");


var $8i27m = parcelRequire("8i27m");


var $kgNLQ = parcelRequire("kgNLQ");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $6UYek = parcelRequire("6UYek");


var $fHAwL = parcelRequire("fHAwL");


var $lb2Lp = parcelRequire("lb2Lp");


var $4L9ve = parcelRequire("4L9ve");


var $NYiei = parcelRequire("NYiei");


var $aSsfA = parcelRequire("aSsfA");


var $3BPrE = parcelRequire("3BPrE");


var $b11gn = parcelRequire("b11gn");

const $c13ad953d7aa53c9$var$getAuthorAccountId = (comment)=>comment.author && 'accountId' in comment.author ? comment.author.accountId ?? undefined : undefined;
const $c13ad953d7aa53c9$var$isThreadOpen = (comment)=>!!comment && !(0, $kgNLQ.isCommentResolved)(comment);
const $c13ad953d7aa53c9$export$7d464c122ca911c0 = ({ contentId: contentId, contentType: contentType, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache })=>{
    const pubSubResourceType = contentType || 'page';
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const subscriptions = (0, $cozmU.useRef)([]);
    const [{ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList }, { updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment }] = (0, $8i27m.useCommentsData)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const orderedActiveAnnotationIdListRef = (0, $cozmU.useRef)(orderedActiveAnnotationIdList);
    const { setContentId: setContentId, setContentType: setContentType, addSubscriber: addSubscriber, removeSubscriber: removeSubscriber } = (0, $6UYek.useSubscriptionsDispatchContext)() || {};
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    (0, $cozmU.useEffect)(()=>{
        orderedActiveAnnotationIdListRef.current = orderedActiveAnnotationIdList;
    }, [
        orderedActiveAnnotationIdList
    ]);
    const resyncAnnotationState = (0, $cozmU.useCallback)((markerRefs)=>{
        const annotationIds = orderedActiveAnnotationIdListRef.current.map((annotation)=>annotation.threadKey);
        if (triggerAnalyticsEvent) // Updates ordered list of unresolved inline comments based on ADF to account for real-time changes (collaborative editing)
        (0, $kDIns.getEditorResolvedState)({
            // the annotations won't already include the pubsub marker refs
            annotations: (0, $aHcFH.getSortedMarkerRefs)([
                ...annotationIds,
                ...markerRefs
            ], 'edit'),
            pageId: contentId,
            triggerAnalyticsEvent: triggerAnalyticsEvent,
            updateUnresolvedInlineComment: updateUnresolvedInlineComment
        });
    }, [
        contentId,
        triggerAnalyticsEvent,
        updateUnresolvedInlineComment
    ]);
    const handleOnPublicationEvent = (0, $cozmU.useCallback)((event, markerRef)=>{
        (0, $gfqXk.getEditorAnnotationEventEmitter)().emit(event, markerRef);
        resyncAnnotationState([
            markerRef
        ]);
    }, [
        resyncAnnotationState
    ]);
    const onPublicationEvent = (0, $cozmU.useCallback)(async (event_0, payload)=>{
        if (!event_0) return;
        let inlineCommentRequestBody;
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) inlineCommentRequestBody = payload?.[event_0];
        else inlineCommentRequestBody = payload.inlineCommentRequestBody;
        const { accountId: accountId, originTabId: originTabId } = payload || {};
        const { markerRef: markerRef_0, commentId: commentId, inlineCommentType: inlineCommentType } = inlineCommentRequestBody || {};
        const isReply = inlineCommentType === 'REPLY';
        if ((0, $hfNnW.shouldSkipOwnPubSubEvent)({
            accountId: accountId,
            currentUserId: currentUserId,
            originTabId: originTabId,
            isReply: isReply,
            isOwnReplyPubSubProcessingEnabled: (0, $6mKj3.expVal)('cc_comments_pubsub_process_own_replies', 'isEnabled', false)
        })) return;
        const { start: startCommentsPubSubExperience, fail: failCommentsPubSubExperience, handleCompletePubSubExperiences: handleCompletePubSubExperiences } = (0, $b11gn.createCommentsPubSubExperienceTracker)((0, $b11gn.CommentsPubSubSource).EditorInlineCommentsPubSub, commentId);
        startCommentsPubSubExperience(event_0);
        try {
            // These promises were previously dispatched as fire-and-forget (`void`).
            // Arguably they should be awaited, but until they are, we collect them here and hand
            // them to handleCompletePubSubExperiences() at the end, which awaits them all,
            // validates each refetched comment, and makes the single terminal call for this event.
            const trackedEvents = [];
            switch(event_0){
                case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentUnresolved:
                case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentUnresolved:
                    if (commentId) {
                        // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                        const comment_0 = await (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        });
                        trackedEvents.push({
                            comment: comment_0,
                            type: (0, $b11gn.CommentsPubsubTrackedEventType).Reopen
                        });
                    }
                    // Remove from commentThreadsRemovedByOtherUsers when reopened
                    if (markerRef_0 && reopenParentComment) reopenParentComment({
                        threadKey: markerRef_0,
                        commentType: (0, $kgNLQ.CommentType).INLINE,
                        parentCommentId: commentId
                    });
                    // Call handleOnPublicationEvent after store updates are complete
                    handleOnPublicationEvent('unresolve', markerRef_0);
                    break;
                case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentResolved:
                case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentResolved:
                    handleOnPublicationEvent('resolve', markerRef_0);
                    if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                    trackedEvents.push({
                        comment: (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        }),
                        type: (0, $b11gn.CommentsPubsubTrackedEventType).Resolve
                    });
                    const { inlineResolveProperties: inlineResolveProperties, inlineText: inlineText } = inlineCommentRequestBody;
                    if (inlineResolveProperties && inlineText) updateRemovedCommentIdsMap({
                        threadKey: markerRef_0,
                        commentId: commentId,
                        commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
                        isReply: isReply,
                        commentType: (0, $kgNLQ.CommentType).INLINE
                    });
                    const { replies: replies = [] } = inlineCommentRequestBody;
                    if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                        commentId,
                        ...replies
                    ]), 'remove');
                    break;
                case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentCreated:
                case (0, $3BPrE.InlineCommentSubscriptionEvents).EditorInlineCommentCreated:
                case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentCreated:
                case (0, $3BPrE.InlineCommentPubSubEvents).EditorInlineCommentCreated:
                    if (addCommentInCache && commentId) {
                        const comment = await (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        });
                        if (comment) addCommentInCache({
                            newComment: comment,
                            onError: failCommentsPubSubExperience
                        });
                    }
                    if (updateUnreadCommentIDSet && accountId !== currentUserId) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'add');
                    // Call handleOnPublicationEvent after store updates are complete
                    handleOnPublicationEvent('create', markerRef_0);
                    break;
                case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentDeleted:
                case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentDeleted:
                    // both a parent comment and reply can be deleted
                    updateRemovedCommentIdsMap({
                        threadKey: markerRef_0,
                        commentId: commentId,
                        isReply: isReply,
                        commentActionType: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                        commentType: (0, $kgNLQ.CommentType).INLINE
                    });
                    if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'remove');
                    if (deleteCommentInCache && commentId) deleteCommentInCache({
                        commentId: commentId,
                        onError: failCommentsPubSubExperience
                    });
                    if (!isReply) handleOnPublicationEvent('delete', markerRef_0);
                    break;
                case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentUpdated:
                case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentUpdated:
                    if (commentId) {
                        const previousVersionNumber = (0, $b11gn.getCachedCommentVersionNumber)(commentId);
                        // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                        trackedEvents.push({
                            comment: (0, $lb2Lp.fetchCommentById)({
                                commentId: commentId,
                                contentId: contentId,
                                fetchPolicy: 'network-only'
                            }),
                            type: (0, $b11gn.CommentsPubsubTrackedEventType).Edit,
                            previousVersionNumber: previousVersionNumber
                        });
                    }
                    break;
                default:
                    failCommentsPubSubExperience(new Error(`Unhandled comments pubsub event: ${event_0}`));
                    break;
            }
            await handleCompletePubSubExperiences(trackedEvents);
        } catch (error) {
            failCommentsPubSubExperience(error);
            throw error;
        }
    }, [
        contentId,
        handleOnPublicationEvent,
        updateRemovedCommentIdsMap,
        currentUserId,
        updateUnreadCommentIDSet,
        addCommentInCache,
        deleteCommentInCache,
        reopenParentComment
    ]);
    const register = (0, $cozmU.useCallback)(()=>{
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
            if (!setContentType || !setContentId || !addSubscriber) return;
            setContentType(pubSubResourceType);
            setContentId(contentId);
            const subscribers = [
                {
                    subscriberId: 'useEditorInlineCommentsPubSubInlineCommentResolved',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'inlineCommentResolved'
                },
                {
                    subscriberId: 'useEditorInlineCommentsPubSubInlineCommentUnresolved',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'inlineCommentUnresolved'
                },
                {
                    subscriberId: 'useEditorInlineCommentsPubSubInlineCommentCreated',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'inlineCommentCreated'
                },
                {
                    subscriberId: 'useEditorInlineCommentsPubSubInlineCommentUpdated',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'inlineCommentUpdated'
                },
                {
                    subscriberId: 'useEditorInlineCommentsPubSubEditorInlineCommentCreated',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'editorInlineCommentCreated'
                }
            ];
            for (const subscriber of subscribers)subscriptions.current.push({
                subscriberId: addSubscriber(subscriber),
                delta: subscriber.delta
            });
            subscriptions.current.push({
                delta: 'inlineCommentDeleted',
                subscriberId: addSubscriber({
                    subscriberId: 'useEditorInlineCommentsPubSubInlineCommentDeleted',
                    onSubscriptionData: onPublicationEvent,
                    delta: 'inlineCommentDeleted'
                })
            });
        } else (0, $gRrX4.getPubSubClient)().then((client)=>{
            client.joinChannel(pubSubResourceType, contentId).finally(()=>{
                client.subscribe((0, $7S9uM.eventToAvi)('resolved:inline_comment'), onPublicationEvent);
                client.subscribe((0, $7S9uM.eventToAvi)('unresolved:inline_comment'), onPublicationEvent);
                client.subscribe((0, $7S9uM.eventToAvi)('created:inline_comment'), onPublicationEvent);
                client.subscribe((0, $7S9uM.eventToAvi)('created:editor_inline_comment'), onPublicationEvent);
                client.subscribe((0, $7S9uM.eventToAvi)('updated:inline_comment'), onPublicationEvent);
                client.subscribe((0, $7S9uM.eventToAvi)('deleted:inline_comment'), onPublicationEvent);
            }).catch((error_0)=>{
                throw new Error(`PubSub Web Client joinChannel ${JSON.stringify(error_0)}`);
            });
        });
    }, [
        setContentType,
        pubSubResourceType,
        setContentId,
        contentId,
        onPublicationEvent,
        subscriptions,
        addSubscriber
    ]);
    const unregister = (0, $cozmU.useCallback)(()=>{
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) for (const subscriber_0 of subscriptions.current)removeSubscriber?.(subscriber_0);
        else (0, $gRrX4.getPubSubClient)().then((client_0)=>{
            client_0.leaveChannel(pubSubResourceType, contentId);
            client_0.unsubscribe((0, $7S9uM.eventToAvi)('resolved:inline_comment'), onPublicationEvent);
            client_0.unsubscribe((0, $7S9uM.eventToAvi)('unresolved:inline_comment'), onPublicationEvent);
            client_0.unsubscribe((0, $7S9uM.eventToAvi)('created:inline_comment'), onPublicationEvent);
            client_0.unsubscribe((0, $7S9uM.eventToAvi)('created:editor_inline_comment'), onPublicationEvent);
            client_0.unsubscribe((0, $7S9uM.eventToAvi)('updated:inline_comment'), onPublicationEvent);
            client_0.unsubscribe((0, $7S9uM.eventToAvi)('deleted:inline_comment'), onPublicationEvent);
        });
    }, [
        contentId,
        onPublicationEvent,
        pubSubResourceType,
        removeSubscriber,
        subscriptions
    ]);
    const reloadMissedComments = (0, $cozmU.useCallback)(async ()=>{
        const beforeData = (0, $NYiei.getCommentsDataFromCache)(contentId);
        await (0, $4L9ve.getProcessedCommentsDataState)().refetch?.();
        const afterData = (0, $NYiei.getCommentsDataFromCache)(contentId);
        const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
        const categorize = (data)=>(0, $kgNLQ.categorizeComments)((data?.comments?.nodes ?? []).filter((comment_1)=>!!comment_1), contentStatusFilters);
        const after = categorize(afterData);
        if (!beforeData) {
            resyncAnnotationState(Object.keys(after.flatMarkerRefMap));
            return;
        }
        const before = categorize(beforeData);
        const knownCommentIds = new Set(Object.keys(before.flatCommentsMap));
        const unreadCommentIds = Object.keys(after.flatCommentsMap).filter((commentId_0)=>!knownCommentIds.has(commentId_0) && $c13ad953d7aa53c9$var$getAuthorAccountId(after.flatCommentsMap[commentId_0]) !== currentUserId);
        if (updateUnreadCommentIDSet && unreadCommentIds.length) updateUnreadCommentIDSet(new Set(unreadCommentIds), 'add');
        const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
        const changedMarkerRefs = [];
        for (const markerRef_1 of new Set([
            ...Object.keys(before.flatMarkerRefMap),
            ...Object.keys(after.flatMarkerRefMap)
        ])){
            const isOpen = $c13ad953d7aa53c9$var$isThreadOpen(after.flatMarkerRefMap[markerRef_1]);
            if (isOpen === $c13ad953d7aa53c9$var$isThreadOpen(before.flatMarkerRefMap[markerRef_1])) continue;
            emitter.emit(isOpen ? 'unresolve' : 'resolve', markerRef_1);
            changedMarkerRefs.push(markerRef_1);
        }
        if (changedMarkerRefs.length) resyncAnnotationState(changedMarkerRefs);
    }, [
        contentId,
        pageMode,
        currentUserId,
        updateUnreadCommentIDSet,
        resyncAnnotationState
    ]);
    return (0, $cozmU.useMemo)(()=>({
            register: register,
            unregister: unregister,
            onPublicationEvent: onPublicationEvent,
            reloadMissedComments: reloadMissedComments
        }), [
        register,
        unregister,
        onPublicationEvent,
        reloadMissedComments
    ]);
};


const $b50d68d67cedaa55$export$7d464c122ca911c0 = ({ contentId: contentId, contentType: contentType, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment, isEnabled: isEnabled = true, isDocumentActive: isDocumentActive, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache })=>{
    const isRegistered = (0, $cozmU.useRef)(false);
    const { register: register, unregister: unregister, reloadMissedComments: reloadMissedComments } = (0, $c13ad953d7aa53c9$export$7d464c122ca911c0)({
        contentId: contentId,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        updateUnresolvedInlineComment: updateUnresolvedInlineComment,
        contentType: contentType,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache
    });
    (0, $cozmU.useEffect)(()=>{
        if (isEnabled && !isRegistered.current) {
            register();
            isRegistered.current = true;
            return ()=>{
                unregister();
                isRegistered.current = false;
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isEnabled,
        register,
        unregister,
        isDocumentActive
    ]);
    return {
        reloadMissedComments: reloadMissedComments
    };
};
module.exports["useEditorInlineCommentsPubSub"] = $b50d68d67cedaa55$export$7d464c122ca911c0;

});


//# sourceMappingURL=FullPageEditorComponent.5059941a.js.map
